import { __assign, __awaiter, __generator } from "tslib";
import { HttpRequest as __HttpRequest } from "@aws-sdk/protocol-http";
import { dateToUtcString as __dateToUtcString, extendedEncodeURIComponent as __extendedEncodeURIComponent, getArrayIfSingleItem as __getArrayIfSingleItem, getValueFromTextNode as __getValueFromTextNode } from "@aws-sdk/smithy-client";
import { XmlNode as __XmlNode, XmlText as __XmlText } from "@aws-sdk/xml-builder";
import { parse as xmlParse } from "fast-xml-parser";
export var serializeAws_restXmlAbortMultipartUploadCommand = function serializeAws_restXmlAbortMultipartUploadCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign(__assign({
            "Content-Type": ""
          }, isSerializableHeaderValue(input.RequestPayer) && {
            "x-amz-request-payer": input.RequestPayer
          }), isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          });
          resolvedPath = "/{Bucket}/{Key+}";

          if (input.Key !== undefined) {
            labelValue = input.Key;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Key.");
            }

            resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function (segment) {
              return __extendedEncodeURIComponent(segment);
            }).join("/"));
          } else {
            throw new Error("No value provided for input HTTP label: Key.");
          }

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          query = __assign({
            "x-id": "AbortMultipartUpload"
          }, input.UploadId !== undefined && {
            uploadId: input.UploadId
          });
          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "DELETE",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlCompleteMultipartUploadCommand = function serializeAws_restXmlCompleteMultipartUploadCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, labelValue, query, body, contents, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign(__assign({
            "Content-Type": "application/xml"
          }, isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          }), isSerializableHeaderValue(input.RequestPayer) && {
            "x-amz-request-payer": input.RequestPayer
          });
          resolvedPath = "/{Bucket}/{Key+}";

          if (input.Key !== undefined) {
            labelValue = input.Key;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Key.");
            }

            resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function (segment) {
              return __extendedEncodeURIComponent(segment);
            }).join("/"));
          } else {
            throw new Error("No value provided for input HTTP label: Key.");
          }

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          query = __assign({}, input.UploadId !== undefined && {
            uploadId: input.UploadId
          });

          if (input.MultipartUpload !== undefined) {
            contents = serializeAws_restXmlCompletedMultipartUpload(input.MultipartUpload, context);
            body = '<?xml version="1.0" encoding="UTF-8"?>';
            contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
            body += contents.toString();
          }

          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "POST",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlCopyObjectCommand = function serializeAws_restXmlCopyObjectCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({
            "Content-Type": ""
          }, isSerializableHeaderValue(input.Tagging) && {
            "x-amz-tagging": input.Tagging
          }), isSerializableHeaderValue(input.SSEKMSEncryptionContext) && {
            "x-amz-server-side-encryption-context": input.SSEKMSEncryptionContext
          }), isSerializableHeaderValue(input.ACL) && {
            "x-amz-acl": input.ACL
          }), isSerializableHeaderValue(input.Expires) && {
            Expires: __dateToUtcString(input.Expires).toString()
          }), isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          }), isSerializableHeaderValue(input.CopySourceIfModifiedSince) && {
            "x-amz-copy-source-if-modified-since": __dateToUtcString(input.CopySourceIfModifiedSince).toString()
          }), isSerializableHeaderValue(input.ContentDisposition) && {
            "Content-Disposition": input.ContentDisposition
          }), isSerializableHeaderValue(input.SSECustomerKey) && {
            "x-amz-server-side-encryption-customer-key": input.SSECustomerKey
          }), isSerializableHeaderValue(input.WebsiteRedirectLocation) && {
            "x-amz-website-redirect-location": input.WebsiteRedirectLocation
          }), isSerializableHeaderValue(input.ObjectLockRetainUntilDate) && {
            "x-amz-object-lock-retain-until-date": (input.ObjectLockRetainUntilDate.toISOString().split(".")[0] + "Z").toString()
          }), isSerializableHeaderValue(input.ContentLanguage) && {
            "Content-Language": input.ContentLanguage
          }), isSerializableHeaderValue(input.GrantRead) && {
            "x-amz-grant-read": input.GrantRead
          }), isSerializableHeaderValue(input.ObjectLockLegalHoldStatus) && {
            "x-amz-object-lock-legal-hold": input.ObjectLockLegalHoldStatus
          }), isSerializableHeaderValue(input.GrantWriteACP) && {
            "x-amz-grant-write-acp": input.GrantWriteACP
          }), isSerializableHeaderValue(input.CopySource) && {
            "x-amz-copy-source": input.CopySource
          }), isSerializableHeaderValue(input.CopySourceSSECustomerAlgorithm) && {
            "x-amz-copy-source-server-side-encryption-customer-algorithm": input.CopySourceSSECustomerAlgorithm
          }), isSerializableHeaderValue(input.CopySourceSSECustomerKey) && {
            "x-amz-copy-source-server-side-encryption-customer-key": input.CopySourceSSECustomerKey
          }), isSerializableHeaderValue(input.CopySourceSSECustomerKeyMD5) && {
            "x-amz-copy-source-server-side-encryption-customer-key-MD5": input.CopySourceSSECustomerKeyMD5
          }), isSerializableHeaderValue(input.CacheControl) && {
            "Cache-Control": input.CacheControl
          }), isSerializableHeaderValue(input.GrantReadACP) && {
            "x-amz-grant-read-acp": input.GrantReadACP
          }), isSerializableHeaderValue(input.RequestPayer) && {
            "x-amz-request-payer": input.RequestPayer
          }), isSerializableHeaderValue(input.SSECustomerKeyMD5) && {
            "x-amz-server-side-encryption-customer-key-MD5": input.SSECustomerKeyMD5
          }), isSerializableHeaderValue(input.TaggingDirective) && {
            "x-amz-tagging-directive": input.TaggingDirective
          }), isSerializableHeaderValue(input.ContentEncoding) && {
            "Content-Encoding": input.ContentEncoding
          }), isSerializableHeaderValue(input.CopySourceIfUnmodifiedSince) && {
            "x-amz-copy-source-if-unmodified-since": __dateToUtcString(input.CopySourceIfUnmodifiedSince).toString()
          }), isSerializableHeaderValue(input.ContentType) && {
            "Content-Type": input.ContentType
          }), isSerializableHeaderValue(input.SSECustomerAlgorithm) && {
            "x-amz-server-side-encryption-customer-algorithm": input.SSECustomerAlgorithm
          }), isSerializableHeaderValue(input.CopySourceIfMatch) && {
            "x-amz-copy-source-if-match": input.CopySourceIfMatch
          }), isSerializableHeaderValue(input.ObjectLockMode) && {
            "x-amz-object-lock-mode": input.ObjectLockMode
          }), isSerializableHeaderValue(input.SSEKMSKeyId) && {
            "x-amz-server-side-encryption-aws-kms-key-id": input.SSEKMSKeyId
          }), isSerializableHeaderValue(input.ExpectedSourceBucketOwner) && {
            "x-amz-source-expected-bucket-owner": input.ExpectedSourceBucketOwner
          }), isSerializableHeaderValue(input.ServerSideEncryption) && {
            "x-amz-server-side-encryption": input.ServerSideEncryption
          }), isSerializableHeaderValue(input.MetadataDirective) && {
            "x-amz-metadata-directive": input.MetadataDirective
          }), isSerializableHeaderValue(input.GrantFullControl) && {
            "x-amz-grant-full-control": input.GrantFullControl
          }), isSerializableHeaderValue(input.CopySourceIfNoneMatch) && {
            "x-amz-copy-source-if-none-match": input.CopySourceIfNoneMatch
          }), isSerializableHeaderValue(input.StorageClass) && {
            "x-amz-storage-class": input.StorageClass
          }), input.Metadata !== undefined && Object.keys(input.Metadata).reduce(function (acc, suffix) {
            acc["x-amz-meta-" + suffix] = input.Metadata[suffix];
            return acc;
          }, {}));
          resolvedPath = "/{Bucket}/{Key+}";

          if (input.Key !== undefined) {
            labelValue = input.Key;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Key.");
            }

            resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function (segment) {
              return __extendedEncodeURIComponent(segment);
            }).join("/"));
          } else {
            throw new Error("No value provided for input HTTP label: Key.");
          }

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          query = {
            "x-id": "CopyObject"
          };
          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "PUT",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlCreateBucketCommand = function serializeAws_restXmlCreateBucketCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, body, contents, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign(__assign(__assign(__assign(__assign(__assign(__assign({
            "Content-Type": "application/xml"
          }, isSerializableHeaderValue(input.GrantReadACP) && {
            "x-amz-grant-read-acp": input.GrantReadACP
          }), isSerializableHeaderValue(input.GrantRead) && {
            "x-amz-grant-read": input.GrantRead
          }), isSerializableHeaderValue(input.ACL) && {
            "x-amz-acl": input.ACL
          }), isSerializableHeaderValue(input.GrantWrite) && {
            "x-amz-grant-write": input.GrantWrite
          }), isSerializableHeaderValue(input.GrantFullControl) && {
            "x-amz-grant-full-control": input.GrantFullControl
          }), isSerializableHeaderValue(input.ObjectLockEnabledForBucket) && {
            "x-amz-bucket-object-lock-enabled": input.ObjectLockEnabledForBucket.toString()
          }), isSerializableHeaderValue(input.GrantWriteACP) && {
            "x-amz-grant-write-acp": input.GrantWriteACP
          });
          resolvedPath = "/{Bucket}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          if (input.CreateBucketConfiguration !== undefined) {
            contents = serializeAws_restXmlCreateBucketConfiguration(input.CreateBucketConfiguration, context);
            body = '<?xml version="1.0" encoding="UTF-8"?>';
            contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
            body += contents.toString();
          }

          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "PUT",
            headers: headers,
            path: resolvedPath,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlCreateMultipartUploadCommand = function serializeAws_restXmlCreateMultipartUploadCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({
            "Content-Type": ""
          }, isSerializableHeaderValue(input.GrantFullControl) && {
            "x-amz-grant-full-control": input.GrantFullControl
          }), isSerializableHeaderValue(input.SSECustomerKeyMD5) && {
            "x-amz-server-side-encryption-customer-key-MD5": input.SSECustomerKeyMD5
          }), isSerializableHeaderValue(input.SSECustomerAlgorithm) && {
            "x-amz-server-side-encryption-customer-algorithm": input.SSECustomerAlgorithm
          }), isSerializableHeaderValue(input.SSEKMSKeyId) && {
            "x-amz-server-side-encryption-aws-kms-key-id": input.SSEKMSKeyId
          }), isSerializableHeaderValue(input.ObjectLockLegalHoldStatus) && {
            "x-amz-object-lock-legal-hold": input.ObjectLockLegalHoldStatus
          }), isSerializableHeaderValue(input.RequestPayer) && {
            "x-amz-request-payer": input.RequestPayer
          }), isSerializableHeaderValue(input.GrantRead) && {
            "x-amz-grant-read": input.GrantRead
          }), isSerializableHeaderValue(input.GrantWriteACP) && {
            "x-amz-grant-write-acp": input.GrantWriteACP
          }), isSerializableHeaderValue(input.WebsiteRedirectLocation) && {
            "x-amz-website-redirect-location": input.WebsiteRedirectLocation
          }), isSerializableHeaderValue(input.ContentType) && {
            "Content-Type": input.ContentType
          }), isSerializableHeaderValue(input.ContentLanguage) && {
            "Content-Language": input.ContentLanguage
          }), isSerializableHeaderValue(input.CacheControl) && {
            "Cache-Control": input.CacheControl
          }), isSerializableHeaderValue(input.GrantReadACP) && {
            "x-amz-grant-read-acp": input.GrantReadACP
          }), isSerializableHeaderValue(input.Tagging) && {
            "x-amz-tagging": input.Tagging
          }), isSerializableHeaderValue(input.SSEKMSEncryptionContext) && {
            "x-amz-server-side-encryption-context": input.SSEKMSEncryptionContext
          }), isSerializableHeaderValue(input.ACL) && {
            "x-amz-acl": input.ACL
          }), isSerializableHeaderValue(input.SSECustomerKey) && {
            "x-amz-server-side-encryption-customer-key": input.SSECustomerKey
          }), isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          }), isSerializableHeaderValue(input.Expires) && {
            Expires: __dateToUtcString(input.Expires).toString()
          }), isSerializableHeaderValue(input.ObjectLockRetainUntilDate) && {
            "x-amz-object-lock-retain-until-date": (input.ObjectLockRetainUntilDate.toISOString().split(".")[0] + "Z").toString()
          }), isSerializableHeaderValue(input.ServerSideEncryption) && {
            "x-amz-server-side-encryption": input.ServerSideEncryption
          }), isSerializableHeaderValue(input.ContentDisposition) && {
            "Content-Disposition": input.ContentDisposition
          }), isSerializableHeaderValue(input.ObjectLockMode) && {
            "x-amz-object-lock-mode": input.ObjectLockMode
          }), isSerializableHeaderValue(input.StorageClass) && {
            "x-amz-storage-class": input.StorageClass
          }), isSerializableHeaderValue(input.ContentEncoding) && {
            "Content-Encoding": input.ContentEncoding
          }), input.Metadata !== undefined && Object.keys(input.Metadata).reduce(function (acc, suffix) {
            acc["x-amz-meta-" + suffix] = input.Metadata[suffix];
            return acc;
          }, {}));
          resolvedPath = "/{Bucket}/{Key+}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          if (input.Key !== undefined) {
            labelValue = input.Key;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Key.");
            }

            resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function (segment) {
              return __extendedEncodeURIComponent(segment);
            }).join("/"));
          } else {
            throw new Error("No value provided for input HTTP label: Key.");
          }

          query = {
            uploads: ""
          };
          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "POST",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlDeleteBucketCommand = function serializeAws_restXmlDeleteBucketCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, body, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign({
            "Content-Type": ""
          }, isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          });
          resolvedPath = "/{Bucket}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "DELETE",
            headers: headers,
            path: resolvedPath,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlDeleteBucketAnalyticsConfigurationCommand = function serializeAws_restXmlDeleteBucketAnalyticsConfigurationCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign({
            "Content-Type": ""
          }, isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          });
          resolvedPath = "/{Bucket}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          query = __assign({
            analytics: ""
          }, input.Id !== undefined && {
            id: input.Id
          });
          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "DELETE",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlDeleteBucketCorsCommand = function serializeAws_restXmlDeleteBucketCorsCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign({
            "Content-Type": ""
          }, isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          });
          resolvedPath = "/{Bucket}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          query = {
            cors: ""
          };
          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "DELETE",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlDeleteBucketEncryptionCommand = function serializeAws_restXmlDeleteBucketEncryptionCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign({
            "Content-Type": ""
          }, isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          });
          resolvedPath = "/{Bucket}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          query = {
            encryption: ""
          };
          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "DELETE",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlDeleteBucketInventoryConfigurationCommand = function serializeAws_restXmlDeleteBucketInventoryConfigurationCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign({
            "Content-Type": ""
          }, isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          });
          resolvedPath = "/{Bucket}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          query = __assign({
            inventory: ""
          }, input.Id !== undefined && {
            id: input.Id
          });
          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "DELETE",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlDeleteBucketLifecycleCommand = function serializeAws_restXmlDeleteBucketLifecycleCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign({
            "Content-Type": ""
          }, isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          });
          resolvedPath = "/{Bucket}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          query = {
            lifecycle: ""
          };
          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "DELETE",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlDeleteBucketMetricsConfigurationCommand = function serializeAws_restXmlDeleteBucketMetricsConfigurationCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign({
            "Content-Type": ""
          }, isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          });
          resolvedPath = "/{Bucket}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          query = __assign({
            metrics: ""
          }, input.Id !== undefined && {
            id: input.Id
          });
          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "DELETE",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlDeleteBucketOwnershipControlsCommand = function serializeAws_restXmlDeleteBucketOwnershipControlsCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign({
            "Content-Type": ""
          }, isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          });
          resolvedPath = "/{Bucket}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          query = {
            ownershipControls: ""
          };
          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "DELETE",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlDeleteBucketPolicyCommand = function serializeAws_restXmlDeleteBucketPolicyCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign({
            "Content-Type": ""
          }, isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          });
          resolvedPath = "/{Bucket}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          query = {
            policy: ""
          };
          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "DELETE",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlDeleteBucketReplicationCommand = function serializeAws_restXmlDeleteBucketReplicationCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign({
            "Content-Type": ""
          }, isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          });
          resolvedPath = "/{Bucket}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          query = {
            replication: ""
          };
          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "DELETE",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlDeleteBucketTaggingCommand = function serializeAws_restXmlDeleteBucketTaggingCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign({
            "Content-Type": ""
          }, isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          });
          resolvedPath = "/{Bucket}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          query = {
            tagging: ""
          };
          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "DELETE",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlDeleteBucketWebsiteCommand = function serializeAws_restXmlDeleteBucketWebsiteCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign({
            "Content-Type": ""
          }, isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          });
          resolvedPath = "/{Bucket}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          query = {
            website: ""
          };
          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "DELETE",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlDeleteObjectCommand = function serializeAws_restXmlDeleteObjectCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign(__assign(__assign(__assign({
            "Content-Type": ""
          }, isSerializableHeaderValue(input.MFA) && {
            "x-amz-mfa": input.MFA
          }), isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          }), isSerializableHeaderValue(input.BypassGovernanceRetention) && {
            "x-amz-bypass-governance-retention": input.BypassGovernanceRetention.toString()
          }), isSerializableHeaderValue(input.RequestPayer) && {
            "x-amz-request-payer": input.RequestPayer
          });
          resolvedPath = "/{Bucket}/{Key+}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          if (input.Key !== undefined) {
            labelValue = input.Key;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Key.");
            }

            resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function (segment) {
              return __extendedEncodeURIComponent(segment);
            }).join("/"));
          } else {
            throw new Error("No value provided for input HTTP label: Key.");
          }

          query = __assign({
            "x-id": "DeleteObject"
          }, input.VersionId !== undefined && {
            versionId: input.VersionId
          });
          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "DELETE",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlDeleteObjectsCommand = function serializeAws_restXmlDeleteObjectsCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign(__assign(__assign(__assign({
            "Content-Type": "application/xml"
          }, isSerializableHeaderValue(input.MFA) && {
            "x-amz-mfa": input.MFA
          }), isSerializableHeaderValue(input.BypassGovernanceRetention) && {
            "x-amz-bypass-governance-retention": input.BypassGovernanceRetention.toString()
          }), isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          }), isSerializableHeaderValue(input.RequestPayer) && {
            "x-amz-request-payer": input.RequestPayer
          });
          resolvedPath = "/{Bucket}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          query = {
            delete: ""
          };

          if (input.Delete !== undefined) {
            contents = serializeAws_restXmlDelete(input.Delete, context);
            body = '<?xml version="1.0" encoding="UTF-8"?>';
            contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
            body += contents.toString();
          }

          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "POST",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlDeleteObjectTaggingCommand = function serializeAws_restXmlDeleteObjectTaggingCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign({
            "Content-Type": ""
          }, isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          });
          resolvedPath = "/{Bucket}/{Key+}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          if (input.Key !== undefined) {
            labelValue = input.Key;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Key.");
            }

            resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function (segment) {
              return __extendedEncodeURIComponent(segment);
            }).join("/"));
          } else {
            throw new Error("No value provided for input HTTP label: Key.");
          }

          query = __assign({
            tagging: ""
          }, input.VersionId !== undefined && {
            versionId: input.VersionId
          });
          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "DELETE",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlDeletePublicAccessBlockCommand = function serializeAws_restXmlDeletePublicAccessBlockCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign({
            "Content-Type": ""
          }, isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          });
          resolvedPath = "/{Bucket}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          query = {
            publicAccessBlock: ""
          };
          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "DELETE",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlGetBucketAccelerateConfigurationCommand = function serializeAws_restXmlGetBucketAccelerateConfigurationCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign({
            "Content-Type": ""
          }, isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          });
          resolvedPath = "/{Bucket}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          query = {
            accelerate: ""
          };
          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "GET",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlGetBucketAclCommand = function serializeAws_restXmlGetBucketAclCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign({
            "Content-Type": ""
          }, isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          });
          resolvedPath = "/{Bucket}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          query = {
            acl: ""
          };
          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "GET",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlGetBucketAnalyticsConfigurationCommand = function serializeAws_restXmlGetBucketAnalyticsConfigurationCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign({
            "Content-Type": ""
          }, isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          });
          resolvedPath = "/{Bucket}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          query = __assign({
            analytics: "",
            "x-id": "GetBucketAnalyticsConfiguration"
          }, input.Id !== undefined && {
            id: input.Id
          });
          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "GET",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlGetBucketCorsCommand = function serializeAws_restXmlGetBucketCorsCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign({
            "Content-Type": ""
          }, isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          });
          resolvedPath = "/{Bucket}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          query = {
            cors: ""
          };
          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "GET",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlGetBucketEncryptionCommand = function serializeAws_restXmlGetBucketEncryptionCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign({
            "Content-Type": ""
          }, isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          });
          resolvedPath = "/{Bucket}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          query = {
            encryption: ""
          };
          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "GET",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlGetBucketInventoryConfigurationCommand = function serializeAws_restXmlGetBucketInventoryConfigurationCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign({
            "Content-Type": ""
          }, isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          });
          resolvedPath = "/{Bucket}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          query = __assign({
            inventory: "",
            "x-id": "GetBucketInventoryConfiguration"
          }, input.Id !== undefined && {
            id: input.Id
          });
          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "GET",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlGetBucketLifecycleConfigurationCommand = function serializeAws_restXmlGetBucketLifecycleConfigurationCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign({
            "Content-Type": ""
          }, isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          });
          resolvedPath = "/{Bucket}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          query = {
            lifecycle: ""
          };
          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "GET",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlGetBucketLocationCommand = function serializeAws_restXmlGetBucketLocationCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign({
            "Content-Type": ""
          }, isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          });
          resolvedPath = "/{Bucket}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          query = {
            location: ""
          };
          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "GET",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlGetBucketLoggingCommand = function serializeAws_restXmlGetBucketLoggingCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign({
            "Content-Type": ""
          }, isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          });
          resolvedPath = "/{Bucket}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          query = {
            logging: ""
          };
          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "GET",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlGetBucketMetricsConfigurationCommand = function serializeAws_restXmlGetBucketMetricsConfigurationCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign({
            "Content-Type": ""
          }, isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          });
          resolvedPath = "/{Bucket}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          query = __assign({
            metrics: "",
            "x-id": "GetBucketMetricsConfiguration"
          }, input.Id !== undefined && {
            id: input.Id
          });
          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "GET",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlGetBucketNotificationConfigurationCommand = function serializeAws_restXmlGetBucketNotificationConfigurationCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign({
            "Content-Type": ""
          }, isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          });
          resolvedPath = "/{Bucket}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          query = {
            notification: ""
          };
          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "GET",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlGetBucketOwnershipControlsCommand = function serializeAws_restXmlGetBucketOwnershipControlsCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign({
            "Content-Type": ""
          }, isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          });
          resolvedPath = "/{Bucket}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          query = {
            ownershipControls: ""
          };
          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "GET",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlGetBucketPolicyCommand = function serializeAws_restXmlGetBucketPolicyCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign({
            "Content-Type": ""
          }, isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          });
          resolvedPath = "/{Bucket}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          query = {
            policy: ""
          };
          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "GET",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlGetBucketPolicyStatusCommand = function serializeAws_restXmlGetBucketPolicyStatusCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign({
            "Content-Type": ""
          }, isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          });
          resolvedPath = "/{Bucket}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          query = {
            policyStatus: ""
          };
          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "GET",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlGetBucketReplicationCommand = function serializeAws_restXmlGetBucketReplicationCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign({
            "Content-Type": ""
          }, isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          });
          resolvedPath = "/{Bucket}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          query = {
            replication: ""
          };
          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "GET",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlGetBucketRequestPaymentCommand = function serializeAws_restXmlGetBucketRequestPaymentCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign({
            "Content-Type": ""
          }, isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          });
          resolvedPath = "/{Bucket}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          query = {
            requestPayment: ""
          };
          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "GET",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlGetBucketTaggingCommand = function serializeAws_restXmlGetBucketTaggingCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign({
            "Content-Type": ""
          }, isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          });
          resolvedPath = "/{Bucket}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          query = {
            tagging: ""
          };
          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "GET",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlGetBucketVersioningCommand = function serializeAws_restXmlGetBucketVersioningCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign({
            "Content-Type": ""
          }, isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          });
          resolvedPath = "/{Bucket}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          query = {
            versioning: ""
          };
          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "GET",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlGetBucketWebsiteCommand = function serializeAws_restXmlGetBucketWebsiteCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign({
            "Content-Type": ""
          }, isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          });
          resolvedPath = "/{Bucket}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          query = {
            website: ""
          };
          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "GET",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlGetObjectCommand = function serializeAws_restXmlGetObjectCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({
            "Content-Type": ""
          }, isSerializableHeaderValue(input.SSECustomerKey) && {
            "x-amz-server-side-encryption-customer-key": input.SSECustomerKey
          }), isSerializableHeaderValue(input.SSECustomerAlgorithm) && {
            "x-amz-server-side-encryption-customer-algorithm": input.SSECustomerAlgorithm
          }), isSerializableHeaderValue(input.SSECustomerKeyMD5) && {
            "x-amz-server-side-encryption-customer-key-MD5": input.SSECustomerKeyMD5
          }), isSerializableHeaderValue(input.RequestPayer) && {
            "x-amz-request-payer": input.RequestPayer
          }), isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          }), isSerializableHeaderValue(input.IfUnmodifiedSince) && {
            "If-Unmodified-Since": __dateToUtcString(input.IfUnmodifiedSince).toString()
          }), isSerializableHeaderValue(input.IfModifiedSince) && {
            "If-Modified-Since": __dateToUtcString(input.IfModifiedSince).toString()
          }), isSerializableHeaderValue(input.IfNoneMatch) && {
            "If-None-Match": input.IfNoneMatch
          }), isSerializableHeaderValue(input.IfMatch) && {
            "If-Match": input.IfMatch
          }), isSerializableHeaderValue(input.Range) && {
            Range: input.Range
          });
          resolvedPath = "/{Bucket}/{Key+}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          if (input.Key !== undefined) {
            labelValue = input.Key;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Key.");
            }

            resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function (segment) {
              return __extendedEncodeURIComponent(segment);
            }).join("/"));
          } else {
            throw new Error("No value provided for input HTTP label: Key.");
          }

          query = __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({
            "x-id": "GetObject"
          }, input.ResponseContentEncoding !== undefined && {
            "response-content-encoding": input.ResponseContentEncoding
          }), input.ResponseCacheControl !== undefined && {
            "response-cache-control": input.ResponseCacheControl
          }), input.ResponseContentLanguage !== undefined && {
            "response-content-language": input.ResponseContentLanguage
          }), input.ResponseContentDisposition !== undefined && {
            "response-content-disposition": input.ResponseContentDisposition
          }), input.PartNumber !== undefined && {
            partNumber: input.PartNumber.toString()
          }), input.VersionId !== undefined && {
            versionId: input.VersionId
          }), input.ResponseExpires !== undefined && {
            "response-expires": (input.ResponseExpires.toISOString().split(".")[0] + "Z").toString()
          }), input.ResponseContentType !== undefined && {
            "response-content-type": input.ResponseContentType
          });
          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "GET",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlGetObjectAclCommand = function serializeAws_restXmlGetObjectAclCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign(__assign({
            "Content-Type": ""
          }, isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          }), isSerializableHeaderValue(input.RequestPayer) && {
            "x-amz-request-payer": input.RequestPayer
          });
          resolvedPath = "/{Bucket}/{Key+}";

          if (input.Key !== undefined) {
            labelValue = input.Key;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Key.");
            }

            resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function (segment) {
              return __extendedEncodeURIComponent(segment);
            }).join("/"));
          } else {
            throw new Error("No value provided for input HTTP label: Key.");
          }

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          query = __assign({
            acl: ""
          }, input.VersionId !== undefined && {
            versionId: input.VersionId
          });
          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "GET",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlGetObjectLegalHoldCommand = function serializeAws_restXmlGetObjectLegalHoldCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign(__assign({
            "Content-Type": ""
          }, isSerializableHeaderValue(input.RequestPayer) && {
            "x-amz-request-payer": input.RequestPayer
          }), isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          });
          resolvedPath = "/{Bucket}/{Key+}";

          if (input.Key !== undefined) {
            labelValue = input.Key;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Key.");
            }

            resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function (segment) {
              return __extendedEncodeURIComponent(segment);
            }).join("/"));
          } else {
            throw new Error("No value provided for input HTTP label: Key.");
          }

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          query = __assign({
            "legal-hold": ""
          }, input.VersionId !== undefined && {
            versionId: input.VersionId
          });
          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "GET",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlGetObjectLockConfigurationCommand = function serializeAws_restXmlGetObjectLockConfigurationCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign({
            "Content-Type": ""
          }, isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          });
          resolvedPath = "/{Bucket}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          query = {
            "object-lock": ""
          };
          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "GET",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlGetObjectRetentionCommand = function serializeAws_restXmlGetObjectRetentionCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign(__assign({
            "Content-Type": ""
          }, isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          }), isSerializableHeaderValue(input.RequestPayer) && {
            "x-amz-request-payer": input.RequestPayer
          });
          resolvedPath = "/{Bucket}/{Key+}";

          if (input.Key !== undefined) {
            labelValue = input.Key;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Key.");
            }

            resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function (segment) {
              return __extendedEncodeURIComponent(segment);
            }).join("/"));
          } else {
            throw new Error("No value provided for input HTTP label: Key.");
          }

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          query = __assign({
            retention: ""
          }, input.VersionId !== undefined && {
            versionId: input.VersionId
          });
          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "GET",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlGetObjectTaggingCommand = function serializeAws_restXmlGetObjectTaggingCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign({
            "Content-Type": ""
          }, isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          });
          resolvedPath = "/{Bucket}/{Key+}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          if (input.Key !== undefined) {
            labelValue = input.Key;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Key.");
            }

            resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function (segment) {
              return __extendedEncodeURIComponent(segment);
            }).join("/"));
          } else {
            throw new Error("No value provided for input HTTP label: Key.");
          }

          query = __assign({
            tagging: ""
          }, input.VersionId !== undefined && {
            versionId: input.VersionId
          });
          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "GET",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlGetObjectTorrentCommand = function serializeAws_restXmlGetObjectTorrentCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign(__assign({
            "Content-Type": ""
          }, isSerializableHeaderValue(input.RequestPayer) && {
            "x-amz-request-payer": input.RequestPayer
          }), isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          });
          resolvedPath = "/{Bucket}/{Key+}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          if (input.Key !== undefined) {
            labelValue = input.Key;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Key.");
            }

            resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function (segment) {
              return __extendedEncodeURIComponent(segment);
            }).join("/"));
          } else {
            throw new Error("No value provided for input HTTP label: Key.");
          }

          query = {
            torrent: ""
          };
          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "GET",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlGetPublicAccessBlockCommand = function serializeAws_restXmlGetPublicAccessBlockCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign({
            "Content-Type": ""
          }, isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          });
          resolvedPath = "/{Bucket}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          query = {
            publicAccessBlock: ""
          };
          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "GET",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlHeadBucketCommand = function serializeAws_restXmlHeadBucketCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, body, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign({
            "Content-Type": ""
          }, isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          });
          resolvedPath = "/{Bucket}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "HEAD",
            headers: headers,
            path: resolvedPath,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlHeadObjectCommand = function serializeAws_restXmlHeadObjectCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({
            "Content-Type": ""
          }, isSerializableHeaderValue(input.SSECustomerAlgorithm) && {
            "x-amz-server-side-encryption-customer-algorithm": input.SSECustomerAlgorithm
          }), isSerializableHeaderValue(input.SSECustomerKey) && {
            "x-amz-server-side-encryption-customer-key": input.SSECustomerKey
          }), isSerializableHeaderValue(input.Range) && {
            Range: input.Range
          }), isSerializableHeaderValue(input.IfNoneMatch) && {
            "If-None-Match": input.IfNoneMatch
          }), isSerializableHeaderValue(input.IfUnmodifiedSince) && {
            "If-Unmodified-Since": __dateToUtcString(input.IfUnmodifiedSince).toString()
          }), isSerializableHeaderValue(input.IfModifiedSince) && {
            "If-Modified-Since": __dateToUtcString(input.IfModifiedSince).toString()
          }), isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          }), isSerializableHeaderValue(input.SSECustomerKeyMD5) && {
            "x-amz-server-side-encryption-customer-key-MD5": input.SSECustomerKeyMD5
          }), isSerializableHeaderValue(input.IfMatch) && {
            "If-Match": input.IfMatch
          }), isSerializableHeaderValue(input.RequestPayer) && {
            "x-amz-request-payer": input.RequestPayer
          });
          resolvedPath = "/{Bucket}/{Key+}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          if (input.Key !== undefined) {
            labelValue = input.Key;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Key.");
            }

            resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function (segment) {
              return __extendedEncodeURIComponent(segment);
            }).join("/"));
          } else {
            throw new Error("No value provided for input HTTP label: Key.");
          }

          query = __assign(__assign({}, input.PartNumber !== undefined && {
            partNumber: input.PartNumber.toString()
          }), input.VersionId !== undefined && {
            versionId: input.VersionId
          });
          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "HEAD",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlListBucketAnalyticsConfigurationsCommand = function serializeAws_restXmlListBucketAnalyticsConfigurationsCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign({
            "Content-Type": ""
          }, isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          });
          resolvedPath = "/{Bucket}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          query = __assign({
            analytics: "",
            "x-id": "ListBucketAnalyticsConfigurations"
          }, input.ContinuationToken !== undefined && {
            "continuation-token": input.ContinuationToken
          });
          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "GET",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlListBucketInventoryConfigurationsCommand = function serializeAws_restXmlListBucketInventoryConfigurationsCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign({
            "Content-Type": ""
          }, isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          });
          resolvedPath = "/{Bucket}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          query = __assign({
            inventory: "",
            "x-id": "ListBucketInventoryConfigurations"
          }, input.ContinuationToken !== undefined && {
            "continuation-token": input.ContinuationToken
          });
          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "GET",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlListBucketMetricsConfigurationsCommand = function serializeAws_restXmlListBucketMetricsConfigurationsCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign({
            "Content-Type": ""
          }, isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          });
          resolvedPath = "/{Bucket}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          query = __assign({
            metrics: "",
            "x-id": "ListBucketMetricsConfigurations"
          }, input.ContinuationToken !== undefined && {
            "continuation-token": input.ContinuationToken
          });
          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "GET",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlListBucketsCommand = function serializeAws_restXmlListBucketsCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, body, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = {
            "Content-Type": ""
          };
          resolvedPath = "/";
          body = "";
          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "GET",
            headers: headers,
            path: resolvedPath,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlListMultipartUploadsCommand = function serializeAws_restXmlListMultipartUploadsCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign({
            "Content-Type": ""
          }, isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          });
          resolvedPath = "/{Bucket}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          query = __assign(__assign(__assign(__assign(__assign(__assign({
            uploads: ""
          }, input.UploadIdMarker !== undefined && {
            "upload-id-marker": input.UploadIdMarker
          }), input.Prefix !== undefined && {
            prefix: input.Prefix
          }), input.Delimiter !== undefined && {
            delimiter: input.Delimiter
          }), input.MaxUploads !== undefined && {
            "max-uploads": input.MaxUploads.toString()
          }), input.KeyMarker !== undefined && {
            "key-marker": input.KeyMarker
          }), input.EncodingType !== undefined && {
            "encoding-type": input.EncodingType
          });
          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "GET",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlListObjectsCommand = function serializeAws_restXmlListObjectsCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign(__assign({
            "Content-Type": ""
          }, isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          }), isSerializableHeaderValue(input.RequestPayer) && {
            "x-amz-request-payer": input.RequestPayer
          });
          resolvedPath = "/{Bucket}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          query = __assign(__assign(__assign(__assign(__assign({}, input.MaxKeys !== undefined && {
            "max-keys": input.MaxKeys.toString()
          }), input.Marker !== undefined && {
            marker: input.Marker
          }), input.Prefix !== undefined && {
            prefix: input.Prefix
          }), input.Delimiter !== undefined && {
            delimiter: input.Delimiter
          }), input.EncodingType !== undefined && {
            "encoding-type": input.EncodingType
          });
          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "GET",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlListObjectsV2Command = function serializeAws_restXmlListObjectsV2Command(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign(__assign({
            "Content-Type": ""
          }, isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          }), isSerializableHeaderValue(input.RequestPayer) && {
            "x-amz-request-payer": input.RequestPayer
          });
          resolvedPath = "/{Bucket}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          query = __assign(__assign(__assign(__assign(__assign(__assign(__assign({
            "list-type": "2"
          }, input.ContinuationToken !== undefined && {
            "continuation-token": input.ContinuationToken
          }), input.FetchOwner !== undefined && {
            "fetch-owner": input.FetchOwner.toString()
          }), input.EncodingType !== undefined && {
            "encoding-type": input.EncodingType
          }), input.Prefix !== undefined && {
            prefix: input.Prefix
          }), input.StartAfter !== undefined && {
            "start-after": input.StartAfter
          }), input.Delimiter !== undefined && {
            delimiter: input.Delimiter
          }), input.MaxKeys !== undefined && {
            "max-keys": input.MaxKeys.toString()
          });
          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "GET",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlListObjectVersionsCommand = function serializeAws_restXmlListObjectVersionsCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign({
            "Content-Type": ""
          }, isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          });
          resolvedPath = "/{Bucket}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          query = __assign(__assign(__assign(__assign(__assign(__assign({
            versions: ""
          }, input.KeyMarker !== undefined && {
            "key-marker": input.KeyMarker
          }), input.MaxKeys !== undefined && {
            "max-keys": input.MaxKeys.toString()
          }), input.Delimiter !== undefined && {
            delimiter: input.Delimiter
          }), input.VersionIdMarker !== undefined && {
            "version-id-marker": input.VersionIdMarker
          }), input.Prefix !== undefined && {
            prefix: input.Prefix
          }), input.EncodingType !== undefined && {
            "encoding-type": input.EncodingType
          });
          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "GET",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlListPartsCommand = function serializeAws_restXmlListPartsCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign(__assign({
            "Content-Type": ""
          }, isSerializableHeaderValue(input.RequestPayer) && {
            "x-amz-request-payer": input.RequestPayer
          }), isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          });
          resolvedPath = "/{Bucket}/{Key+}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          if (input.Key !== undefined) {
            labelValue = input.Key;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Key.");
            }

            resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function (segment) {
              return __extendedEncodeURIComponent(segment);
            }).join("/"));
          } else {
            throw new Error("No value provided for input HTTP label: Key.");
          }

          query = __assign(__assign(__assign({
            "x-id": "ListParts"
          }, input.UploadId !== undefined && {
            uploadId: input.UploadId
          }), input.MaxParts !== undefined && {
            "max-parts": input.MaxParts.toString()
          }), input.PartNumberMarker !== undefined && {
            "part-number-marker": input.PartNumberMarker.toString()
          });
          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "GET",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlPutBucketAccelerateConfigurationCommand = function serializeAws_restXmlPutBucketAccelerateConfigurationCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign({
            "Content-Type": "application/xml"
          }, isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          });
          resolvedPath = "/{Bucket}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          query = {
            accelerate: ""
          };

          if (input.AccelerateConfiguration !== undefined) {
            contents = serializeAws_restXmlAccelerateConfiguration(input.AccelerateConfiguration, context);
            body = '<?xml version="1.0" encoding="UTF-8"?>';
            contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
            body += contents.toString();
          }

          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "PUT",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlPutBucketAclCommand = function serializeAws_restXmlPutBucketAclCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({
            "Content-Type": "application/xml"
          }, isSerializableHeaderValue(input.GrantFullControl) && {
            "x-amz-grant-full-control": input.GrantFullControl
          }), isSerializableHeaderValue(input.GrantReadACP) && {
            "x-amz-grant-read-acp": input.GrantReadACP
          }), isSerializableHeaderValue(input.GrantWrite) && {
            "x-amz-grant-write": input.GrantWrite
          }), isSerializableHeaderValue(input.ContentMD5) && {
            "Content-MD5": input.ContentMD5
          }), isSerializableHeaderValue(input.ACL) && {
            "x-amz-acl": input.ACL
          }), isSerializableHeaderValue(input.GrantWriteACP) && {
            "x-amz-grant-write-acp": input.GrantWriteACP
          }), isSerializableHeaderValue(input.GrantRead) && {
            "x-amz-grant-read": input.GrantRead
          }), isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          });
          resolvedPath = "/{Bucket}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          query = {
            acl: ""
          };

          if (input.AccessControlPolicy !== undefined) {
            contents = serializeAws_restXmlAccessControlPolicy(input.AccessControlPolicy, context);
            body = '<?xml version="1.0" encoding="UTF-8"?>';
            contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
            body += contents.toString();
          }

          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "PUT",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlPutBucketAnalyticsConfigurationCommand = function serializeAws_restXmlPutBucketAnalyticsConfigurationCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign({
            "Content-Type": "application/xml"
          }, isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          });
          resolvedPath = "/{Bucket}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          query = __assign({
            analytics: ""
          }, input.Id !== undefined && {
            id: input.Id
          });

          if (input.AnalyticsConfiguration !== undefined) {
            contents = serializeAws_restXmlAnalyticsConfiguration(input.AnalyticsConfiguration, context);
            body = '<?xml version="1.0" encoding="UTF-8"?>';
            contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
            body += contents.toString();
          }

          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "PUT",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlPutBucketCorsCommand = function serializeAws_restXmlPutBucketCorsCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign(__assign({
            "Content-Type": "application/xml"
          }, isSerializableHeaderValue(input.ContentMD5) && {
            "Content-MD5": input.ContentMD5
          }), isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          });
          resolvedPath = "/{Bucket}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          query = {
            cors: ""
          };

          if (input.CORSConfiguration !== undefined) {
            contents = serializeAws_restXmlCORSConfiguration(input.CORSConfiguration, context);
            body = '<?xml version="1.0" encoding="UTF-8"?>';
            contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
            body += contents.toString();
          }

          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "PUT",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlPutBucketEncryptionCommand = function serializeAws_restXmlPutBucketEncryptionCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign(__assign({
            "Content-Type": "application/xml"
          }, isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          }), isSerializableHeaderValue(input.ContentMD5) && {
            "Content-MD5": input.ContentMD5
          });
          resolvedPath = "/{Bucket}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          query = {
            encryption: ""
          };

          if (input.ServerSideEncryptionConfiguration !== undefined) {
            contents = serializeAws_restXmlServerSideEncryptionConfiguration(input.ServerSideEncryptionConfiguration, context);
            body = '<?xml version="1.0" encoding="UTF-8"?>';
            contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
            body += contents.toString();
          }

          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "PUT",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlPutBucketInventoryConfigurationCommand = function serializeAws_restXmlPutBucketInventoryConfigurationCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign({
            "Content-Type": "application/xml"
          }, isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          });
          resolvedPath = "/{Bucket}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          query = __assign({
            inventory: ""
          }, input.Id !== undefined && {
            id: input.Id
          });

          if (input.InventoryConfiguration !== undefined) {
            contents = serializeAws_restXmlInventoryConfiguration(input.InventoryConfiguration, context);
            body = '<?xml version="1.0" encoding="UTF-8"?>';
            contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
            body += contents.toString();
          }

          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "PUT",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlPutBucketLifecycleConfigurationCommand = function serializeAws_restXmlPutBucketLifecycleConfigurationCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign({
            "Content-Type": "application/xml"
          }, isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          });
          resolvedPath = "/{Bucket}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          query = {
            lifecycle: ""
          };

          if (input.LifecycleConfiguration !== undefined) {
            contents = serializeAws_restXmlBucketLifecycleConfiguration(input.LifecycleConfiguration, context);
            body = '<?xml version="1.0" encoding="UTF-8"?>';
            contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
            body += contents.toString();
          }

          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "PUT",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlPutBucketLoggingCommand = function serializeAws_restXmlPutBucketLoggingCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign(__assign({
            "Content-Type": "application/xml"
          }, isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          }), isSerializableHeaderValue(input.ContentMD5) && {
            "Content-MD5": input.ContentMD5
          });
          resolvedPath = "/{Bucket}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          query = {
            logging: ""
          };

          if (input.BucketLoggingStatus !== undefined) {
            contents = serializeAws_restXmlBucketLoggingStatus(input.BucketLoggingStatus, context);
            body = '<?xml version="1.0" encoding="UTF-8"?>';
            contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
            body += contents.toString();
          }

          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "PUT",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlPutBucketMetricsConfigurationCommand = function serializeAws_restXmlPutBucketMetricsConfigurationCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign({
            "Content-Type": "application/xml"
          }, isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          });
          resolvedPath = "/{Bucket}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          query = __assign({
            metrics: ""
          }, input.Id !== undefined && {
            id: input.Id
          });

          if (input.MetricsConfiguration !== undefined) {
            contents = serializeAws_restXmlMetricsConfiguration(input.MetricsConfiguration, context);
            body = '<?xml version="1.0" encoding="UTF-8"?>';
            contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
            body += contents.toString();
          }

          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "PUT",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlPutBucketNotificationConfigurationCommand = function serializeAws_restXmlPutBucketNotificationConfigurationCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign({
            "Content-Type": "application/xml"
          }, isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          });
          resolvedPath = "/{Bucket}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          query = {
            notification: ""
          };

          if (input.NotificationConfiguration !== undefined) {
            contents = serializeAws_restXmlNotificationConfiguration(input.NotificationConfiguration, context);
            body = '<?xml version="1.0" encoding="UTF-8"?>';
            contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
            body += contents.toString();
          }

          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "PUT",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlPutBucketOwnershipControlsCommand = function serializeAws_restXmlPutBucketOwnershipControlsCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign(__assign({
            "Content-Type": "application/xml"
          }, isSerializableHeaderValue(input.ContentMD5) && {
            "Content-MD5": input.ContentMD5
          }), isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          });
          resolvedPath = "/{Bucket}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          query = {
            ownershipControls: ""
          };

          if (input.OwnershipControls !== undefined) {
            contents = serializeAws_restXmlOwnershipControls(input.OwnershipControls, context);
            body = '<?xml version="1.0" encoding="UTF-8"?>';
            contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
            body += contents.toString();
          }

          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "PUT",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlPutBucketPolicyCommand = function serializeAws_restXmlPutBucketPolicyCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, bodyNode, node, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign(__assign(__assign({
            "Content-Type": "application/xml"
          }, isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          }), isSerializableHeaderValue(input.ContentMD5) && {
            "Content-MD5": input.ContentMD5
          }), isSerializableHeaderValue(input.ConfirmRemoveSelfBucketAccess) && {
            "x-amz-confirm-remove-self-bucket-access": input.ConfirmRemoveSelfBucketAccess.toString()
          });
          resolvedPath = "/{Bucket}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          query = {
            policy: ""
          };
          body = '<?xml version="1.0" encoding="UTF-8"?>';
          bodyNode = new __XmlNode("PutBucketPolicyRequest");
          bodyNode.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");

          if (input.Policy !== undefined) {
            node = new __XmlNode("Policy").addChildNode(new __XmlText(input.Policy)).withName("Policy");
            bodyNode.addChildNode(node);
          }

          body += bodyNode.toString();
          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "PUT",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlPutBucketReplicationCommand = function serializeAws_restXmlPutBucketReplicationCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign(__assign(__assign({
            "Content-Type": "application/xml"
          }, isSerializableHeaderValue(input.Token) && {
            "x-amz-bucket-object-lock-token": input.Token
          }), isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          }), isSerializableHeaderValue(input.ContentMD5) && {
            "Content-MD5": input.ContentMD5
          });
          resolvedPath = "/{Bucket}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          query = {
            replication: ""
          };

          if (input.ReplicationConfiguration !== undefined) {
            contents = serializeAws_restXmlReplicationConfiguration(input.ReplicationConfiguration, context);
            body = '<?xml version="1.0" encoding="UTF-8"?>';
            contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
            body += contents.toString();
          }

          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "PUT",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlPutBucketRequestPaymentCommand = function serializeAws_restXmlPutBucketRequestPaymentCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign(__assign({
            "Content-Type": "application/xml"
          }, isSerializableHeaderValue(input.ContentMD5) && {
            "Content-MD5": input.ContentMD5
          }), isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          });
          resolvedPath = "/{Bucket}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          query = {
            requestPayment: ""
          };

          if (input.RequestPaymentConfiguration !== undefined) {
            contents = serializeAws_restXmlRequestPaymentConfiguration(input.RequestPaymentConfiguration, context);
            body = '<?xml version="1.0" encoding="UTF-8"?>';
            contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
            body += contents.toString();
          }

          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "PUT",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlPutBucketTaggingCommand = function serializeAws_restXmlPutBucketTaggingCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign(__assign({
            "Content-Type": "application/xml"
          }, isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          }), isSerializableHeaderValue(input.ContentMD5) && {
            "Content-MD5": input.ContentMD5
          });
          resolvedPath = "/{Bucket}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          query = {
            tagging: ""
          };

          if (input.Tagging !== undefined) {
            contents = serializeAws_restXmlTagging(input.Tagging, context);
            body = '<?xml version="1.0" encoding="UTF-8"?>';
            contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
            body += contents.toString();
          }

          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "PUT",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlPutBucketVersioningCommand = function serializeAws_restXmlPutBucketVersioningCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign(__assign(__assign({
            "Content-Type": "application/xml"
          }, isSerializableHeaderValue(input.ContentMD5) && {
            "Content-MD5": input.ContentMD5
          }), isSerializableHeaderValue(input.MFA) && {
            "x-amz-mfa": input.MFA
          }), isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          });
          resolvedPath = "/{Bucket}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          query = {
            versioning: ""
          };

          if (input.VersioningConfiguration !== undefined) {
            contents = serializeAws_restXmlVersioningConfiguration(input.VersioningConfiguration, context);
            body = '<?xml version="1.0" encoding="UTF-8"?>';
            contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
            body += contents.toString();
          }

          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "PUT",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlPutBucketWebsiteCommand = function serializeAws_restXmlPutBucketWebsiteCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign(__assign({
            "Content-Type": "application/xml"
          }, isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          }), isSerializableHeaderValue(input.ContentMD5) && {
            "Content-MD5": input.ContentMD5
          });
          resolvedPath = "/{Bucket}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          query = {
            website: ""
          };

          if (input.WebsiteConfiguration !== undefined) {
            contents = serializeAws_restXmlWebsiteConfiguration(input.WebsiteConfiguration, context);
            body = '<?xml version="1.0" encoding="UTF-8"?>';
            contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
            body += contents.toString();
          }

          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "PUT",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlPutObjectCommand = function serializeAws_restXmlPutObjectCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, labelValue, query, body, contents, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({
            "Content-Type": "application/octet-stream"
          }, isSerializableHeaderValue(input.GrantFullControl) && {
            "x-amz-grant-full-control": input.GrantFullControl
          }), isSerializableHeaderValue(input.ContentEncoding) && {
            "Content-Encoding": input.ContentEncoding
          }), isSerializableHeaderValue(input.RequestPayer) && {
            "x-amz-request-payer": input.RequestPayer
          }), isSerializableHeaderValue(input.GrantReadACP) && {
            "x-amz-grant-read-acp": input.GrantReadACP
          }), isSerializableHeaderValue(input.SSECustomerKeyMD5) && {
            "x-amz-server-side-encryption-customer-key-MD5": input.SSECustomerKeyMD5
          }), isSerializableHeaderValue(input.CacheControl) && {
            "Cache-Control": input.CacheControl
          }), isSerializableHeaderValue(input.WebsiteRedirectLocation) && {
            "x-amz-website-redirect-location": input.WebsiteRedirectLocation
          }), isSerializableHeaderValue(input.ObjectLockLegalHoldStatus) && {
            "x-amz-object-lock-legal-hold": input.ObjectLockLegalHoldStatus
          }), isSerializableHeaderValue(input.GrantWriteACP) && {
            "x-amz-grant-write-acp": input.GrantWriteACP
          }), isSerializableHeaderValue(input.ContentLength) && {
            "Content-Length": input.ContentLength.toString()
          }), isSerializableHeaderValue(input.ObjectLockRetainUntilDate) && {
            "x-amz-object-lock-retain-until-date": (input.ObjectLockRetainUntilDate.toISOString().split(".")[0] + "Z").toString()
          }), isSerializableHeaderValue(input.SSECustomerAlgorithm) && {
            "x-amz-server-side-encryption-customer-algorithm": input.SSECustomerAlgorithm
          }), isSerializableHeaderValue(input.ContentDisposition) && {
            "Content-Disposition": input.ContentDisposition
          }), isSerializableHeaderValue(input.SSECustomerKey) && {
            "x-amz-server-side-encryption-customer-key": input.SSECustomerKey
          }), isSerializableHeaderValue(input.SSEKMSEncryptionContext) && {
            "x-amz-server-side-encryption-context": input.SSEKMSEncryptionContext
          }), isSerializableHeaderValue(input.Tagging) && {
            "x-amz-tagging": input.Tagging
          }), isSerializableHeaderValue(input.Expires) && {
            Expires: __dateToUtcString(input.Expires).toString()
          }), isSerializableHeaderValue(input.StorageClass) && {
            "x-amz-storage-class": input.StorageClass
          }), isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          }), isSerializableHeaderValue(input.ContentMD5) && {
            "Content-MD5": input.ContentMD5
          }), isSerializableHeaderValue(input.ServerSideEncryption) && {
            "x-amz-server-side-encryption": input.ServerSideEncryption
          }), isSerializableHeaderValue(input.ObjectLockMode) && {
            "x-amz-object-lock-mode": input.ObjectLockMode
          }), isSerializableHeaderValue(input.SSEKMSKeyId) && {
            "x-amz-server-side-encryption-aws-kms-key-id": input.SSEKMSKeyId
          }), isSerializableHeaderValue(input.ContentLanguage) && {
            "Content-Language": input.ContentLanguage
          }), isSerializableHeaderValue(input.GrantRead) && {
            "x-amz-grant-read": input.GrantRead
          }), isSerializableHeaderValue(input.ACL) && {
            "x-amz-acl": input.ACL
          }), isSerializableHeaderValue(input.ContentType) && {
            "Content-Type": input.ContentType
          }), input.Metadata !== undefined && Object.keys(input.Metadata).reduce(function (acc, suffix) {
            acc["x-amz-meta-" + suffix] = input.Metadata[suffix];
            return acc;
          }, {}));
          resolvedPath = "/{Bucket}/{Key+}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          if (input.Key !== undefined) {
            labelValue = input.Key;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Key.");
            }

            resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function (segment) {
              return __extendedEncodeURIComponent(segment);
            }).join("/"));
          } else {
            throw new Error("No value provided for input HTTP label: Key.");
          }

          query = {
            "x-id": "PutObject"
          };

          if (input.Body !== undefined) {
            contents = input.Body;
            body = contents;
          }

          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "PUT",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlPutObjectAclCommand = function serializeAws_restXmlPutObjectAclCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, labelValue, query, body, contents, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({
            "Content-Type": "application/xml"
          }, isSerializableHeaderValue(input.RequestPayer) && {
            "x-amz-request-payer": input.RequestPayer
          }), isSerializableHeaderValue(input.ACL) && {
            "x-amz-acl": input.ACL
          }), isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          }), isSerializableHeaderValue(input.ContentMD5) && {
            "Content-MD5": input.ContentMD5
          }), isSerializableHeaderValue(input.GrantFullControl) && {
            "x-amz-grant-full-control": input.GrantFullControl
          }), isSerializableHeaderValue(input.GrantReadACP) && {
            "x-amz-grant-read-acp": input.GrantReadACP
          }), isSerializableHeaderValue(input.GrantRead) && {
            "x-amz-grant-read": input.GrantRead
          }), isSerializableHeaderValue(input.GrantWrite) && {
            "x-amz-grant-write": input.GrantWrite
          }), isSerializableHeaderValue(input.GrantWriteACP) && {
            "x-amz-grant-write-acp": input.GrantWriteACP
          });
          resolvedPath = "/{Bucket}/{Key+}";

          if (input.Key !== undefined) {
            labelValue = input.Key;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Key.");
            }

            resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function (segment) {
              return __extendedEncodeURIComponent(segment);
            }).join("/"));
          } else {
            throw new Error("No value provided for input HTTP label: Key.");
          }

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          query = __assign({
            acl: ""
          }, input.VersionId !== undefined && {
            versionId: input.VersionId
          });

          if (input.AccessControlPolicy !== undefined) {
            contents = serializeAws_restXmlAccessControlPolicy(input.AccessControlPolicy, context);
            body = '<?xml version="1.0" encoding="UTF-8"?>';
            contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
            body += contents.toString();
          }

          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "PUT",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlPutObjectLegalHoldCommand = function serializeAws_restXmlPutObjectLegalHoldCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, labelValue, query, body, contents, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign(__assign(__assign({
            "Content-Type": "application/xml"
          }, isSerializableHeaderValue(input.ContentMD5) && {
            "Content-MD5": input.ContentMD5
          }), isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          }), isSerializableHeaderValue(input.RequestPayer) && {
            "x-amz-request-payer": input.RequestPayer
          });
          resolvedPath = "/{Bucket}/{Key+}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          if (input.Key !== undefined) {
            labelValue = input.Key;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Key.");
            }

            resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function (segment) {
              return __extendedEncodeURIComponent(segment);
            }).join("/"));
          } else {
            throw new Error("No value provided for input HTTP label: Key.");
          }

          query = __assign({
            "legal-hold": ""
          }, input.VersionId !== undefined && {
            versionId: input.VersionId
          });

          if (input.LegalHold !== undefined) {
            contents = serializeAws_restXmlObjectLockLegalHold(input.LegalHold, context);
            body = '<?xml version="1.0" encoding="UTF-8"?>';
            contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
            body += contents.toString();
          }

          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "PUT",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlPutObjectLockConfigurationCommand = function serializeAws_restXmlPutObjectLockConfigurationCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign(__assign(__assign(__assign({
            "Content-Type": "application/xml"
          }, isSerializableHeaderValue(input.Token) && {
            "x-amz-bucket-object-lock-token": input.Token
          }), isSerializableHeaderValue(input.RequestPayer) && {
            "x-amz-request-payer": input.RequestPayer
          }), isSerializableHeaderValue(input.ContentMD5) && {
            "Content-MD5": input.ContentMD5
          }), isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          });
          resolvedPath = "/{Bucket}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          query = {
            "object-lock": ""
          };

          if (input.ObjectLockConfiguration !== undefined) {
            contents = serializeAws_restXmlObjectLockConfiguration(input.ObjectLockConfiguration, context);
            body = '<?xml version="1.0" encoding="UTF-8"?>';
            contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
            body += contents.toString();
          }

          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "PUT",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlPutObjectRetentionCommand = function serializeAws_restXmlPutObjectRetentionCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, labelValue, query, body, contents, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign(__assign(__assign(__assign({
            "Content-Type": "application/xml"
          }, isSerializableHeaderValue(input.RequestPayer) && {
            "x-amz-request-payer": input.RequestPayer
          }), isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          }), isSerializableHeaderValue(input.BypassGovernanceRetention) && {
            "x-amz-bypass-governance-retention": input.BypassGovernanceRetention.toString()
          }), isSerializableHeaderValue(input.ContentMD5) && {
            "Content-MD5": input.ContentMD5
          });
          resolvedPath = "/{Bucket}/{Key+}";

          if (input.Key !== undefined) {
            labelValue = input.Key;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Key.");
            }

            resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function (segment) {
              return __extendedEncodeURIComponent(segment);
            }).join("/"));
          } else {
            throw new Error("No value provided for input HTTP label: Key.");
          }

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          query = __assign({
            retention: ""
          }, input.VersionId !== undefined && {
            versionId: input.VersionId
          });

          if (input.Retention !== undefined) {
            contents = serializeAws_restXmlObjectLockRetention(input.Retention, context);
            body = '<?xml version="1.0" encoding="UTF-8"?>';
            contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
            body += contents.toString();
          }

          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "PUT",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlPutObjectTaggingCommand = function serializeAws_restXmlPutObjectTaggingCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, labelValue, query, body, contents, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign(__assign({
            "Content-Type": "application/xml"
          }, isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          }), isSerializableHeaderValue(input.ContentMD5) && {
            "Content-MD5": input.ContentMD5
          });
          resolvedPath = "/{Bucket}/{Key+}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          if (input.Key !== undefined) {
            labelValue = input.Key;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Key.");
            }

            resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function (segment) {
              return __extendedEncodeURIComponent(segment);
            }).join("/"));
          } else {
            throw new Error("No value provided for input HTTP label: Key.");
          }

          query = __assign({
            tagging: ""
          }, input.VersionId !== undefined && {
            versionId: input.VersionId
          });

          if (input.Tagging !== undefined) {
            contents = serializeAws_restXmlTagging(input.Tagging, context);
            body = '<?xml version="1.0" encoding="UTF-8"?>';
            contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
            body += contents.toString();
          }

          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "PUT",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlPutPublicAccessBlockCommand = function serializeAws_restXmlPutPublicAccessBlockCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, query, body, contents, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign(__assign({
            "Content-Type": "application/xml"
          }, isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          }), isSerializableHeaderValue(input.ContentMD5) && {
            "Content-MD5": input.ContentMD5
          });
          resolvedPath = "/{Bucket}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          query = {
            publicAccessBlock: ""
          };

          if (input.PublicAccessBlockConfiguration !== undefined) {
            contents = serializeAws_restXmlPublicAccessBlockConfiguration(input.PublicAccessBlockConfiguration, context);
            body = '<?xml version="1.0" encoding="UTF-8"?>';
            contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
            body += contents.toString();
          }

          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "PUT",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlRestoreObjectCommand = function serializeAws_restXmlRestoreObjectCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, labelValue, query, body, contents, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign(__assign({
            "Content-Type": "application/xml"
          }, isSerializableHeaderValue(input.RequestPayer) && {
            "x-amz-request-payer": input.RequestPayer
          }), isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          });
          resolvedPath = "/{Bucket}/{Key+}";

          if (input.Key !== undefined) {
            labelValue = input.Key;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Key.");
            }

            resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function (segment) {
              return __extendedEncodeURIComponent(segment);
            }).join("/"));
          } else {
            throw new Error("No value provided for input HTTP label: Key.");
          }

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          query = __assign({
            restore: ""
          }, input.VersionId !== undefined && {
            versionId: input.VersionId
          });

          if (input.RestoreRequest !== undefined) {
            contents = serializeAws_restXmlRestoreRequest(input.RestoreRequest, context);
            body = '<?xml version="1.0" encoding="UTF-8"?>';
            contents.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");
            body += contents.toString();
          }

          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "POST",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlSelectObjectContentCommand = function serializeAws_restXmlSelectObjectContentCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, labelValue, query, body, bodyNode, node, node, node, node, node, node, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign(__assign(__assign(__assign({
            "Content-Type": "application/xml"
          }, isSerializableHeaderValue(input.SSECustomerAlgorithm) && {
            "x-amz-server-side-encryption-customer-algorithm": input.SSECustomerAlgorithm
          }), isSerializableHeaderValue(input.SSECustomerKey) && {
            "x-amz-server-side-encryption-customer-key": input.SSECustomerKey
          }), isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          }), isSerializableHeaderValue(input.SSECustomerKeyMD5) && {
            "x-amz-server-side-encryption-customer-key-MD5": input.SSECustomerKeyMD5
          });
          resolvedPath = "/{Bucket}/{Key+}";

          if (input.Key !== undefined) {
            labelValue = input.Key;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Key.");
            }

            resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function (segment) {
              return __extendedEncodeURIComponent(segment);
            }).join("/"));
          } else {
            throw new Error("No value provided for input HTTP label: Key.");
          }

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          query = {
            select: "",
            "select-type": "2"
          };
          body = '<?xml version="1.0" encoding="UTF-8"?>';
          bodyNode = new __XmlNode("SelectObjectContentRequest");
          bodyNode.addAttribute("xmlns", "http://s3.amazonaws.com/doc/2006-03-01/");

          if (input.Expression !== undefined) {
            node = new __XmlNode("Expression").addChildNode(new __XmlText(input.Expression)).withName("Expression");
            bodyNode.addChildNode(node);
          }

          if (input.ExpressionType !== undefined) {
            node = new __XmlNode("ExpressionType").addChildNode(new __XmlText(input.ExpressionType)).withName("ExpressionType");
            bodyNode.addChildNode(node);
          }

          if (input.InputSerialization !== undefined) {
            node = serializeAws_restXmlInputSerialization(input.InputSerialization, context).withName("InputSerialization");
            bodyNode.addChildNode(node);
          }

          if (input.OutputSerialization !== undefined) {
            node = serializeAws_restXmlOutputSerialization(input.OutputSerialization, context).withName("OutputSerialization");
            bodyNode.addChildNode(node);
          }

          if (input.RequestProgress !== undefined) {
            node = serializeAws_restXmlRequestProgress(input.RequestProgress, context).withName("RequestProgress");
            bodyNode.addChildNode(node);
          }

          if (input.ScanRange !== undefined) {
            node = serializeAws_restXmlScanRange(input.ScanRange, context).withName("ScanRange");
            bodyNode.addChildNode(node);
          }

          body += bodyNode.toString();
          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "POST",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlUploadPartCommand = function serializeAws_restXmlUploadPartCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, labelValue, query, body, contents, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign(__assign(__assign(__assign(__assign(__assign(__assign({
            "Content-Type": "application/octet-stream"
          }, isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          }), isSerializableHeaderValue(input.RequestPayer) && {
            "x-amz-request-payer": input.RequestPayer
          }), isSerializableHeaderValue(input.ContentLength) && {
            "Content-Length": input.ContentLength.toString()
          }), isSerializableHeaderValue(input.SSECustomerKey) && {
            "x-amz-server-side-encryption-customer-key": input.SSECustomerKey
          }), isSerializableHeaderValue(input.SSECustomerAlgorithm) && {
            "x-amz-server-side-encryption-customer-algorithm": input.SSECustomerAlgorithm
          }), isSerializableHeaderValue(input.SSECustomerKeyMD5) && {
            "x-amz-server-side-encryption-customer-key-MD5": input.SSECustomerKeyMD5
          }), isSerializableHeaderValue(input.ContentMD5) && {
            "Content-MD5": input.ContentMD5
          });
          resolvedPath = "/{Bucket}/{Key+}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          if (input.Key !== undefined) {
            labelValue = input.Key;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Key.");
            }

            resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function (segment) {
              return __extendedEncodeURIComponent(segment);
            }).join("/"));
          } else {
            throw new Error("No value provided for input HTTP label: Key.");
          }

          query = __assign(__assign({
            "x-id": "UploadPart"
          }, input.PartNumber !== undefined && {
            partNumber: input.PartNumber.toString()
          }), input.UploadId !== undefined && {
            uploadId: input.UploadId
          });

          if (input.Body !== undefined) {
            contents = input.Body;
            body = contents;
          }

          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "PUT",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var serializeAws_restXmlUploadPartCopyCommand = function serializeAws_restXmlUploadPartCopyCommand(input, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var headers, resolvedPath, labelValue, labelValue, query, body, _a, hostname, _b, protocol, port;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          headers = __assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign(__assign({
            "Content-Type": ""
          }, isSerializableHeaderValue(input.RequestPayer) && {
            "x-amz-request-payer": input.RequestPayer
          }), isSerializableHeaderValue(input.CopySourceRange) && {
            "x-amz-copy-source-range": input.CopySourceRange
          }), isSerializableHeaderValue(input.SSECustomerKey) && {
            "x-amz-server-side-encryption-customer-key": input.SSECustomerKey
          }), isSerializableHeaderValue(input.SSECustomerAlgorithm) && {
            "x-amz-server-side-encryption-customer-algorithm": input.SSECustomerAlgorithm
          }), isSerializableHeaderValue(input.CopySourceIfMatch) && {
            "x-amz-copy-source-if-match": input.CopySourceIfMatch
          }), isSerializableHeaderValue(input.ExpectedBucketOwner) && {
            "x-amz-expected-bucket-owner": input.ExpectedBucketOwner
          }), isSerializableHeaderValue(input.CopySourceSSECustomerKey) && {
            "x-amz-copy-source-server-side-encryption-customer-key": input.CopySourceSSECustomerKey
          }), isSerializableHeaderValue(input.CopySource) && {
            "x-amz-copy-source": input.CopySource
          }), isSerializableHeaderValue(input.CopySourceIfModifiedSince) && {
            "x-amz-copy-source-if-modified-since": __dateToUtcString(input.CopySourceIfModifiedSince).toString()
          }), isSerializableHeaderValue(input.CopySourceSSECustomerAlgorithm) && {
            "x-amz-copy-source-server-side-encryption-customer-algorithm": input.CopySourceSSECustomerAlgorithm
          }), isSerializableHeaderValue(input.CopySourceIfUnmodifiedSince) && {
            "x-amz-copy-source-if-unmodified-since": __dateToUtcString(input.CopySourceIfUnmodifiedSince).toString()
          }), isSerializableHeaderValue(input.ExpectedSourceBucketOwner) && {
            "x-amz-source-expected-bucket-owner": input.ExpectedSourceBucketOwner
          }), isSerializableHeaderValue(input.SSECustomerKeyMD5) && {
            "x-amz-server-side-encryption-customer-key-MD5": input.SSECustomerKeyMD5
          }), isSerializableHeaderValue(input.CopySourceIfNoneMatch) && {
            "x-amz-copy-source-if-none-match": input.CopySourceIfNoneMatch
          }), isSerializableHeaderValue(input.CopySourceSSECustomerKeyMD5) && {
            "x-amz-copy-source-server-side-encryption-customer-key-MD5": input.CopySourceSSECustomerKeyMD5
          });
          resolvedPath = "/{Bucket}/{Key+}";

          if (input.Bucket !== undefined) {
            labelValue = input.Bucket;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Bucket.");
            }

            resolvedPath = resolvedPath.replace("{Bucket}", __extendedEncodeURIComponent(labelValue));
          } else {
            throw new Error("No value provided for input HTTP label: Bucket.");
          }

          if (input.Key !== undefined) {
            labelValue = input.Key;

            if (labelValue.length <= 0) {
              throw new Error("Empty value provided for input HTTP label: Key.");
            }

            resolvedPath = resolvedPath.replace("{Key+}", labelValue.split("/").map(function (segment) {
              return __extendedEncodeURIComponent(segment);
            }).join("/"));
          } else {
            throw new Error("No value provided for input HTTP label: Key.");
          }

          query = __assign(__assign({
            "x-id": "UploadPartCopy"
          }, input.UploadId !== undefined && {
            uploadId: input.UploadId
          }), input.PartNumber !== undefined && {
            partNumber: input.PartNumber.toString()
          });
          return [4
          /*yield*/
          , context.endpoint()];

        case 1:
          _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
          return [2
          /*return*/
          , new __HttpRequest({
            protocol: protocol,
            hostname: hostname,
            port: port,
            method: "PUT",
            headers: headers,
            path: resolvedPath,
            query: query,
            body: body
          })];
      }
    });
  });
};
export var deserializeAws_restXmlAbortMultipartUploadCommand = function deserializeAws_restXmlAbortMultipartUploadCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 204 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlAbortMultipartUploadCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output),
            RequestCharged: undefined
          };

          if (output.headers["x-amz-request-charged"] !== undefined) {
            contents.RequestCharged = output.headers["x-amz-request-charged"];
          }

          return [4
          /*yield*/
          , collectBody(output.body, context)];

        case 1:
          _a.sent();

          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlAbortMultipartUploadCommandError = function deserializeAws_restXmlAbortMultipartUploadCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, _c, parsedBody, message;

    var _d;

    return __generator(this, function (_e) {
      switch (_e.label) {
        case 0:
          _a = [__assign({}, output)];
          _d = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_d.body = _e.sent(), _d)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);
          _b = errorCode;

          switch (_b) {
            case "NoSuchUpload":
              return [3
              /*break*/
              , 2];

            case "com.amazonaws.s3#NoSuchUpload":
              return [3
              /*break*/
              , 2];
          }

          return [3
          /*break*/
          , 4];

        case 2:
          _c = [{}];
          return [4
          /*yield*/
          , deserializeAws_restXmlNoSuchUploadResponse(parsedOutput, context)];

        case 3:
          response = __assign.apply(void 0, [__assign.apply(void 0, _c.concat([_e.sent()])), {
            name: errorCode,
            $metadata: deserializeMetadata(output)
          }]);
          return [3
          /*break*/
          , 5];

        case 4:
          parsedBody = parsedOutput.body;
          errorCode = parsedBody.code || parsedBody.Code || errorCode;
          response = __assign(__assign({}, parsedBody), {
            name: "" + errorCode,
            message: parsedBody.message || parsedBody.Message || errorCode,
            $fault: "client",
            $metadata: deserializeMetadata(output)
          });
          _e.label = 5;

        case 5:
          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlCompleteMultipartUploadCommand = function deserializeAws_restXmlCompleteMultipartUploadCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlCompleteMultipartUploadCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output),
            Bucket: undefined,
            ETag: undefined,
            Expiration: undefined,
            Key: undefined,
            Location: undefined,
            RequestCharged: undefined,
            SSEKMSKeyId: undefined,
            ServerSideEncryption: undefined,
            VersionId: undefined
          };

          if (output.headers["x-amz-expiration"] !== undefined) {
            contents.Expiration = output.headers["x-amz-expiration"];
          }

          if (output.headers["x-amz-server-side-encryption"] !== undefined) {
            contents.ServerSideEncryption = output.headers["x-amz-server-side-encryption"];
          }

          if (output.headers["x-amz-server-side-encryption-aws-kms-key-id"] !== undefined) {
            contents.SSEKMSKeyId = output.headers["x-amz-server-side-encryption-aws-kms-key-id"];
          }

          if (output.headers["x-amz-version-id"] !== undefined) {
            contents.VersionId = output.headers["x-amz-version-id"];
          }

          if (output.headers["x-amz-request-charged"] !== undefined) {
            contents.RequestCharged = output.headers["x-amz-request-charged"];
          }

          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          data = _a.sent();

          if (data["Bucket"] !== undefined) {
            contents.Bucket = data["Bucket"];
          }

          if (data["ETag"] !== undefined) {
            contents.ETag = data["ETag"];
          }

          if (data["Key"] !== undefined) {
            contents.Key = data["Key"];
          }

          if (data["Location"] !== undefined) {
            contents.Location = data["Location"];
          }

          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlCompleteMultipartUploadCommandError = function deserializeAws_restXmlCompleteMultipartUploadCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlCopyObjectCommand = function deserializeAws_restXmlCopyObjectCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlCopyObjectCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output),
            CopyObjectResult: undefined,
            CopySourceVersionId: undefined,
            Expiration: undefined,
            RequestCharged: undefined,
            SSECustomerAlgorithm: undefined,
            SSECustomerKeyMD5: undefined,
            SSEKMSEncryptionContext: undefined,
            SSEKMSKeyId: undefined,
            ServerSideEncryption: undefined,
            VersionId: undefined
          };

          if (output.headers["x-amz-server-side-encryption-customer-key-md5"] !== undefined) {
            contents.SSECustomerKeyMD5 = output.headers["x-amz-server-side-encryption-customer-key-md5"];
          }

          if (output.headers["x-amz-expiration"] !== undefined) {
            contents.Expiration = output.headers["x-amz-expiration"];
          }

          if (output.headers["x-amz-version-id"] !== undefined) {
            contents.VersionId = output.headers["x-amz-version-id"];
          }

          if (output.headers["x-amz-server-side-encryption-customer-algorithm"] !== undefined) {
            contents.SSECustomerAlgorithm = output.headers["x-amz-server-side-encryption-customer-algorithm"];
          }

          if (output.headers["x-amz-copy-source-version-id"] !== undefined) {
            contents.CopySourceVersionId = output.headers["x-amz-copy-source-version-id"];
          }

          if (output.headers["x-amz-server-side-encryption-context"] !== undefined) {
            contents.SSEKMSEncryptionContext = output.headers["x-amz-server-side-encryption-context"];
          }

          if (output.headers["x-amz-server-side-encryption"] !== undefined) {
            contents.ServerSideEncryption = output.headers["x-amz-server-side-encryption"];
          }

          if (output.headers["x-amz-request-charged"] !== undefined) {
            contents.RequestCharged = output.headers["x-amz-request-charged"];
          }

          if (output.headers["x-amz-server-side-encryption-aws-kms-key-id"] !== undefined) {
            contents.SSEKMSKeyId = output.headers["x-amz-server-side-encryption-aws-kms-key-id"];
          }

          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          data = _a.sent();
          contents.CopyObjectResult = deserializeAws_restXmlCopyObjectResult(data, context);
          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlCopyObjectCommandError = function deserializeAws_restXmlCopyObjectCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, _c, parsedBody, message;

    var _d;

    return __generator(this, function (_e) {
      switch (_e.label) {
        case 0:
          _a = [__assign({}, output)];
          _d = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_d.body = _e.sent(), _d)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);
          _b = errorCode;

          switch (_b) {
            case "ObjectNotInActiveTierError":
              return [3
              /*break*/
              , 2];

            case "com.amazonaws.s3#ObjectNotInActiveTierError":
              return [3
              /*break*/
              , 2];
          }

          return [3
          /*break*/
          , 4];

        case 2:
          _c = [{}];
          return [4
          /*yield*/
          , deserializeAws_restXmlObjectNotInActiveTierErrorResponse(parsedOutput, context)];

        case 3:
          response = __assign.apply(void 0, [__assign.apply(void 0, _c.concat([_e.sent()])), {
            name: errorCode,
            $metadata: deserializeMetadata(output)
          }]);
          return [3
          /*break*/
          , 5];

        case 4:
          parsedBody = parsedOutput.body;
          errorCode = parsedBody.code || parsedBody.Code || errorCode;
          response = __assign(__assign({}, parsedBody), {
            name: "" + errorCode,
            message: parsedBody.message || parsedBody.Message || errorCode,
            $fault: "client",
            $metadata: deserializeMetadata(output)
          });
          _e.label = 5;

        case 5:
          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlCreateBucketCommand = function deserializeAws_restXmlCreateBucketCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlCreateBucketCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output),
            Location: undefined
          };

          if (output.headers["location"] !== undefined) {
            contents.Location = output.headers["location"];
          }

          return [4
          /*yield*/
          , collectBody(output.body, context)];

        case 1:
          _a.sent();

          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlCreateBucketCommandError = function deserializeAws_restXmlCreateBucketCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, _c, _d, parsedBody, message;

    var _e;

    return __generator(this, function (_f) {
      switch (_f.label) {
        case 0:
          _a = [__assign({}, output)];
          _e = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_e.body = _f.sent(), _e)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);
          _b = errorCode;

          switch (_b) {
            case "BucketAlreadyExists":
              return [3
              /*break*/
              , 2];

            case "com.amazonaws.s3#BucketAlreadyExists":
              return [3
              /*break*/
              , 2];

            case "BucketAlreadyOwnedByYou":
              return [3
              /*break*/
              , 4];

            case "com.amazonaws.s3#BucketAlreadyOwnedByYou":
              return [3
              /*break*/
              , 4];
          }

          return [3
          /*break*/
          , 6];

        case 2:
          _c = [{}];
          return [4
          /*yield*/
          , deserializeAws_restXmlBucketAlreadyExistsResponse(parsedOutput, context)];

        case 3:
          response = __assign.apply(void 0, [__assign.apply(void 0, _c.concat([_f.sent()])), {
            name: errorCode,
            $metadata: deserializeMetadata(output)
          }]);
          return [3
          /*break*/
          , 7];

        case 4:
          _d = [{}];
          return [4
          /*yield*/
          , deserializeAws_restXmlBucketAlreadyOwnedByYouResponse(parsedOutput, context)];

        case 5:
          response = __assign.apply(void 0, [__assign.apply(void 0, _d.concat([_f.sent()])), {
            name: errorCode,
            $metadata: deserializeMetadata(output)
          }]);
          return [3
          /*break*/
          , 7];

        case 6:
          parsedBody = parsedOutput.body;
          errorCode = parsedBody.code || parsedBody.Code || errorCode;
          response = __assign(__assign({}, parsedBody), {
            name: "" + errorCode,
            message: parsedBody.message || parsedBody.Message || errorCode,
            $fault: "client",
            $metadata: deserializeMetadata(output)
          });
          _f.label = 7;

        case 7:
          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlCreateMultipartUploadCommand = function deserializeAws_restXmlCreateMultipartUploadCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlCreateMultipartUploadCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output),
            AbortDate: undefined,
            AbortRuleId: undefined,
            Bucket: undefined,
            Key: undefined,
            RequestCharged: undefined,
            SSECustomerAlgorithm: undefined,
            SSECustomerKeyMD5: undefined,
            SSEKMSEncryptionContext: undefined,
            SSEKMSKeyId: undefined,
            ServerSideEncryption: undefined,
            UploadId: undefined
          };

          if (output.headers["x-amz-server-side-encryption-context"] !== undefined) {
            contents.SSEKMSEncryptionContext = output.headers["x-amz-server-side-encryption-context"];
          }

          if (output.headers["x-amz-server-side-encryption"] !== undefined) {
            contents.ServerSideEncryption = output.headers["x-amz-server-side-encryption"];
          }

          if (output.headers["x-amz-request-charged"] !== undefined) {
            contents.RequestCharged = output.headers["x-amz-request-charged"];
          }

          if (output.headers["x-amz-abort-date"] !== undefined) {
            contents.AbortDate = new Date(output.headers["x-amz-abort-date"]);
          }

          if (output.headers["x-amz-server-side-encryption-customer-algorithm"] !== undefined) {
            contents.SSECustomerAlgorithm = output.headers["x-amz-server-side-encryption-customer-algorithm"];
          }

          if (output.headers["x-amz-server-side-encryption-aws-kms-key-id"] !== undefined) {
            contents.SSEKMSKeyId = output.headers["x-amz-server-side-encryption-aws-kms-key-id"];
          }

          if (output.headers["x-amz-abort-rule-id"] !== undefined) {
            contents.AbortRuleId = output.headers["x-amz-abort-rule-id"];
          }

          if (output.headers["x-amz-server-side-encryption-customer-key-md5"] !== undefined) {
            contents.SSECustomerKeyMD5 = output.headers["x-amz-server-side-encryption-customer-key-md5"];
          }

          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          data = _a.sent();

          if (data["Bucket"] !== undefined) {
            contents.Bucket = data["Bucket"];
          }

          if (data["Key"] !== undefined) {
            contents.Key = data["Key"];
          }

          if (data["UploadId"] !== undefined) {
            contents.UploadId = data["UploadId"];
          }

          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlCreateMultipartUploadCommandError = function deserializeAws_restXmlCreateMultipartUploadCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlDeleteBucketCommand = function deserializeAws_restXmlDeleteBucketCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 204 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlDeleteBucketCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output)
          };
          return [4
          /*yield*/
          , collectBody(output.body, context)];

        case 1:
          _a.sent();

          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlDeleteBucketCommandError = function deserializeAws_restXmlDeleteBucketCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlDeleteBucketAnalyticsConfigurationCommand = function deserializeAws_restXmlDeleteBucketAnalyticsConfigurationCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 204 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlDeleteBucketAnalyticsConfigurationCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output)
          };
          return [4
          /*yield*/
          , collectBody(output.body, context)];

        case 1:
          _a.sent();

          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlDeleteBucketAnalyticsConfigurationCommandError = function deserializeAws_restXmlDeleteBucketAnalyticsConfigurationCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlDeleteBucketCorsCommand = function deserializeAws_restXmlDeleteBucketCorsCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 204 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlDeleteBucketCorsCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output)
          };
          return [4
          /*yield*/
          , collectBody(output.body, context)];

        case 1:
          _a.sent();

          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlDeleteBucketCorsCommandError = function deserializeAws_restXmlDeleteBucketCorsCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlDeleteBucketEncryptionCommand = function deserializeAws_restXmlDeleteBucketEncryptionCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 204 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlDeleteBucketEncryptionCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output)
          };
          return [4
          /*yield*/
          , collectBody(output.body, context)];

        case 1:
          _a.sent();

          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlDeleteBucketEncryptionCommandError = function deserializeAws_restXmlDeleteBucketEncryptionCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlDeleteBucketInventoryConfigurationCommand = function deserializeAws_restXmlDeleteBucketInventoryConfigurationCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 204 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlDeleteBucketInventoryConfigurationCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output)
          };
          return [4
          /*yield*/
          , collectBody(output.body, context)];

        case 1:
          _a.sent();

          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlDeleteBucketInventoryConfigurationCommandError = function deserializeAws_restXmlDeleteBucketInventoryConfigurationCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlDeleteBucketLifecycleCommand = function deserializeAws_restXmlDeleteBucketLifecycleCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 204 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlDeleteBucketLifecycleCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output)
          };
          return [4
          /*yield*/
          , collectBody(output.body, context)];

        case 1:
          _a.sent();

          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlDeleteBucketLifecycleCommandError = function deserializeAws_restXmlDeleteBucketLifecycleCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlDeleteBucketMetricsConfigurationCommand = function deserializeAws_restXmlDeleteBucketMetricsConfigurationCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 204 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlDeleteBucketMetricsConfigurationCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output)
          };
          return [4
          /*yield*/
          , collectBody(output.body, context)];

        case 1:
          _a.sent();

          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlDeleteBucketMetricsConfigurationCommandError = function deserializeAws_restXmlDeleteBucketMetricsConfigurationCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlDeleteBucketOwnershipControlsCommand = function deserializeAws_restXmlDeleteBucketOwnershipControlsCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 204 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlDeleteBucketOwnershipControlsCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output)
          };
          return [4
          /*yield*/
          , collectBody(output.body, context)];

        case 1:
          _a.sent();

          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlDeleteBucketOwnershipControlsCommandError = function deserializeAws_restXmlDeleteBucketOwnershipControlsCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlDeleteBucketPolicyCommand = function deserializeAws_restXmlDeleteBucketPolicyCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 204 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlDeleteBucketPolicyCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output)
          };
          return [4
          /*yield*/
          , collectBody(output.body, context)];

        case 1:
          _a.sent();

          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlDeleteBucketPolicyCommandError = function deserializeAws_restXmlDeleteBucketPolicyCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlDeleteBucketReplicationCommand = function deserializeAws_restXmlDeleteBucketReplicationCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 204 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlDeleteBucketReplicationCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output)
          };
          return [4
          /*yield*/
          , collectBody(output.body, context)];

        case 1:
          _a.sent();

          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlDeleteBucketReplicationCommandError = function deserializeAws_restXmlDeleteBucketReplicationCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlDeleteBucketTaggingCommand = function deserializeAws_restXmlDeleteBucketTaggingCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 204 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlDeleteBucketTaggingCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output)
          };
          return [4
          /*yield*/
          , collectBody(output.body, context)];

        case 1:
          _a.sent();

          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlDeleteBucketTaggingCommandError = function deserializeAws_restXmlDeleteBucketTaggingCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlDeleteBucketWebsiteCommand = function deserializeAws_restXmlDeleteBucketWebsiteCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 204 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlDeleteBucketWebsiteCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output)
          };
          return [4
          /*yield*/
          , collectBody(output.body, context)];

        case 1:
          _a.sent();

          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlDeleteBucketWebsiteCommandError = function deserializeAws_restXmlDeleteBucketWebsiteCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlDeleteObjectCommand = function deserializeAws_restXmlDeleteObjectCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 204 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlDeleteObjectCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output),
            DeleteMarker: undefined,
            RequestCharged: undefined,
            VersionId: undefined
          };

          if (output.headers["x-amz-delete-marker"] !== undefined) {
            contents.DeleteMarker = output.headers["x-amz-delete-marker"] === "true";
          }

          if (output.headers["x-amz-request-charged"] !== undefined) {
            contents.RequestCharged = output.headers["x-amz-request-charged"];
          }

          if (output.headers["x-amz-version-id"] !== undefined) {
            contents.VersionId = output.headers["x-amz-version-id"];
          }

          return [4
          /*yield*/
          , collectBody(output.body, context)];

        case 1:
          _a.sent();

          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlDeleteObjectCommandError = function deserializeAws_restXmlDeleteObjectCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlDeleteObjectsCommand = function deserializeAws_restXmlDeleteObjectsCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlDeleteObjectsCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output),
            Deleted: undefined,
            Errors: undefined,
            RequestCharged: undefined
          };

          if (output.headers["x-amz-request-charged"] !== undefined) {
            contents.RequestCharged = output.headers["x-amz-request-charged"];
          }

          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          data = _a.sent();

          if (data.Deleted === "") {
            contents.Deleted = [];
          }

          if (data["Deleted"] !== undefined) {
            contents.Deleted = deserializeAws_restXmlDeletedObjects(__getArrayIfSingleItem(data["Deleted"]), context);
          }

          if (data.Error === "") {
            contents.Errors = [];
          }

          if (data["Error"] !== undefined) {
            contents.Errors = deserializeAws_restXmlErrors(__getArrayIfSingleItem(data["Error"]), context);
          }

          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlDeleteObjectsCommandError = function deserializeAws_restXmlDeleteObjectsCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlDeleteObjectTaggingCommand = function deserializeAws_restXmlDeleteObjectTaggingCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 204 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlDeleteObjectTaggingCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output),
            VersionId: undefined
          };

          if (output.headers["x-amz-version-id"] !== undefined) {
            contents.VersionId = output.headers["x-amz-version-id"];
          }

          return [4
          /*yield*/
          , collectBody(output.body, context)];

        case 1:
          _a.sent();

          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlDeleteObjectTaggingCommandError = function deserializeAws_restXmlDeleteObjectTaggingCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlDeletePublicAccessBlockCommand = function deserializeAws_restXmlDeletePublicAccessBlockCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 204 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlDeletePublicAccessBlockCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output)
          };
          return [4
          /*yield*/
          , collectBody(output.body, context)];

        case 1:
          _a.sent();

          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlDeletePublicAccessBlockCommandError = function deserializeAws_restXmlDeletePublicAccessBlockCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlGetBucketAccelerateConfigurationCommand = function deserializeAws_restXmlGetBucketAccelerateConfigurationCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlGetBucketAccelerateConfigurationCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output),
            Status: undefined
          };
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          data = _a.sent();

          if (data["Status"] !== undefined) {
            contents.Status = data["Status"];
          }

          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlGetBucketAccelerateConfigurationCommandError = function deserializeAws_restXmlGetBucketAccelerateConfigurationCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlGetBucketAclCommand = function deserializeAws_restXmlGetBucketAclCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlGetBucketAclCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output),
            Grants: undefined,
            Owner: undefined
          };
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          data = _a.sent();

          if (data.AccessControlList === "") {
            contents.Grants = [];
          }

          if (data["AccessControlList"] !== undefined && data["AccessControlList"]["Grant"] !== undefined) {
            contents.Grants = deserializeAws_restXmlGrants(__getArrayIfSingleItem(data["AccessControlList"]["Grant"]), context);
          }

          if (data["Owner"] !== undefined) {
            contents.Owner = deserializeAws_restXmlOwner(data["Owner"], context);
          }

          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlGetBucketAclCommandError = function deserializeAws_restXmlGetBucketAclCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlGetBucketAnalyticsConfigurationCommand = function deserializeAws_restXmlGetBucketAnalyticsConfigurationCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlGetBucketAnalyticsConfigurationCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output),
            AnalyticsConfiguration: undefined
          };
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          data = _a.sent();
          contents.AnalyticsConfiguration = deserializeAws_restXmlAnalyticsConfiguration(data, context);
          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlGetBucketAnalyticsConfigurationCommandError = function deserializeAws_restXmlGetBucketAnalyticsConfigurationCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlGetBucketCorsCommand = function deserializeAws_restXmlGetBucketCorsCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlGetBucketCorsCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output),
            CORSRules: undefined
          };
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          data = _a.sent();

          if (data.CORSRule === "") {
            contents.CORSRules = [];
          }

          if (data["CORSRule"] !== undefined) {
            contents.CORSRules = deserializeAws_restXmlCORSRules(__getArrayIfSingleItem(data["CORSRule"]), context);
          }

          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlGetBucketCorsCommandError = function deserializeAws_restXmlGetBucketCorsCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlGetBucketEncryptionCommand = function deserializeAws_restXmlGetBucketEncryptionCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlGetBucketEncryptionCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output),
            ServerSideEncryptionConfiguration: undefined
          };
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          data = _a.sent();
          contents.ServerSideEncryptionConfiguration = deserializeAws_restXmlServerSideEncryptionConfiguration(data, context);
          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlGetBucketEncryptionCommandError = function deserializeAws_restXmlGetBucketEncryptionCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlGetBucketInventoryConfigurationCommand = function deserializeAws_restXmlGetBucketInventoryConfigurationCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlGetBucketInventoryConfigurationCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output),
            InventoryConfiguration: undefined
          };
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          data = _a.sent();
          contents.InventoryConfiguration = deserializeAws_restXmlInventoryConfiguration(data, context);
          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlGetBucketInventoryConfigurationCommandError = function deserializeAws_restXmlGetBucketInventoryConfigurationCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlGetBucketLifecycleConfigurationCommand = function deserializeAws_restXmlGetBucketLifecycleConfigurationCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlGetBucketLifecycleConfigurationCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output),
            Rules: undefined
          };
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          data = _a.sent();

          if (data.Rule === "") {
            contents.Rules = [];
          }

          if (data["Rule"] !== undefined) {
            contents.Rules = deserializeAws_restXmlLifecycleRules(__getArrayIfSingleItem(data["Rule"]), context);
          }

          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlGetBucketLifecycleConfigurationCommandError = function deserializeAws_restXmlGetBucketLifecycleConfigurationCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlGetBucketLocationCommand = function deserializeAws_restXmlGetBucketLocationCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlGetBucketLocationCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output),
            LocationConstraint: undefined
          };
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          data = _a.sent();

          if (data["LocationConstraint"] !== undefined) {
            contents.LocationConstraint = data["LocationConstraint"];
          }

          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlGetBucketLocationCommandError = function deserializeAws_restXmlGetBucketLocationCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlGetBucketLoggingCommand = function deserializeAws_restXmlGetBucketLoggingCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlGetBucketLoggingCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output),
            LoggingEnabled: undefined
          };
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          data = _a.sent();

          if (data["LoggingEnabled"] !== undefined) {
            contents.LoggingEnabled = deserializeAws_restXmlLoggingEnabled(data["LoggingEnabled"], context);
          }

          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlGetBucketLoggingCommandError = function deserializeAws_restXmlGetBucketLoggingCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlGetBucketMetricsConfigurationCommand = function deserializeAws_restXmlGetBucketMetricsConfigurationCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlGetBucketMetricsConfigurationCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output),
            MetricsConfiguration: undefined
          };
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          data = _a.sent();
          contents.MetricsConfiguration = deserializeAws_restXmlMetricsConfiguration(data, context);
          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlGetBucketMetricsConfigurationCommandError = function deserializeAws_restXmlGetBucketMetricsConfigurationCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlGetBucketNotificationConfigurationCommand = function deserializeAws_restXmlGetBucketNotificationConfigurationCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlGetBucketNotificationConfigurationCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output),
            LambdaFunctionConfigurations: undefined,
            QueueConfigurations: undefined,
            TopicConfigurations: undefined
          };
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          data = _a.sent();

          if (data.CloudFunctionConfiguration === "") {
            contents.LambdaFunctionConfigurations = [];
          }

          if (data["CloudFunctionConfiguration"] !== undefined) {
            contents.LambdaFunctionConfigurations = deserializeAws_restXmlLambdaFunctionConfigurationList(__getArrayIfSingleItem(data["CloudFunctionConfiguration"]), context);
          }

          if (data.QueueConfiguration === "") {
            contents.QueueConfigurations = [];
          }

          if (data["QueueConfiguration"] !== undefined) {
            contents.QueueConfigurations = deserializeAws_restXmlQueueConfigurationList(__getArrayIfSingleItem(data["QueueConfiguration"]), context);
          }

          if (data.TopicConfiguration === "") {
            contents.TopicConfigurations = [];
          }

          if (data["TopicConfiguration"] !== undefined) {
            contents.TopicConfigurations = deserializeAws_restXmlTopicConfigurationList(__getArrayIfSingleItem(data["TopicConfiguration"]), context);
          }

          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlGetBucketNotificationConfigurationCommandError = function deserializeAws_restXmlGetBucketNotificationConfigurationCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlGetBucketOwnershipControlsCommand = function deserializeAws_restXmlGetBucketOwnershipControlsCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlGetBucketOwnershipControlsCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output),
            OwnershipControls: undefined
          };
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          data = _a.sent();
          contents.OwnershipControls = deserializeAws_restXmlOwnershipControls(data, context);
          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlGetBucketOwnershipControlsCommandError = function deserializeAws_restXmlGetBucketOwnershipControlsCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlGetBucketPolicyCommand = function deserializeAws_restXmlGetBucketPolicyCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlGetBucketPolicyCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output),
            Policy: undefined
          };
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          data = _a.sent();

          if (data["Policy"] !== undefined) {
            contents.Policy = data["Policy"];
          }

          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlGetBucketPolicyCommandError = function deserializeAws_restXmlGetBucketPolicyCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlGetBucketPolicyStatusCommand = function deserializeAws_restXmlGetBucketPolicyStatusCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlGetBucketPolicyStatusCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output),
            PolicyStatus: undefined
          };
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          data = _a.sent();
          contents.PolicyStatus = deserializeAws_restXmlPolicyStatus(data, context);
          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlGetBucketPolicyStatusCommandError = function deserializeAws_restXmlGetBucketPolicyStatusCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlGetBucketReplicationCommand = function deserializeAws_restXmlGetBucketReplicationCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlGetBucketReplicationCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output),
            ReplicationConfiguration: undefined
          };
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          data = _a.sent();
          contents.ReplicationConfiguration = deserializeAws_restXmlReplicationConfiguration(data, context);
          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlGetBucketReplicationCommandError = function deserializeAws_restXmlGetBucketReplicationCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlGetBucketRequestPaymentCommand = function deserializeAws_restXmlGetBucketRequestPaymentCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlGetBucketRequestPaymentCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output),
            Payer: undefined
          };
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          data = _a.sent();

          if (data["Payer"] !== undefined) {
            contents.Payer = data["Payer"];
          }

          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlGetBucketRequestPaymentCommandError = function deserializeAws_restXmlGetBucketRequestPaymentCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlGetBucketTaggingCommand = function deserializeAws_restXmlGetBucketTaggingCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlGetBucketTaggingCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output),
            TagSet: undefined
          };
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          data = _a.sent();

          if (data.TagSet === "") {
            contents.TagSet = [];
          }

          if (data["TagSet"] !== undefined && data["TagSet"]["Tag"] !== undefined) {
            contents.TagSet = deserializeAws_restXmlTagSet(__getArrayIfSingleItem(data["TagSet"]["Tag"]), context);
          }

          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlGetBucketTaggingCommandError = function deserializeAws_restXmlGetBucketTaggingCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlGetBucketVersioningCommand = function deserializeAws_restXmlGetBucketVersioningCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlGetBucketVersioningCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output),
            MFADelete: undefined,
            Status: undefined
          };
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          data = _a.sent();

          if (data["MfaDelete"] !== undefined) {
            contents.MFADelete = data["MfaDelete"];
          }

          if (data["Status"] !== undefined) {
            contents.Status = data["Status"];
          }

          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlGetBucketVersioningCommandError = function deserializeAws_restXmlGetBucketVersioningCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlGetBucketWebsiteCommand = function deserializeAws_restXmlGetBucketWebsiteCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlGetBucketWebsiteCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output),
            ErrorDocument: undefined,
            IndexDocument: undefined,
            RedirectAllRequestsTo: undefined,
            RoutingRules: undefined
          };
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          data = _a.sent();

          if (data["ErrorDocument"] !== undefined) {
            contents.ErrorDocument = deserializeAws_restXmlErrorDocument(data["ErrorDocument"], context);
          }

          if (data["IndexDocument"] !== undefined) {
            contents.IndexDocument = deserializeAws_restXmlIndexDocument(data["IndexDocument"], context);
          }

          if (data["RedirectAllRequestsTo"] !== undefined) {
            contents.RedirectAllRequestsTo = deserializeAws_restXmlRedirectAllRequestsTo(data["RedirectAllRequestsTo"], context);
          }

          if (data.RoutingRules === "") {
            contents.RoutingRules = [];
          }

          if (data["RoutingRules"] !== undefined && data["RoutingRules"]["RoutingRule"] !== undefined) {
            contents.RoutingRules = deserializeAws_restXmlRoutingRules(__getArrayIfSingleItem(data["RoutingRules"]["RoutingRule"]), context);
          }

          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlGetBucketWebsiteCommandError = function deserializeAws_restXmlGetBucketWebsiteCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlGetObjectCommand = function deserializeAws_restXmlGetObjectCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
      if (output.statusCode !== 200 && output.statusCode >= 300) {
        return [2
        /*return*/
        , deserializeAws_restXmlGetObjectCommandError(output, context)];
      }

      contents = {
        $metadata: deserializeMetadata(output),
        AcceptRanges: undefined,
        Body: undefined,
        CacheControl: undefined,
        ContentDisposition: undefined,
        ContentEncoding: undefined,
        ContentLanguage: undefined,
        ContentLength: undefined,
        ContentRange: undefined,
        ContentType: undefined,
        DeleteMarker: undefined,
        ETag: undefined,
        Expiration: undefined,
        Expires: undefined,
        LastModified: undefined,
        Metadata: undefined,
        MissingMeta: undefined,
        ObjectLockLegalHoldStatus: undefined,
        ObjectLockMode: undefined,
        ObjectLockRetainUntilDate: undefined,
        PartsCount: undefined,
        ReplicationStatus: undefined,
        RequestCharged: undefined,
        Restore: undefined,
        SSECustomerAlgorithm: undefined,
        SSECustomerKeyMD5: undefined,
        SSEKMSKeyId: undefined,
        ServerSideEncryption: undefined,
        StorageClass: undefined,
        TagCount: undefined,
        VersionId: undefined,
        WebsiteRedirectLocation: undefined
      };

      if (output.headers["x-amz-object-lock-mode"] !== undefined) {
        contents.ObjectLockMode = output.headers["x-amz-object-lock-mode"];
      }

      if (output.headers["content-language"] !== undefined) {
        contents.ContentLanguage = output.headers["content-language"];
      }

      if (output.headers["content-disposition"] !== undefined) {
        contents.ContentDisposition = output.headers["content-disposition"];
      }

      if (output.headers["cache-control"] !== undefined) {
        contents.CacheControl = output.headers["cache-control"];
      }

      if (output.headers["content-type"] !== undefined) {
        contents.ContentType = output.headers["content-type"];
      }

      if (output.headers["content-range"] !== undefined) {
        contents.ContentRange = output.headers["content-range"];
      }

      if (output.headers["x-amz-server-side-encryption-aws-kms-key-id"] !== undefined) {
        contents.SSEKMSKeyId = output.headers["x-amz-server-side-encryption-aws-kms-key-id"];
      }

      if (output.headers["content-length"] !== undefined) {
        contents.ContentLength = parseInt(output.headers["content-length"], 10);
      }

      if (output.headers["x-amz-object-lock-retain-until-date"] !== undefined) {
        contents.ObjectLockRetainUntilDate = new Date(output.headers["x-amz-object-lock-retain-until-date"]);
      }

      if (output.headers["x-amz-object-lock-legal-hold"] !== undefined) {
        contents.ObjectLockLegalHoldStatus = output.headers["x-amz-object-lock-legal-hold"];
      }

      if (output.headers["x-amz-delete-marker"] !== undefined) {
        contents.DeleteMarker = output.headers["x-amz-delete-marker"] === "true";
      }

      if (output.headers["x-amz-storage-class"] !== undefined) {
        contents.StorageClass = output.headers["x-amz-storage-class"];
      }

      if (output.headers["content-encoding"] !== undefined) {
        contents.ContentEncoding = output.headers["content-encoding"];
      }

      if (output.headers["x-amz-restore"] !== undefined) {
        contents.Restore = output.headers["x-amz-restore"];
      }

      if (output.headers["x-amz-website-redirect-location"] !== undefined) {
        contents.WebsiteRedirectLocation = output.headers["x-amz-website-redirect-location"];
      }

      if (output.headers["x-amz-server-side-encryption"] !== undefined) {
        contents.ServerSideEncryption = output.headers["x-amz-server-side-encryption"];
      }

      if (output.headers["x-amz-mp-parts-count"] !== undefined) {
        contents.PartsCount = parseInt(output.headers["x-amz-mp-parts-count"], 10);
      }

      if (output.headers["x-amz-server-side-encryption-customer-algorithm"] !== undefined) {
        contents.SSECustomerAlgorithm = output.headers["x-amz-server-side-encryption-customer-algorithm"];
      }

      if (output.headers["accept-ranges"] !== undefined) {
        contents.AcceptRanges = output.headers["accept-ranges"];
      }

      if (output.headers["x-amz-version-id"] !== undefined) {
        contents.VersionId = output.headers["x-amz-version-id"];
      }

      if (output.headers["expires"] !== undefined) {
        contents.Expires = new Date(output.headers["expires"]);
      }

      if (output.headers["x-amz-expiration"] !== undefined) {
        contents.Expiration = output.headers["x-amz-expiration"];
      }

      if (output.headers["x-amz-missing-meta"] !== undefined) {
        contents.MissingMeta = parseInt(output.headers["x-amz-missing-meta"], 10);
      }

      if (output.headers["x-amz-replication-status"] !== undefined) {
        contents.ReplicationStatus = output.headers["x-amz-replication-status"];
      }

      if (output.headers["x-amz-tagging-count"] !== undefined) {
        contents.TagCount = parseInt(output.headers["x-amz-tagging-count"], 10);
      }

      if (output.headers["x-amz-server-side-encryption-customer-key-md5"] !== undefined) {
        contents.SSECustomerKeyMD5 = output.headers["x-amz-server-side-encryption-customer-key-md5"];
      }

      if (output.headers["last-modified"] !== undefined) {
        contents.LastModified = new Date(output.headers["last-modified"]);
      }

      if (output.headers["etag"] !== undefined) {
        contents.ETag = output.headers["etag"];
      }

      if (output.headers["x-amz-request-charged"] !== undefined) {
        contents.RequestCharged = output.headers["x-amz-request-charged"];
      }

      Object.keys(output.headers).forEach(function (header) {
        if (contents.Metadata === undefined) {
          contents.Metadata = {};
        }

        if (header.startsWith("x-amz-meta-")) {
          contents.Metadata[header.substring(11)] = output.headers[header];
        }
      });
      data = output.body;
      contents.Body = data;
      return [2
      /*return*/
      , Promise.resolve(contents)];
    });
  });
};

var deserializeAws_restXmlGetObjectCommandError = function deserializeAws_restXmlGetObjectCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, _c, parsedBody, message;

    var _d;

    return __generator(this, function (_e) {
      switch (_e.label) {
        case 0:
          _a = [__assign({}, output)];
          _d = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_d.body = _e.sent(), _d)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);
          _b = errorCode;

          switch (_b) {
            case "NoSuchKey":
              return [3
              /*break*/
              , 2];

            case "com.amazonaws.s3#NoSuchKey":
              return [3
              /*break*/
              , 2];
          }

          return [3
          /*break*/
          , 4];

        case 2:
          _c = [{}];
          return [4
          /*yield*/
          , deserializeAws_restXmlNoSuchKeyResponse(parsedOutput, context)];

        case 3:
          response = __assign.apply(void 0, [__assign.apply(void 0, _c.concat([_e.sent()])), {
            name: errorCode,
            $metadata: deserializeMetadata(output)
          }]);
          return [3
          /*break*/
          , 5];

        case 4:
          parsedBody = parsedOutput.body;
          errorCode = parsedBody.code || parsedBody.Code || errorCode;
          response = __assign(__assign({}, parsedBody), {
            name: "" + errorCode,
            message: parsedBody.message || parsedBody.Message || errorCode,
            $fault: "client",
            $metadata: deserializeMetadata(output)
          });
          _e.label = 5;

        case 5:
          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlGetObjectAclCommand = function deserializeAws_restXmlGetObjectAclCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlGetObjectAclCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output),
            Grants: undefined,
            Owner: undefined,
            RequestCharged: undefined
          };

          if (output.headers["x-amz-request-charged"] !== undefined) {
            contents.RequestCharged = output.headers["x-amz-request-charged"];
          }

          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          data = _a.sent();

          if (data.AccessControlList === "") {
            contents.Grants = [];
          }

          if (data["AccessControlList"] !== undefined && data["AccessControlList"]["Grant"] !== undefined) {
            contents.Grants = deserializeAws_restXmlGrants(__getArrayIfSingleItem(data["AccessControlList"]["Grant"]), context);
          }

          if (data["Owner"] !== undefined) {
            contents.Owner = deserializeAws_restXmlOwner(data["Owner"], context);
          }

          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlGetObjectAclCommandError = function deserializeAws_restXmlGetObjectAclCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, _c, parsedBody, message;

    var _d;

    return __generator(this, function (_e) {
      switch (_e.label) {
        case 0:
          _a = [__assign({}, output)];
          _d = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_d.body = _e.sent(), _d)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);
          _b = errorCode;

          switch (_b) {
            case "NoSuchKey":
              return [3
              /*break*/
              , 2];

            case "com.amazonaws.s3#NoSuchKey":
              return [3
              /*break*/
              , 2];
          }

          return [3
          /*break*/
          , 4];

        case 2:
          _c = [{}];
          return [4
          /*yield*/
          , deserializeAws_restXmlNoSuchKeyResponse(parsedOutput, context)];

        case 3:
          response = __assign.apply(void 0, [__assign.apply(void 0, _c.concat([_e.sent()])), {
            name: errorCode,
            $metadata: deserializeMetadata(output)
          }]);
          return [3
          /*break*/
          , 5];

        case 4:
          parsedBody = parsedOutput.body;
          errorCode = parsedBody.code || parsedBody.Code || errorCode;
          response = __assign(__assign({}, parsedBody), {
            name: "" + errorCode,
            message: parsedBody.message || parsedBody.Message || errorCode,
            $fault: "client",
            $metadata: deserializeMetadata(output)
          });
          _e.label = 5;

        case 5:
          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlGetObjectLegalHoldCommand = function deserializeAws_restXmlGetObjectLegalHoldCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlGetObjectLegalHoldCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output),
            LegalHold: undefined
          };
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          data = _a.sent();
          contents.LegalHold = deserializeAws_restXmlObjectLockLegalHold(data, context);
          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlGetObjectLegalHoldCommandError = function deserializeAws_restXmlGetObjectLegalHoldCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlGetObjectLockConfigurationCommand = function deserializeAws_restXmlGetObjectLockConfigurationCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlGetObjectLockConfigurationCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output),
            ObjectLockConfiguration: undefined
          };
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          data = _a.sent();
          contents.ObjectLockConfiguration = deserializeAws_restXmlObjectLockConfiguration(data, context);
          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlGetObjectLockConfigurationCommandError = function deserializeAws_restXmlGetObjectLockConfigurationCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlGetObjectRetentionCommand = function deserializeAws_restXmlGetObjectRetentionCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlGetObjectRetentionCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output),
            Retention: undefined
          };
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          data = _a.sent();
          contents.Retention = deserializeAws_restXmlObjectLockRetention(data, context);
          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlGetObjectRetentionCommandError = function deserializeAws_restXmlGetObjectRetentionCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlGetObjectTaggingCommand = function deserializeAws_restXmlGetObjectTaggingCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlGetObjectTaggingCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output),
            TagSet: undefined,
            VersionId: undefined
          };

          if (output.headers["x-amz-version-id"] !== undefined) {
            contents.VersionId = output.headers["x-amz-version-id"];
          }

          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          data = _a.sent();

          if (data.TagSet === "") {
            contents.TagSet = [];
          }

          if (data["TagSet"] !== undefined && data["TagSet"]["Tag"] !== undefined) {
            contents.TagSet = deserializeAws_restXmlTagSet(__getArrayIfSingleItem(data["TagSet"]["Tag"]), context);
          }

          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlGetObjectTaggingCommandError = function deserializeAws_restXmlGetObjectTaggingCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlGetObjectTorrentCommand = function deserializeAws_restXmlGetObjectTorrentCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
      if (output.statusCode !== 200 && output.statusCode >= 300) {
        return [2
        /*return*/
        , deserializeAws_restXmlGetObjectTorrentCommandError(output, context)];
      }

      contents = {
        $metadata: deserializeMetadata(output),
        Body: undefined,
        RequestCharged: undefined
      };

      if (output.headers["x-amz-request-charged"] !== undefined) {
        contents.RequestCharged = output.headers["x-amz-request-charged"];
      }

      data = output.body;
      contents.Body = data;
      return [2
      /*return*/
      , Promise.resolve(contents)];
    });
  });
};

var deserializeAws_restXmlGetObjectTorrentCommandError = function deserializeAws_restXmlGetObjectTorrentCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlGetPublicAccessBlockCommand = function deserializeAws_restXmlGetPublicAccessBlockCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlGetPublicAccessBlockCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output),
            PublicAccessBlockConfiguration: undefined
          };
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          data = _a.sent();
          contents.PublicAccessBlockConfiguration = deserializeAws_restXmlPublicAccessBlockConfiguration(data, context);
          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlGetPublicAccessBlockCommandError = function deserializeAws_restXmlGetPublicAccessBlockCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlHeadBucketCommand = function deserializeAws_restXmlHeadBucketCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlHeadBucketCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output)
          };
          return [4
          /*yield*/
          , collectBody(output.body, context)];

        case 1:
          _a.sent();

          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlHeadBucketCommandError = function deserializeAws_restXmlHeadBucketCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, _c, parsedBody, message;

    var _d;

    return __generator(this, function (_e) {
      switch (_e.label) {
        case 0:
          _a = [__assign({}, output)];
          _d = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_d.body = _e.sent(), _d)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);
          _b = errorCode;

          switch (_b) {
            case "NoSuchBucket":
              return [3
              /*break*/
              , 2];

            case "com.amazonaws.s3#NoSuchBucket":
              return [3
              /*break*/
              , 2];
          }

          return [3
          /*break*/
          , 4];

        case 2:
          _c = [{}];
          return [4
          /*yield*/
          , deserializeAws_restXmlNoSuchBucketResponse(parsedOutput, context)];

        case 3:
          response = __assign.apply(void 0, [__assign.apply(void 0, _c.concat([_e.sent()])), {
            name: errorCode,
            $metadata: deserializeMetadata(output)
          }]);
          return [3
          /*break*/
          , 5];

        case 4:
          parsedBody = parsedOutput.body;
          errorCode = parsedBody.code || parsedBody.Code || errorCode;
          response = __assign(__assign({}, parsedBody), {
            name: "" + errorCode,
            message: parsedBody.message || parsedBody.Message || errorCode,
            $fault: "client",
            $metadata: deserializeMetadata(output)
          });
          _e.label = 5;

        case 5:
          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlHeadObjectCommand = function deserializeAws_restXmlHeadObjectCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlHeadObjectCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output),
            AcceptRanges: undefined,
            CacheControl: undefined,
            ContentDisposition: undefined,
            ContentEncoding: undefined,
            ContentLanguage: undefined,
            ContentLength: undefined,
            ContentType: undefined,
            DeleteMarker: undefined,
            ETag: undefined,
            Expiration: undefined,
            Expires: undefined,
            LastModified: undefined,
            Metadata: undefined,
            MissingMeta: undefined,
            ObjectLockLegalHoldStatus: undefined,
            ObjectLockMode: undefined,
            ObjectLockRetainUntilDate: undefined,
            PartsCount: undefined,
            ReplicationStatus: undefined,
            RequestCharged: undefined,
            Restore: undefined,
            SSECustomerAlgorithm: undefined,
            SSECustomerKeyMD5: undefined,
            SSEKMSKeyId: undefined,
            ServerSideEncryption: undefined,
            StorageClass: undefined,
            VersionId: undefined,
            WebsiteRedirectLocation: undefined
          };

          if (output.headers["cache-control"] !== undefined) {
            contents.CacheControl = output.headers["cache-control"];
          }

          if (output.headers["content-length"] !== undefined) {
            contents.ContentLength = parseInt(output.headers["content-length"], 10);
          }

          if (output.headers["x-amz-object-lock-retain-until-date"] !== undefined) {
            contents.ObjectLockRetainUntilDate = new Date(output.headers["x-amz-object-lock-retain-until-date"]);
          }

          if (output.headers["content-type"] !== undefined) {
            contents.ContentType = output.headers["content-type"];
          }

          if (output.headers["etag"] !== undefined) {
            contents.ETag = output.headers["etag"];
          }

          if (output.headers["content-disposition"] !== undefined) {
            contents.ContentDisposition = output.headers["content-disposition"];
          }

          if (output.headers["content-language"] !== undefined) {
            contents.ContentLanguage = output.headers["content-language"];
          }

          if (output.headers["x-amz-expiration"] !== undefined) {
            contents.Expiration = output.headers["x-amz-expiration"];
          }

          if (output.headers["expires"] !== undefined) {
            contents.Expires = new Date(output.headers["expires"]);
          }

          if (output.headers["x-amz-server-side-encryption-customer-key-md5"] !== undefined) {
            contents.SSECustomerKeyMD5 = output.headers["x-amz-server-side-encryption-customer-key-md5"];
          }

          if (output.headers["x-amz-replication-status"] !== undefined) {
            contents.ReplicationStatus = output.headers["x-amz-replication-status"];
          }

          if (output.headers["x-amz-object-lock-legal-hold"] !== undefined) {
            contents.ObjectLockLegalHoldStatus = output.headers["x-amz-object-lock-legal-hold"];
          }

          if (output.headers["x-amz-website-redirect-location"] !== undefined) {
            contents.WebsiteRedirectLocation = output.headers["x-amz-website-redirect-location"];
          }

          if (output.headers["x-amz-server-side-encryption"] !== undefined) {
            contents.ServerSideEncryption = output.headers["x-amz-server-side-encryption"];
          }

          if (output.headers["x-amz-version-id"] !== undefined) {
            contents.VersionId = output.headers["x-amz-version-id"];
          }

          if (output.headers["x-amz-server-side-encryption-customer-algorithm"] !== undefined) {
            contents.SSECustomerAlgorithm = output.headers["x-amz-server-side-encryption-customer-algorithm"];
          }

          if (output.headers["x-amz-mp-parts-count"] !== undefined) {
            contents.PartsCount = parseInt(output.headers["x-amz-mp-parts-count"], 10);
          }

          if (output.headers["x-amz-request-charged"] !== undefined) {
            contents.RequestCharged = output.headers["x-amz-request-charged"];
          }

          if (output.headers["last-modified"] !== undefined) {
            contents.LastModified = new Date(output.headers["last-modified"]);
          }

          if (output.headers["x-amz-missing-meta"] !== undefined) {
            contents.MissingMeta = parseInt(output.headers["x-amz-missing-meta"], 10);
          }

          if (output.headers["x-amz-restore"] !== undefined) {
            contents.Restore = output.headers["x-amz-restore"];
          }

          if (output.headers["content-encoding"] !== undefined) {
            contents.ContentEncoding = output.headers["content-encoding"];
          }

          if (output.headers["x-amz-storage-class"] !== undefined) {
            contents.StorageClass = output.headers["x-amz-storage-class"];
          }

          if (output.headers["x-amz-delete-marker"] !== undefined) {
            contents.DeleteMarker = output.headers["x-amz-delete-marker"] === "true";
          }

          if (output.headers["x-amz-object-lock-mode"] !== undefined) {
            contents.ObjectLockMode = output.headers["x-amz-object-lock-mode"];
          }

          if (output.headers["x-amz-server-side-encryption-aws-kms-key-id"] !== undefined) {
            contents.SSEKMSKeyId = output.headers["x-amz-server-side-encryption-aws-kms-key-id"];
          }

          if (output.headers["accept-ranges"] !== undefined) {
            contents.AcceptRanges = output.headers["accept-ranges"];
          }

          Object.keys(output.headers).forEach(function (header) {
            if (contents.Metadata === undefined) {
              contents.Metadata = {};
            }

            if (header.startsWith("x-amz-meta-")) {
              contents.Metadata[header.substring(11)] = output.headers[header];
            }
          });
          return [4
          /*yield*/
          , collectBody(output.body, context)];

        case 1:
          _a.sent();

          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlHeadObjectCommandError = function deserializeAws_restXmlHeadObjectCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, _c, parsedBody, message;

    var _d;

    return __generator(this, function (_e) {
      switch (_e.label) {
        case 0:
          _a = [__assign({}, output)];
          _d = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_d.body = _e.sent(), _d)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);
          _b = errorCode;

          switch (_b) {
            case "NoSuchKey":
              return [3
              /*break*/
              , 2];

            case "com.amazonaws.s3#NoSuchKey":
              return [3
              /*break*/
              , 2];
          }

          return [3
          /*break*/
          , 4];

        case 2:
          _c = [{}];
          return [4
          /*yield*/
          , deserializeAws_restXmlNoSuchKeyResponse(parsedOutput, context)];

        case 3:
          response = __assign.apply(void 0, [__assign.apply(void 0, _c.concat([_e.sent()])), {
            name: errorCode,
            $metadata: deserializeMetadata(output)
          }]);
          return [3
          /*break*/
          , 5];

        case 4:
          parsedBody = parsedOutput.body;
          errorCode = parsedBody.code || parsedBody.Code || errorCode;
          response = __assign(__assign({}, parsedBody), {
            name: "" + errorCode,
            message: parsedBody.message || parsedBody.Message || errorCode,
            $fault: "client",
            $metadata: deserializeMetadata(output)
          });
          _e.label = 5;

        case 5:
          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlListBucketAnalyticsConfigurationsCommand = function deserializeAws_restXmlListBucketAnalyticsConfigurationsCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlListBucketAnalyticsConfigurationsCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output),
            AnalyticsConfigurationList: undefined,
            ContinuationToken: undefined,
            IsTruncated: undefined,
            NextContinuationToken: undefined
          };
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          data = _a.sent();

          if (data.AnalyticsConfiguration === "") {
            contents.AnalyticsConfigurationList = [];
          }

          if (data["AnalyticsConfiguration"] !== undefined) {
            contents.AnalyticsConfigurationList = deserializeAws_restXmlAnalyticsConfigurationList(__getArrayIfSingleItem(data["AnalyticsConfiguration"]), context);
          }

          if (data["ContinuationToken"] !== undefined) {
            contents.ContinuationToken = data["ContinuationToken"];
          }

          if (data["IsTruncated"] !== undefined) {
            contents.IsTruncated = data["IsTruncated"] == "true";
          }

          if (data["NextContinuationToken"] !== undefined) {
            contents.NextContinuationToken = data["NextContinuationToken"];
          }

          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlListBucketAnalyticsConfigurationsCommandError = function deserializeAws_restXmlListBucketAnalyticsConfigurationsCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlListBucketInventoryConfigurationsCommand = function deserializeAws_restXmlListBucketInventoryConfigurationsCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlListBucketInventoryConfigurationsCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output),
            ContinuationToken: undefined,
            InventoryConfigurationList: undefined,
            IsTruncated: undefined,
            NextContinuationToken: undefined
          };
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          data = _a.sent();

          if (data["ContinuationToken"] !== undefined) {
            contents.ContinuationToken = data["ContinuationToken"];
          }

          if (data.InventoryConfiguration === "") {
            contents.InventoryConfigurationList = [];
          }

          if (data["InventoryConfiguration"] !== undefined) {
            contents.InventoryConfigurationList = deserializeAws_restXmlInventoryConfigurationList(__getArrayIfSingleItem(data["InventoryConfiguration"]), context);
          }

          if (data["IsTruncated"] !== undefined) {
            contents.IsTruncated = data["IsTruncated"] == "true";
          }

          if (data["NextContinuationToken"] !== undefined) {
            contents.NextContinuationToken = data["NextContinuationToken"];
          }

          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlListBucketInventoryConfigurationsCommandError = function deserializeAws_restXmlListBucketInventoryConfigurationsCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlListBucketMetricsConfigurationsCommand = function deserializeAws_restXmlListBucketMetricsConfigurationsCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlListBucketMetricsConfigurationsCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output),
            ContinuationToken: undefined,
            IsTruncated: undefined,
            MetricsConfigurationList: undefined,
            NextContinuationToken: undefined
          };
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          data = _a.sent();

          if (data["ContinuationToken"] !== undefined) {
            contents.ContinuationToken = data["ContinuationToken"];
          }

          if (data["IsTruncated"] !== undefined) {
            contents.IsTruncated = data["IsTruncated"] == "true";
          }

          if (data.MetricsConfiguration === "") {
            contents.MetricsConfigurationList = [];
          }

          if (data["MetricsConfiguration"] !== undefined) {
            contents.MetricsConfigurationList = deserializeAws_restXmlMetricsConfigurationList(__getArrayIfSingleItem(data["MetricsConfiguration"]), context);
          }

          if (data["NextContinuationToken"] !== undefined) {
            contents.NextContinuationToken = data["NextContinuationToken"];
          }

          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlListBucketMetricsConfigurationsCommandError = function deserializeAws_restXmlListBucketMetricsConfigurationsCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlListBucketsCommand = function deserializeAws_restXmlListBucketsCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlListBucketsCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output),
            Buckets: undefined,
            Owner: undefined
          };
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          data = _a.sent();

          if (data.Buckets === "") {
            contents.Buckets = [];
          }

          if (data["Buckets"] !== undefined && data["Buckets"]["Bucket"] !== undefined) {
            contents.Buckets = deserializeAws_restXmlBuckets(__getArrayIfSingleItem(data["Buckets"]["Bucket"]), context);
          }

          if (data["Owner"] !== undefined) {
            contents.Owner = deserializeAws_restXmlOwner(data["Owner"], context);
          }

          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlListBucketsCommandError = function deserializeAws_restXmlListBucketsCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlListMultipartUploadsCommand = function deserializeAws_restXmlListMultipartUploadsCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlListMultipartUploadsCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output),
            Bucket: undefined,
            CommonPrefixes: undefined,
            Delimiter: undefined,
            EncodingType: undefined,
            IsTruncated: undefined,
            KeyMarker: undefined,
            MaxUploads: undefined,
            NextKeyMarker: undefined,
            NextUploadIdMarker: undefined,
            Prefix: undefined,
            UploadIdMarker: undefined,
            Uploads: undefined
          };
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          data = _a.sent();

          if (data["Bucket"] !== undefined) {
            contents.Bucket = data["Bucket"];
          }

          if (data.CommonPrefixes === "") {
            contents.CommonPrefixes = [];
          }

          if (data["CommonPrefixes"] !== undefined) {
            contents.CommonPrefixes = deserializeAws_restXmlCommonPrefixList(__getArrayIfSingleItem(data["CommonPrefixes"]), context);
          }

          if (data["Delimiter"] !== undefined) {
            contents.Delimiter = data["Delimiter"];
          }

          if (data["EncodingType"] !== undefined) {
            contents.EncodingType = data["EncodingType"];
          }

          if (data["IsTruncated"] !== undefined) {
            contents.IsTruncated = data["IsTruncated"] == "true";
          }

          if (data["KeyMarker"] !== undefined) {
            contents.KeyMarker = data["KeyMarker"];
          }

          if (data["MaxUploads"] !== undefined) {
            contents.MaxUploads = parseInt(data["MaxUploads"]);
          }

          if (data["NextKeyMarker"] !== undefined) {
            contents.NextKeyMarker = data["NextKeyMarker"];
          }

          if (data["NextUploadIdMarker"] !== undefined) {
            contents.NextUploadIdMarker = data["NextUploadIdMarker"];
          }

          if (data["Prefix"] !== undefined) {
            contents.Prefix = data["Prefix"];
          }

          if (data["UploadIdMarker"] !== undefined) {
            contents.UploadIdMarker = data["UploadIdMarker"];
          }

          if (data.Upload === "") {
            contents.Uploads = [];
          }

          if (data["Upload"] !== undefined) {
            contents.Uploads = deserializeAws_restXmlMultipartUploadList(__getArrayIfSingleItem(data["Upload"]), context);
          }

          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlListMultipartUploadsCommandError = function deserializeAws_restXmlListMultipartUploadsCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlListObjectsCommand = function deserializeAws_restXmlListObjectsCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlListObjectsCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output),
            CommonPrefixes: undefined,
            Contents: undefined,
            Delimiter: undefined,
            EncodingType: undefined,
            IsTruncated: undefined,
            Marker: undefined,
            MaxKeys: undefined,
            Name: undefined,
            NextMarker: undefined,
            Prefix: undefined
          };
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          data = _a.sent();

          if (data.CommonPrefixes === "") {
            contents.CommonPrefixes = [];
          }

          if (data["CommonPrefixes"] !== undefined) {
            contents.CommonPrefixes = deserializeAws_restXmlCommonPrefixList(__getArrayIfSingleItem(data["CommonPrefixes"]), context);
          }

          if (data.Contents === "") {
            contents.Contents = [];
          }

          if (data["Contents"] !== undefined) {
            contents.Contents = deserializeAws_restXmlObjectList(__getArrayIfSingleItem(data["Contents"]), context);
          }

          if (data["Delimiter"] !== undefined) {
            contents.Delimiter = data["Delimiter"];
          }

          if (data["EncodingType"] !== undefined) {
            contents.EncodingType = data["EncodingType"];
          }

          if (data["IsTruncated"] !== undefined) {
            contents.IsTruncated = data["IsTruncated"] == "true";
          }

          if (data["Marker"] !== undefined) {
            contents.Marker = data["Marker"];
          }

          if (data["MaxKeys"] !== undefined) {
            contents.MaxKeys = parseInt(data["MaxKeys"]);
          }

          if (data["Name"] !== undefined) {
            contents.Name = data["Name"];
          }

          if (data["NextMarker"] !== undefined) {
            contents.NextMarker = data["NextMarker"];
          }

          if (data["Prefix"] !== undefined) {
            contents.Prefix = data["Prefix"];
          }

          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlListObjectsCommandError = function deserializeAws_restXmlListObjectsCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, _c, parsedBody, message;

    var _d;

    return __generator(this, function (_e) {
      switch (_e.label) {
        case 0:
          _a = [__assign({}, output)];
          _d = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_d.body = _e.sent(), _d)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);
          _b = errorCode;

          switch (_b) {
            case "NoSuchBucket":
              return [3
              /*break*/
              , 2];

            case "com.amazonaws.s3#NoSuchBucket":
              return [3
              /*break*/
              , 2];
          }

          return [3
          /*break*/
          , 4];

        case 2:
          _c = [{}];
          return [4
          /*yield*/
          , deserializeAws_restXmlNoSuchBucketResponse(parsedOutput, context)];

        case 3:
          response = __assign.apply(void 0, [__assign.apply(void 0, _c.concat([_e.sent()])), {
            name: errorCode,
            $metadata: deserializeMetadata(output)
          }]);
          return [3
          /*break*/
          , 5];

        case 4:
          parsedBody = parsedOutput.body;
          errorCode = parsedBody.code || parsedBody.Code || errorCode;
          response = __assign(__assign({}, parsedBody), {
            name: "" + errorCode,
            message: parsedBody.message || parsedBody.Message || errorCode,
            $fault: "client",
            $metadata: deserializeMetadata(output)
          });
          _e.label = 5;

        case 5:
          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlListObjectsV2Command = function deserializeAws_restXmlListObjectsV2Command(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlListObjectsV2CommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output),
            CommonPrefixes: undefined,
            Contents: undefined,
            ContinuationToken: undefined,
            Delimiter: undefined,
            EncodingType: undefined,
            IsTruncated: undefined,
            KeyCount: undefined,
            MaxKeys: undefined,
            Name: undefined,
            NextContinuationToken: undefined,
            Prefix: undefined,
            StartAfter: undefined
          };
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          data = _a.sent();

          if (data.CommonPrefixes === "") {
            contents.CommonPrefixes = [];
          }

          if (data["CommonPrefixes"] !== undefined) {
            contents.CommonPrefixes = deserializeAws_restXmlCommonPrefixList(__getArrayIfSingleItem(data["CommonPrefixes"]), context);
          }

          if (data.Contents === "") {
            contents.Contents = [];
          }

          if (data["Contents"] !== undefined) {
            contents.Contents = deserializeAws_restXmlObjectList(__getArrayIfSingleItem(data["Contents"]), context);
          }

          if (data["ContinuationToken"] !== undefined) {
            contents.ContinuationToken = data["ContinuationToken"];
          }

          if (data["Delimiter"] !== undefined) {
            contents.Delimiter = data["Delimiter"];
          }

          if (data["EncodingType"] !== undefined) {
            contents.EncodingType = data["EncodingType"];
          }

          if (data["IsTruncated"] !== undefined) {
            contents.IsTruncated = data["IsTruncated"] == "true";
          }

          if (data["KeyCount"] !== undefined) {
            contents.KeyCount = parseInt(data["KeyCount"]);
          }

          if (data["MaxKeys"] !== undefined) {
            contents.MaxKeys = parseInt(data["MaxKeys"]);
          }

          if (data["Name"] !== undefined) {
            contents.Name = data["Name"];
          }

          if (data["NextContinuationToken"] !== undefined) {
            contents.NextContinuationToken = data["NextContinuationToken"];
          }

          if (data["Prefix"] !== undefined) {
            contents.Prefix = data["Prefix"];
          }

          if (data["StartAfter"] !== undefined) {
            contents.StartAfter = data["StartAfter"];
          }

          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlListObjectsV2CommandError = function deserializeAws_restXmlListObjectsV2CommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, _c, parsedBody, message;

    var _d;

    return __generator(this, function (_e) {
      switch (_e.label) {
        case 0:
          _a = [__assign({}, output)];
          _d = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_d.body = _e.sent(), _d)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);
          _b = errorCode;

          switch (_b) {
            case "NoSuchBucket":
              return [3
              /*break*/
              , 2];

            case "com.amazonaws.s3#NoSuchBucket":
              return [3
              /*break*/
              , 2];
          }

          return [3
          /*break*/
          , 4];

        case 2:
          _c = [{}];
          return [4
          /*yield*/
          , deserializeAws_restXmlNoSuchBucketResponse(parsedOutput, context)];

        case 3:
          response = __assign.apply(void 0, [__assign.apply(void 0, _c.concat([_e.sent()])), {
            name: errorCode,
            $metadata: deserializeMetadata(output)
          }]);
          return [3
          /*break*/
          , 5];

        case 4:
          parsedBody = parsedOutput.body;
          errorCode = parsedBody.code || parsedBody.Code || errorCode;
          response = __assign(__assign({}, parsedBody), {
            name: "" + errorCode,
            message: parsedBody.message || parsedBody.Message || errorCode,
            $fault: "client",
            $metadata: deserializeMetadata(output)
          });
          _e.label = 5;

        case 5:
          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlListObjectVersionsCommand = function deserializeAws_restXmlListObjectVersionsCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlListObjectVersionsCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output),
            CommonPrefixes: undefined,
            DeleteMarkers: undefined,
            Delimiter: undefined,
            EncodingType: undefined,
            IsTruncated: undefined,
            KeyMarker: undefined,
            MaxKeys: undefined,
            Name: undefined,
            NextKeyMarker: undefined,
            NextVersionIdMarker: undefined,
            Prefix: undefined,
            VersionIdMarker: undefined,
            Versions: undefined
          };
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          data = _a.sent();

          if (data.CommonPrefixes === "") {
            contents.CommonPrefixes = [];
          }

          if (data["CommonPrefixes"] !== undefined) {
            contents.CommonPrefixes = deserializeAws_restXmlCommonPrefixList(__getArrayIfSingleItem(data["CommonPrefixes"]), context);
          }

          if (data.DeleteMarker === "") {
            contents.DeleteMarkers = [];
          }

          if (data["DeleteMarker"] !== undefined) {
            contents.DeleteMarkers = deserializeAws_restXmlDeleteMarkers(__getArrayIfSingleItem(data["DeleteMarker"]), context);
          }

          if (data["Delimiter"] !== undefined) {
            contents.Delimiter = data["Delimiter"];
          }

          if (data["EncodingType"] !== undefined) {
            contents.EncodingType = data["EncodingType"];
          }

          if (data["IsTruncated"] !== undefined) {
            contents.IsTruncated = data["IsTruncated"] == "true";
          }

          if (data["KeyMarker"] !== undefined) {
            contents.KeyMarker = data["KeyMarker"];
          }

          if (data["MaxKeys"] !== undefined) {
            contents.MaxKeys = parseInt(data["MaxKeys"]);
          }

          if (data["Name"] !== undefined) {
            contents.Name = data["Name"];
          }

          if (data["NextKeyMarker"] !== undefined) {
            contents.NextKeyMarker = data["NextKeyMarker"];
          }

          if (data["NextVersionIdMarker"] !== undefined) {
            contents.NextVersionIdMarker = data["NextVersionIdMarker"];
          }

          if (data["Prefix"] !== undefined) {
            contents.Prefix = data["Prefix"];
          }

          if (data["VersionIdMarker"] !== undefined) {
            contents.VersionIdMarker = data["VersionIdMarker"];
          }

          if (data.Version === "") {
            contents.Versions = [];
          }

          if (data["Version"] !== undefined) {
            contents.Versions = deserializeAws_restXmlObjectVersionList(__getArrayIfSingleItem(data["Version"]), context);
          }

          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlListObjectVersionsCommandError = function deserializeAws_restXmlListObjectVersionsCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlListPartsCommand = function deserializeAws_restXmlListPartsCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlListPartsCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output),
            AbortDate: undefined,
            AbortRuleId: undefined,
            Bucket: undefined,
            Initiator: undefined,
            IsTruncated: undefined,
            Key: undefined,
            MaxParts: undefined,
            NextPartNumberMarker: undefined,
            Owner: undefined,
            PartNumberMarker: undefined,
            Parts: undefined,
            RequestCharged: undefined,
            StorageClass: undefined,
            UploadId: undefined
          };

          if (output.headers["x-amz-abort-rule-id"] !== undefined) {
            contents.AbortRuleId = output.headers["x-amz-abort-rule-id"];
          }

          if (output.headers["x-amz-request-charged"] !== undefined) {
            contents.RequestCharged = output.headers["x-amz-request-charged"];
          }

          if (output.headers["x-amz-abort-date"] !== undefined) {
            contents.AbortDate = new Date(output.headers["x-amz-abort-date"]);
          }

          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          data = _a.sent();

          if (data["Bucket"] !== undefined) {
            contents.Bucket = data["Bucket"];
          }

          if (data["Initiator"] !== undefined) {
            contents.Initiator = deserializeAws_restXmlInitiator(data["Initiator"], context);
          }

          if (data["IsTruncated"] !== undefined) {
            contents.IsTruncated = data["IsTruncated"] == "true";
          }

          if (data["Key"] !== undefined) {
            contents.Key = data["Key"];
          }

          if (data["MaxParts"] !== undefined) {
            contents.MaxParts = parseInt(data["MaxParts"]);
          }

          if (data["NextPartNumberMarker"] !== undefined) {
            contents.NextPartNumberMarker = parseInt(data["NextPartNumberMarker"]);
          }

          if (data["Owner"] !== undefined) {
            contents.Owner = deserializeAws_restXmlOwner(data["Owner"], context);
          }

          if (data["PartNumberMarker"] !== undefined) {
            contents.PartNumberMarker = parseInt(data["PartNumberMarker"]);
          }

          if (data.Part === "") {
            contents.Parts = [];
          }

          if (data["Part"] !== undefined) {
            contents.Parts = deserializeAws_restXmlParts(__getArrayIfSingleItem(data["Part"]), context);
          }

          if (data["StorageClass"] !== undefined) {
            contents.StorageClass = data["StorageClass"];
          }

          if (data["UploadId"] !== undefined) {
            contents.UploadId = data["UploadId"];
          }

          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlListPartsCommandError = function deserializeAws_restXmlListPartsCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlPutBucketAccelerateConfigurationCommand = function deserializeAws_restXmlPutBucketAccelerateConfigurationCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlPutBucketAccelerateConfigurationCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output)
          };
          return [4
          /*yield*/
          , collectBody(output.body, context)];

        case 1:
          _a.sent();

          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlPutBucketAccelerateConfigurationCommandError = function deserializeAws_restXmlPutBucketAccelerateConfigurationCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlPutBucketAclCommand = function deserializeAws_restXmlPutBucketAclCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlPutBucketAclCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output)
          };
          return [4
          /*yield*/
          , collectBody(output.body, context)];

        case 1:
          _a.sent();

          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlPutBucketAclCommandError = function deserializeAws_restXmlPutBucketAclCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlPutBucketAnalyticsConfigurationCommand = function deserializeAws_restXmlPutBucketAnalyticsConfigurationCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlPutBucketAnalyticsConfigurationCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output)
          };
          return [4
          /*yield*/
          , collectBody(output.body, context)];

        case 1:
          _a.sent();

          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlPutBucketAnalyticsConfigurationCommandError = function deserializeAws_restXmlPutBucketAnalyticsConfigurationCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlPutBucketCorsCommand = function deserializeAws_restXmlPutBucketCorsCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlPutBucketCorsCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output)
          };
          return [4
          /*yield*/
          , collectBody(output.body, context)];

        case 1:
          _a.sent();

          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlPutBucketCorsCommandError = function deserializeAws_restXmlPutBucketCorsCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlPutBucketEncryptionCommand = function deserializeAws_restXmlPutBucketEncryptionCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlPutBucketEncryptionCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output)
          };
          return [4
          /*yield*/
          , collectBody(output.body, context)];

        case 1:
          _a.sent();

          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlPutBucketEncryptionCommandError = function deserializeAws_restXmlPutBucketEncryptionCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlPutBucketInventoryConfigurationCommand = function deserializeAws_restXmlPutBucketInventoryConfigurationCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlPutBucketInventoryConfigurationCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output)
          };
          return [4
          /*yield*/
          , collectBody(output.body, context)];

        case 1:
          _a.sent();

          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlPutBucketInventoryConfigurationCommandError = function deserializeAws_restXmlPutBucketInventoryConfigurationCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlPutBucketLifecycleConfigurationCommand = function deserializeAws_restXmlPutBucketLifecycleConfigurationCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlPutBucketLifecycleConfigurationCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output)
          };
          return [4
          /*yield*/
          , collectBody(output.body, context)];

        case 1:
          _a.sent();

          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlPutBucketLifecycleConfigurationCommandError = function deserializeAws_restXmlPutBucketLifecycleConfigurationCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlPutBucketLoggingCommand = function deserializeAws_restXmlPutBucketLoggingCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlPutBucketLoggingCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output)
          };
          return [4
          /*yield*/
          , collectBody(output.body, context)];

        case 1:
          _a.sent();

          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlPutBucketLoggingCommandError = function deserializeAws_restXmlPutBucketLoggingCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlPutBucketMetricsConfigurationCommand = function deserializeAws_restXmlPutBucketMetricsConfigurationCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlPutBucketMetricsConfigurationCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output)
          };
          return [4
          /*yield*/
          , collectBody(output.body, context)];

        case 1:
          _a.sent();

          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlPutBucketMetricsConfigurationCommandError = function deserializeAws_restXmlPutBucketMetricsConfigurationCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlPutBucketNotificationConfigurationCommand = function deserializeAws_restXmlPutBucketNotificationConfigurationCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlPutBucketNotificationConfigurationCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output)
          };
          return [4
          /*yield*/
          , collectBody(output.body, context)];

        case 1:
          _a.sent();

          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlPutBucketNotificationConfigurationCommandError = function deserializeAws_restXmlPutBucketNotificationConfigurationCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlPutBucketOwnershipControlsCommand = function deserializeAws_restXmlPutBucketOwnershipControlsCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlPutBucketOwnershipControlsCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output)
          };
          return [4
          /*yield*/
          , collectBody(output.body, context)];

        case 1:
          _a.sent();

          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlPutBucketOwnershipControlsCommandError = function deserializeAws_restXmlPutBucketOwnershipControlsCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlPutBucketPolicyCommand = function deserializeAws_restXmlPutBucketPolicyCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlPutBucketPolicyCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output)
          };
          return [4
          /*yield*/
          , collectBody(output.body, context)];

        case 1:
          _a.sent();

          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlPutBucketPolicyCommandError = function deserializeAws_restXmlPutBucketPolicyCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlPutBucketReplicationCommand = function deserializeAws_restXmlPutBucketReplicationCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlPutBucketReplicationCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output)
          };
          return [4
          /*yield*/
          , collectBody(output.body, context)];

        case 1:
          _a.sent();

          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlPutBucketReplicationCommandError = function deserializeAws_restXmlPutBucketReplicationCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlPutBucketRequestPaymentCommand = function deserializeAws_restXmlPutBucketRequestPaymentCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlPutBucketRequestPaymentCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output)
          };
          return [4
          /*yield*/
          , collectBody(output.body, context)];

        case 1:
          _a.sent();

          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlPutBucketRequestPaymentCommandError = function deserializeAws_restXmlPutBucketRequestPaymentCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlPutBucketTaggingCommand = function deserializeAws_restXmlPutBucketTaggingCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlPutBucketTaggingCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output)
          };
          return [4
          /*yield*/
          , collectBody(output.body, context)];

        case 1:
          _a.sent();

          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlPutBucketTaggingCommandError = function deserializeAws_restXmlPutBucketTaggingCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlPutBucketVersioningCommand = function deserializeAws_restXmlPutBucketVersioningCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlPutBucketVersioningCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output)
          };
          return [4
          /*yield*/
          , collectBody(output.body, context)];

        case 1:
          _a.sent();

          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlPutBucketVersioningCommandError = function deserializeAws_restXmlPutBucketVersioningCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlPutBucketWebsiteCommand = function deserializeAws_restXmlPutBucketWebsiteCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlPutBucketWebsiteCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output)
          };
          return [4
          /*yield*/
          , collectBody(output.body, context)];

        case 1:
          _a.sent();

          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlPutBucketWebsiteCommandError = function deserializeAws_restXmlPutBucketWebsiteCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlPutObjectCommand = function deserializeAws_restXmlPutObjectCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlPutObjectCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output),
            ETag: undefined,
            Expiration: undefined,
            RequestCharged: undefined,
            SSECustomerAlgorithm: undefined,
            SSECustomerKeyMD5: undefined,
            SSEKMSEncryptionContext: undefined,
            SSEKMSKeyId: undefined,
            ServerSideEncryption: undefined,
            VersionId: undefined
          };

          if (output.headers["x-amz-server-side-encryption-context"] !== undefined) {
            contents.SSEKMSEncryptionContext = output.headers["x-amz-server-side-encryption-context"];
          }

          if (output.headers["x-amz-expiration"] !== undefined) {
            contents.Expiration = output.headers["x-amz-expiration"];
          }

          if (output.headers["x-amz-server-side-encryption-customer-key-md5"] !== undefined) {
            contents.SSECustomerKeyMD5 = output.headers["x-amz-server-side-encryption-customer-key-md5"];
          }

          if (output.headers["etag"] !== undefined) {
            contents.ETag = output.headers["etag"];
          }

          if (output.headers["x-amz-server-side-encryption-customer-algorithm"] !== undefined) {
            contents.SSECustomerAlgorithm = output.headers["x-amz-server-side-encryption-customer-algorithm"];
          }

          if (output.headers["x-amz-version-id"] !== undefined) {
            contents.VersionId = output.headers["x-amz-version-id"];
          }

          if (output.headers["x-amz-request-charged"] !== undefined) {
            contents.RequestCharged = output.headers["x-amz-request-charged"];
          }

          if (output.headers["x-amz-server-side-encryption-aws-kms-key-id"] !== undefined) {
            contents.SSEKMSKeyId = output.headers["x-amz-server-side-encryption-aws-kms-key-id"];
          }

          if (output.headers["x-amz-server-side-encryption"] !== undefined) {
            contents.ServerSideEncryption = output.headers["x-amz-server-side-encryption"];
          }

          return [4
          /*yield*/
          , collectBody(output.body, context)];

        case 1:
          _a.sent();

          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlPutObjectCommandError = function deserializeAws_restXmlPutObjectCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlPutObjectAclCommand = function deserializeAws_restXmlPutObjectAclCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlPutObjectAclCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output),
            RequestCharged: undefined
          };

          if (output.headers["x-amz-request-charged"] !== undefined) {
            contents.RequestCharged = output.headers["x-amz-request-charged"];
          }

          return [4
          /*yield*/
          , collectBody(output.body, context)];

        case 1:
          _a.sent();

          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlPutObjectAclCommandError = function deserializeAws_restXmlPutObjectAclCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, _c, parsedBody, message;

    var _d;

    return __generator(this, function (_e) {
      switch (_e.label) {
        case 0:
          _a = [__assign({}, output)];
          _d = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_d.body = _e.sent(), _d)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);
          _b = errorCode;

          switch (_b) {
            case "NoSuchKey":
              return [3
              /*break*/
              , 2];

            case "com.amazonaws.s3#NoSuchKey":
              return [3
              /*break*/
              , 2];
          }

          return [3
          /*break*/
          , 4];

        case 2:
          _c = [{}];
          return [4
          /*yield*/
          , deserializeAws_restXmlNoSuchKeyResponse(parsedOutput, context)];

        case 3:
          response = __assign.apply(void 0, [__assign.apply(void 0, _c.concat([_e.sent()])), {
            name: errorCode,
            $metadata: deserializeMetadata(output)
          }]);
          return [3
          /*break*/
          , 5];

        case 4:
          parsedBody = parsedOutput.body;
          errorCode = parsedBody.code || parsedBody.Code || errorCode;
          response = __assign(__assign({}, parsedBody), {
            name: "" + errorCode,
            message: parsedBody.message || parsedBody.Message || errorCode,
            $fault: "client",
            $metadata: deserializeMetadata(output)
          });
          _e.label = 5;

        case 5:
          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlPutObjectLegalHoldCommand = function deserializeAws_restXmlPutObjectLegalHoldCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlPutObjectLegalHoldCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output),
            RequestCharged: undefined
          };

          if (output.headers["x-amz-request-charged"] !== undefined) {
            contents.RequestCharged = output.headers["x-amz-request-charged"];
          }

          return [4
          /*yield*/
          , collectBody(output.body, context)];

        case 1:
          _a.sent();

          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlPutObjectLegalHoldCommandError = function deserializeAws_restXmlPutObjectLegalHoldCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlPutObjectLockConfigurationCommand = function deserializeAws_restXmlPutObjectLockConfigurationCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlPutObjectLockConfigurationCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output),
            RequestCharged: undefined
          };

          if (output.headers["x-amz-request-charged"] !== undefined) {
            contents.RequestCharged = output.headers["x-amz-request-charged"];
          }

          return [4
          /*yield*/
          , collectBody(output.body, context)];

        case 1:
          _a.sent();

          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlPutObjectLockConfigurationCommandError = function deserializeAws_restXmlPutObjectLockConfigurationCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlPutObjectRetentionCommand = function deserializeAws_restXmlPutObjectRetentionCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlPutObjectRetentionCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output),
            RequestCharged: undefined
          };

          if (output.headers["x-amz-request-charged"] !== undefined) {
            contents.RequestCharged = output.headers["x-amz-request-charged"];
          }

          return [4
          /*yield*/
          , collectBody(output.body, context)];

        case 1:
          _a.sent();

          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlPutObjectRetentionCommandError = function deserializeAws_restXmlPutObjectRetentionCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlPutObjectTaggingCommand = function deserializeAws_restXmlPutObjectTaggingCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlPutObjectTaggingCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output),
            VersionId: undefined
          };

          if (output.headers["x-amz-version-id"] !== undefined) {
            contents.VersionId = output.headers["x-amz-version-id"];
          }

          return [4
          /*yield*/
          , collectBody(output.body, context)];

        case 1:
          _a.sent();

          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlPutObjectTaggingCommandError = function deserializeAws_restXmlPutObjectTaggingCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlPutPublicAccessBlockCommand = function deserializeAws_restXmlPutPublicAccessBlockCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlPutPublicAccessBlockCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output)
          };
          return [4
          /*yield*/
          , collectBody(output.body, context)];

        case 1:
          _a.sent();

          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlPutPublicAccessBlockCommandError = function deserializeAws_restXmlPutPublicAccessBlockCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlRestoreObjectCommand = function deserializeAws_restXmlRestoreObjectCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlRestoreObjectCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output),
            RequestCharged: undefined,
            RestoreOutputPath: undefined
          };

          if (output.headers["x-amz-request-charged"] !== undefined) {
            contents.RequestCharged = output.headers["x-amz-request-charged"];
          }

          if (output.headers["x-amz-restore-output-path"] !== undefined) {
            contents.RestoreOutputPath = output.headers["x-amz-restore-output-path"];
          }

          return [4
          /*yield*/
          , collectBody(output.body, context)];

        case 1:
          _a.sent();

          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlRestoreObjectCommandError = function deserializeAws_restXmlRestoreObjectCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, _c, parsedBody, message;

    var _d;

    return __generator(this, function (_e) {
      switch (_e.label) {
        case 0:
          _a = [__assign({}, output)];
          _d = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_d.body = _e.sent(), _d)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);
          _b = errorCode;

          switch (_b) {
            case "ObjectAlreadyInActiveTierError":
              return [3
              /*break*/
              , 2];

            case "com.amazonaws.s3#ObjectAlreadyInActiveTierError":
              return [3
              /*break*/
              , 2];
          }

          return [3
          /*break*/
          , 4];

        case 2:
          _c = [{}];
          return [4
          /*yield*/
          , deserializeAws_restXmlObjectAlreadyInActiveTierErrorResponse(parsedOutput, context)];

        case 3:
          response = __assign.apply(void 0, [__assign.apply(void 0, _c.concat([_e.sent()])), {
            name: errorCode,
            $metadata: deserializeMetadata(output)
          }]);
          return [3
          /*break*/
          , 5];

        case 4:
          parsedBody = parsedOutput.body;
          errorCode = parsedBody.code || parsedBody.Code || errorCode;
          response = __assign(__assign({}, parsedBody), {
            name: "" + errorCode,
            message: parsedBody.message || parsedBody.Message || errorCode,
            $fault: "client",
            $metadata: deserializeMetadata(output)
          });
          _e.label = 5;

        case 5:
          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlSelectObjectContentCommand = function deserializeAws_restXmlSelectObjectContentCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
      if (output.statusCode !== 200 && output.statusCode >= 300) {
        return [2
        /*return*/
        , deserializeAws_restXmlSelectObjectContentCommandError(output, context)];
      }

      contents = {
        $metadata: deserializeMetadata(output),
        Payload: undefined
      };
      data = context.eventStreamMarshaller.deserialize(output.body, function (event) {
        return __awaiter(void 0, void 0, void 0, function () {
          var eventName, eventHeaders, eventMessage, parsedEvent;

          var _a;

          return __generator(this, function (_b) {
            switch (_b.label) {
              case 0:
                eventName = Object.keys(event)[0];
                eventHeaders = Object.entries(event[eventName].headers).reduce(function (accummulator, curr) {
                  accummulator[curr[0]] = curr[1].value;
                  return accummulator;
                }, {});
                eventMessage = {
                  headers: eventHeaders,
                  body: event[eventName].body
                };
                parsedEvent = (_a = {}, _a[eventName] = eventMessage, _a);
                return [4
                /*yield*/
                , deserializeAws_restXmlSelectObjectContentEventStream_event(parsedEvent, context)];

              case 1:
                return [2
                /*return*/
                , _b.sent()];
            }
          });
        });
      });
      contents.Payload = data;
      return [2
      /*return*/
      , Promise.resolve(contents)];
    });
  });
};

var deserializeAws_restXmlSelectObjectContentCommandError = function deserializeAws_restXmlSelectObjectContentCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlUploadPartCommand = function deserializeAws_restXmlUploadPartCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlUploadPartCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output),
            ETag: undefined,
            RequestCharged: undefined,
            SSECustomerAlgorithm: undefined,
            SSECustomerKeyMD5: undefined,
            SSEKMSKeyId: undefined,
            ServerSideEncryption: undefined
          };

          if (output.headers["x-amz-server-side-encryption-customer-key-md5"] !== undefined) {
            contents.SSECustomerKeyMD5 = output.headers["x-amz-server-side-encryption-customer-key-md5"];
          }

          if (output.headers["x-amz-server-side-encryption"] !== undefined) {
            contents.ServerSideEncryption = output.headers["x-amz-server-side-encryption"];
          }

          if (output.headers["x-amz-server-side-encryption-aws-kms-key-id"] !== undefined) {
            contents.SSEKMSKeyId = output.headers["x-amz-server-side-encryption-aws-kms-key-id"];
          }

          if (output.headers["x-amz-server-side-encryption-customer-algorithm"] !== undefined) {
            contents.SSECustomerAlgorithm = output.headers["x-amz-server-side-encryption-customer-algorithm"];
          }

          if (output.headers["x-amz-request-charged"] !== undefined) {
            contents.RequestCharged = output.headers["x-amz-request-charged"];
          }

          if (output.headers["etag"] !== undefined) {
            contents.ETag = output.headers["etag"];
          }

          return [4
          /*yield*/
          , collectBody(output.body, context)];

        case 1:
          _a.sent();

          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlUploadPartCommandError = function deserializeAws_restXmlUploadPartCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

export var deserializeAws_restXmlUploadPartCopyCommand = function deserializeAws_restXmlUploadPartCopyCommand(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          if (output.statusCode !== 200 && output.statusCode >= 300) {
            return [2
            /*return*/
            , deserializeAws_restXmlUploadPartCopyCommandError(output, context)];
          }

          contents = {
            $metadata: deserializeMetadata(output),
            CopyPartResult: undefined,
            CopySourceVersionId: undefined,
            RequestCharged: undefined,
            SSECustomerAlgorithm: undefined,
            SSECustomerKeyMD5: undefined,
            SSEKMSKeyId: undefined,
            ServerSideEncryption: undefined
          };

          if (output.headers["x-amz-copy-source-version-id"] !== undefined) {
            contents.CopySourceVersionId = output.headers["x-amz-copy-source-version-id"];
          }

          if (output.headers["x-amz-server-side-encryption-customer-algorithm"] !== undefined) {
            contents.SSECustomerAlgorithm = output.headers["x-amz-server-side-encryption-customer-algorithm"];
          }

          if (output.headers["x-amz-server-side-encryption-customer-key-md5"] !== undefined) {
            contents.SSECustomerKeyMD5 = output.headers["x-amz-server-side-encryption-customer-key-md5"];
          }

          if (output.headers["x-amz-request-charged"] !== undefined) {
            contents.RequestCharged = output.headers["x-amz-request-charged"];
          }

          if (output.headers["x-amz-server-side-encryption-aws-kms-key-id"] !== undefined) {
            contents.SSEKMSKeyId = output.headers["x-amz-server-side-encryption-aws-kms-key-id"];
          }

          if (output.headers["x-amz-server-side-encryption"] !== undefined) {
            contents.ServerSideEncryption = output.headers["x-amz-server-side-encryption"];
          }

          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          data = _a.sent();
          contents.CopyPartResult = deserializeAws_restXmlCopyPartResult(data, context);
          return [2
          /*return*/
          , Promise.resolve(contents)];
      }
    });
  });
};

var deserializeAws_restXmlUploadPartCopyCommandError = function deserializeAws_restXmlUploadPartCopyCommandError(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, parsedBody, message;

    var _b;

    return __generator(this, function (_c) {
      switch (_c.label) {
        case 0:
          _a = [__assign({}, output)];
          _b = {};
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          parsedOutput = __assign.apply(void 0, _a.concat([(_b.body = _c.sent(), _b)]));
          errorCode = "UnknownError";
          errorCode = loadRestXmlErrorCode(output, parsedOutput.body);

          switch (errorCode) {
            default:
              parsedBody = parsedOutput.body;
              errorCode = parsedBody.code || parsedBody.Code || errorCode;
              response = __assign(__assign({}, parsedBody), {
                name: "" + errorCode,
                message: parsedBody.message || parsedBody.Message || errorCode,
                $fault: "client",
                $metadata: deserializeMetadata(output)
              });
          }

          message = response.message || response.Message || errorCode;
          response.message = message;
          delete response.Message;
          return [2
          /*return*/
          , Promise.reject(Object.assign(new Error(message), response))];
      }
    });
  });
};

var deserializeAws_restXmlSelectObjectContentEventStream_event = function deserializeAws_restXmlSelectObjectContentEventStream_event(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var _a, _b, _c, _d, _e;

    return __generator(this, function (_f) {
      switch (_f.label) {
        case 0:
          if (!(output["Cont"] !== undefined)) return [3
          /*break*/
          , 2];
          _a = {};
          return [4
          /*yield*/
          , deserializeAws_restXmlContinuationEvent_event(output["Cont"], context)];

        case 1:
          return [2
          /*return*/
          , (_a.Cont = _f.sent(), _a)];

        case 2:
          if (!(output["Progress"] !== undefined)) return [3
          /*break*/
          , 4];
          _b = {};
          return [4
          /*yield*/
          , deserializeAws_restXmlProgressEvent_event(output["Progress"], context)];

        case 3:
          return [2
          /*return*/
          , (_b.Progress = _f.sent(), _b)];

        case 4:
          if (!(output["Stats"] !== undefined)) return [3
          /*break*/
          , 6];
          _c = {};
          return [4
          /*yield*/
          , deserializeAws_restXmlStatsEvent_event(output["Stats"], context)];

        case 5:
          return [2
          /*return*/
          , (_c.Stats = _f.sent(), _c)];

        case 6:
          if (!(output["End"] !== undefined)) return [3
          /*break*/
          , 8];
          _d = {};
          return [4
          /*yield*/
          , deserializeAws_restXmlEndEvent_event(output["End"], context)];

        case 7:
          return [2
          /*return*/
          , (_d.End = _f.sent(), _d)];

        case 8:
          if (!(output["Records"] !== undefined)) return [3
          /*break*/
          , 10];
          _e = {};
          return [4
          /*yield*/
          , deserializeAws_restXmlRecordsEvent_event(output["Records"], context)];

        case 9:
          return [2
          /*return*/
          , (_e.Records = _f.sent(), _e)];

        case 10:
          return [2
          /*return*/
          , {
            $unknown: output
          }];
      }
    });
  });
};

var deserializeAws_restXmlContinuationEvent_event = function deserializeAws_restXmlContinuationEvent_event(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
      contents = {};
      return [2
      /*return*/
      , contents];
    });
  });
};

var deserializeAws_restXmlEndEvent_event = function deserializeAws_restXmlEndEvent_event(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
      contents = {};
      return [2
      /*return*/
      , contents];
    });
  });
};

var deserializeAws_restXmlProgressEvent_event = function deserializeAws_restXmlProgressEvent_event(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents, _a;

    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          contents = {};
          _a = contents;
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          _a.Details = _b.sent();
          return [2
          /*return*/
          , contents];
      }
    });
  });
};

var deserializeAws_restXmlRecordsEvent_event = function deserializeAws_restXmlRecordsEvent_event(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents;
    return __generator(this, function (_a) {
      contents = {};
      contents.Payload = output.body;
      return [2
      /*return*/
      , contents];
    });
  });
};

var deserializeAws_restXmlStatsEvent_event = function deserializeAws_restXmlStatsEvent_event(output, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents, _a;

    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          contents = {};
          _a = contents;
          return [4
          /*yield*/
          , parseBody(output.body, context)];

        case 1:
          _a.Details = _b.sent();
          return [2
          /*return*/
          , contents];
      }
    });
  });
};

var deserializeAws_restXmlBucketAlreadyExistsResponse = function deserializeAws_restXmlBucketAlreadyExistsResponse(parsedOutput, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
      contents = {
        name: "BucketAlreadyExists",
        $fault: "client",
        $metadata: deserializeMetadata(parsedOutput)
      };
      data = parsedOutput.body;
      return [2
      /*return*/
      , contents];
    });
  });
};

var deserializeAws_restXmlBucketAlreadyOwnedByYouResponse = function deserializeAws_restXmlBucketAlreadyOwnedByYouResponse(parsedOutput, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
      contents = {
        name: "BucketAlreadyOwnedByYou",
        $fault: "client",
        $metadata: deserializeMetadata(parsedOutput)
      };
      data = parsedOutput.body;
      return [2
      /*return*/
      , contents];
    });
  });
};

var deserializeAws_restXmlNoSuchBucketResponse = function deserializeAws_restXmlNoSuchBucketResponse(parsedOutput, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
      contents = {
        name: "NoSuchBucket",
        $fault: "client",
        $metadata: deserializeMetadata(parsedOutput)
      };
      data = parsedOutput.body;
      return [2
      /*return*/
      , contents];
    });
  });
};

var deserializeAws_restXmlNoSuchKeyResponse = function deserializeAws_restXmlNoSuchKeyResponse(parsedOutput, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
      contents = {
        name: "NoSuchKey",
        $fault: "client",
        $metadata: deserializeMetadata(parsedOutput)
      };
      data = parsedOutput.body;
      return [2
      /*return*/
      , contents];
    });
  });
};

var deserializeAws_restXmlNoSuchUploadResponse = function deserializeAws_restXmlNoSuchUploadResponse(parsedOutput, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
      contents = {
        name: "NoSuchUpload",
        $fault: "client",
        $metadata: deserializeMetadata(parsedOutput)
      };
      data = parsedOutput.body;
      return [2
      /*return*/
      , contents];
    });
  });
};

var deserializeAws_restXmlObjectAlreadyInActiveTierErrorResponse = function deserializeAws_restXmlObjectAlreadyInActiveTierErrorResponse(parsedOutput, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
      contents = {
        name: "ObjectAlreadyInActiveTierError",
        $fault: "client",
        $metadata: deserializeMetadata(parsedOutput)
      };
      data = parsedOutput.body;
      return [2
      /*return*/
      , contents];
    });
  });
};

var deserializeAws_restXmlObjectNotInActiveTierErrorResponse = function deserializeAws_restXmlObjectNotInActiveTierErrorResponse(parsedOutput, context) {
  return __awaiter(void 0, void 0, void 0, function () {
    var contents, data;
    return __generator(this, function (_a) {
      contents = {
        name: "ObjectNotInActiveTierError",
        $fault: "client",
        $metadata: deserializeMetadata(parsedOutput)
      };
      data = parsedOutput.body;
      return [2
      /*return*/
      , contents];
    });
  });
};

var serializeAws_restXmlAbortIncompleteMultipartUpload = function serializeAws_restXmlAbortIncompleteMultipartUpload(input, context) {
  var bodyNode = new __XmlNode("AbortIncompleteMultipartUpload");

  if (input.DaysAfterInitiation !== undefined) {
    var node = new __XmlNode("DaysAfterInitiation").addChildNode(new __XmlText(String(input.DaysAfterInitiation))).withName("DaysAfterInitiation");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlAccelerateConfiguration = function serializeAws_restXmlAccelerateConfiguration(input, context) {
  var bodyNode = new __XmlNode("AccelerateConfiguration");

  if (input.Status !== undefined) {
    var node = new __XmlNode("BucketAccelerateStatus").addChildNode(new __XmlText(input.Status)).withName("Status");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlAccessControlPolicy = function serializeAws_restXmlAccessControlPolicy(input, context) {
  var bodyNode = new __XmlNode("AccessControlPolicy");

  if (input.Grants !== undefined) {
    var nodes = serializeAws_restXmlGrants(input.Grants, context);
    var containerNode_1 = new __XmlNode("AccessControlList");
    nodes.map(function (node) {
      containerNode_1.addChildNode(node);
    });
    bodyNode.addChildNode(containerNode_1);
  }

  if (input.Owner !== undefined) {
    var node = serializeAws_restXmlOwner(input.Owner, context).withName("Owner");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlAccessControlTranslation = function serializeAws_restXmlAccessControlTranslation(input, context) {
  var bodyNode = new __XmlNode("AccessControlTranslation");

  if (input.Owner !== undefined) {
    var node = new __XmlNode("OwnerOverride").addChildNode(new __XmlText(input.Owner)).withName("Owner");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlAllowedHeaders = function serializeAws_restXmlAllowedHeaders(input, context) {
  return input.map(function (entry) {
    var node = new __XmlNode("AllowedHeader").addChildNode(new __XmlText(entry));
    return node.withName("member");
  });
};

var serializeAws_restXmlAllowedMethods = function serializeAws_restXmlAllowedMethods(input, context) {
  return input.map(function (entry) {
    var node = new __XmlNode("AllowedMethod").addChildNode(new __XmlText(entry));
    return node.withName("member");
  });
};

var serializeAws_restXmlAllowedOrigins = function serializeAws_restXmlAllowedOrigins(input, context) {
  return input.map(function (entry) {
    var node = new __XmlNode("AllowedOrigin").addChildNode(new __XmlText(entry));
    return node.withName("member");
  });
};

var serializeAws_restXmlAnalyticsAndOperator = function serializeAws_restXmlAnalyticsAndOperator(input, context) {
  var bodyNode = new __XmlNode("AnalyticsAndOperator");

  if (input.Prefix !== undefined) {
    var node = new __XmlNode("Prefix").addChildNode(new __XmlText(input.Prefix)).withName("Prefix");
    bodyNode.addChildNode(node);
  }

  if (input.Tags !== undefined) {
    var nodes = serializeAws_restXmlTagSet(input.Tags, context);
    nodes.map(function (node) {
      node = node.withName("Tag");
      bodyNode.addChildNode(node);
    });
  }

  return bodyNode;
};

var serializeAws_restXmlAnalyticsConfiguration = function serializeAws_restXmlAnalyticsConfiguration(input, context) {
  var bodyNode = new __XmlNode("AnalyticsConfiguration");

  if (input.StorageClassAnalysis !== undefined) {
    var node = serializeAws_restXmlStorageClassAnalysis(input.StorageClassAnalysis, context).withName("StorageClassAnalysis");
    bodyNode.addChildNode(node);
  }

  if (input.Filter !== undefined) {
    var node = serializeAws_restXmlAnalyticsFilter(input.Filter, context).withName("Filter");
    bodyNode.addChildNode(node);
  }

  if (input.Id !== undefined) {
    var node = new __XmlNode("AnalyticsId").addChildNode(new __XmlText(input.Id)).withName("Id");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlAnalyticsExportDestination = function serializeAws_restXmlAnalyticsExportDestination(input, context) {
  var bodyNode = new __XmlNode("AnalyticsExportDestination");

  if (input.S3BucketDestination !== undefined) {
    var node = serializeAws_restXmlAnalyticsS3BucketDestination(input.S3BucketDestination, context).withName("S3BucketDestination");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlAnalyticsFilter = function serializeAws_restXmlAnalyticsFilter(input, context) {
  var bodyNode = new __XmlNode("AnalyticsFilter");

  if (input.Prefix !== undefined) {
    var node = new __XmlNode("Prefix").addChildNode(new __XmlText(input.Prefix)).withName("Prefix");
    bodyNode.addChildNode(node);
  }

  if (input.Tag !== undefined) {
    var node = serializeAws_restXmlTag(input.Tag, context).withName("Tag");
    bodyNode.addChildNode(node);
  }

  if (input.And !== undefined) {
    var node = serializeAws_restXmlAnalyticsAndOperator(input.And, context).withName("And");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlAnalyticsS3BucketDestination = function serializeAws_restXmlAnalyticsS3BucketDestination(input, context) {
  var bodyNode = new __XmlNode("AnalyticsS3BucketDestination");

  if (input.Prefix !== undefined) {
    var node = new __XmlNode("Prefix").addChildNode(new __XmlText(input.Prefix)).withName("Prefix");
    bodyNode.addChildNode(node);
  }

  if (input.BucketAccountId !== undefined) {
    var node = new __XmlNode("AccountId").addChildNode(new __XmlText(input.BucketAccountId)).withName("BucketAccountId");
    bodyNode.addChildNode(node);
  }

  if (input.Bucket !== undefined) {
    var node = new __XmlNode("BucketName").addChildNode(new __XmlText(input.Bucket)).withName("Bucket");
    bodyNode.addChildNode(node);
  }

  if (input.Format !== undefined) {
    var node = new __XmlNode("AnalyticsS3ExportFileFormat").addChildNode(new __XmlText(input.Format)).withName("Format");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlBucketLifecycleConfiguration = function serializeAws_restXmlBucketLifecycleConfiguration(input, context) {
  var bodyNode = new __XmlNode("BucketLifecycleConfiguration");

  if (input.Rules !== undefined) {
    var nodes = serializeAws_restXmlLifecycleRules(input.Rules, context);
    nodes.map(function (node) {
      node = node.withName("Rule");
      bodyNode.addChildNode(node);
    });
  }

  return bodyNode;
};

var serializeAws_restXmlBucketLoggingStatus = function serializeAws_restXmlBucketLoggingStatus(input, context) {
  var bodyNode = new __XmlNode("BucketLoggingStatus");

  if (input.LoggingEnabled !== undefined) {
    var node = serializeAws_restXmlLoggingEnabled(input.LoggingEnabled, context).withName("LoggingEnabled");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlCompletedMultipartUpload = function serializeAws_restXmlCompletedMultipartUpload(input, context) {
  var bodyNode = new __XmlNode("CompletedMultipartUpload");

  if (input.Parts !== undefined) {
    var nodes = serializeAws_restXmlCompletedPartList(input.Parts, context);
    nodes.map(function (node) {
      node = node.withName("Part");
      bodyNode.addChildNode(node);
    });
  }

  return bodyNode;
};

var serializeAws_restXmlCompletedPart = function serializeAws_restXmlCompletedPart(input, context) {
  var bodyNode = new __XmlNode("CompletedPart");

  if (input.ETag !== undefined) {
    var node = new __XmlNode("ETag").addChildNode(new __XmlText(input.ETag)).withName("ETag");
    bodyNode.addChildNode(node);
  }

  if (input.PartNumber !== undefined) {
    var node = new __XmlNode("PartNumber").addChildNode(new __XmlText(String(input.PartNumber))).withName("PartNumber");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlCompletedPartList = function serializeAws_restXmlCompletedPartList(input, context) {
  return input.map(function (entry) {
    var node = serializeAws_restXmlCompletedPart(entry, context);
    return node.withName("member");
  });
};

var serializeAws_restXmlCondition = function serializeAws_restXmlCondition(input, context) {
  var bodyNode = new __XmlNode("Condition");

  if (input.KeyPrefixEquals !== undefined) {
    var node = new __XmlNode("KeyPrefixEquals").addChildNode(new __XmlText(input.KeyPrefixEquals)).withName("KeyPrefixEquals");
    bodyNode.addChildNode(node);
  }

  if (input.HttpErrorCodeReturnedEquals !== undefined) {
    var node = new __XmlNode("HttpErrorCodeReturnedEquals").addChildNode(new __XmlText(input.HttpErrorCodeReturnedEquals)).withName("HttpErrorCodeReturnedEquals");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlCORSConfiguration = function serializeAws_restXmlCORSConfiguration(input, context) {
  var bodyNode = new __XmlNode("CORSConfiguration");

  if (input.CORSRules !== undefined) {
    var nodes = serializeAws_restXmlCORSRules(input.CORSRules, context);
    nodes.map(function (node) {
      node = node.withName("CORSRule");
      bodyNode.addChildNode(node);
    });
  }

  return bodyNode;
};

var serializeAws_restXmlCORSRule = function serializeAws_restXmlCORSRule(input, context) {
  var bodyNode = new __XmlNode("CORSRule");

  if (input.AllowedHeaders !== undefined) {
    var nodes = serializeAws_restXmlAllowedHeaders(input.AllowedHeaders, context);
    nodes.map(function (node) {
      node = node.withName("AllowedHeader");
      bodyNode.addChildNode(node);
    });
  }

  if (input.AllowedOrigins !== undefined) {
    var nodes = serializeAws_restXmlAllowedOrigins(input.AllowedOrigins, context);
    nodes.map(function (node) {
      node = node.withName("AllowedOrigin");
      bodyNode.addChildNode(node);
    });
  }

  if (input.MaxAgeSeconds !== undefined) {
    var node = new __XmlNode("MaxAgeSeconds").addChildNode(new __XmlText(String(input.MaxAgeSeconds))).withName("MaxAgeSeconds");
    bodyNode.addChildNode(node);
  }

  if (input.ExposeHeaders !== undefined) {
    var nodes = serializeAws_restXmlExposeHeaders(input.ExposeHeaders, context);
    nodes.map(function (node) {
      node = node.withName("ExposeHeader");
      bodyNode.addChildNode(node);
    });
  }

  if (input.AllowedMethods !== undefined) {
    var nodes = serializeAws_restXmlAllowedMethods(input.AllowedMethods, context);
    nodes.map(function (node) {
      node = node.withName("AllowedMethod");
      bodyNode.addChildNode(node);
    });
  }

  return bodyNode;
};

var serializeAws_restXmlCORSRules = function serializeAws_restXmlCORSRules(input, context) {
  return input.map(function (entry) {
    var node = serializeAws_restXmlCORSRule(entry, context);
    return node.withName("member");
  });
};

var serializeAws_restXmlCreateBucketConfiguration = function serializeAws_restXmlCreateBucketConfiguration(input, context) {
  var bodyNode = new __XmlNode("CreateBucketConfiguration");

  if (input.LocationConstraint !== undefined) {
    var node = new __XmlNode("BucketLocationConstraint").addChildNode(new __XmlText(input.LocationConstraint)).withName("LocationConstraint");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlCSVInput = function serializeAws_restXmlCSVInput(input, context) {
  var bodyNode = new __XmlNode("CSVInput");

  if (input.FieldDelimiter !== undefined) {
    var node = new __XmlNode("FieldDelimiter").addChildNode(new __XmlText(input.FieldDelimiter)).withName("FieldDelimiter");
    bodyNode.addChildNode(node);
  }

  if (input.AllowQuotedRecordDelimiter !== undefined) {
    var node = new __XmlNode("AllowQuotedRecordDelimiter").addChildNode(new __XmlText(String(input.AllowQuotedRecordDelimiter))).withName("AllowQuotedRecordDelimiter");
    bodyNode.addChildNode(node);
  }

  if (input.FileHeaderInfo !== undefined) {
    var node = new __XmlNode("FileHeaderInfo").addChildNode(new __XmlText(input.FileHeaderInfo)).withName("FileHeaderInfo");
    bodyNode.addChildNode(node);
  }

  if (input.QuoteCharacter !== undefined) {
    var node = new __XmlNode("QuoteCharacter").addChildNode(new __XmlText(input.QuoteCharacter)).withName("QuoteCharacter");
    bodyNode.addChildNode(node);
  }

  if (input.QuoteEscapeCharacter !== undefined) {
    var node = new __XmlNode("QuoteEscapeCharacter").addChildNode(new __XmlText(input.QuoteEscapeCharacter)).withName("QuoteEscapeCharacter");
    bodyNode.addChildNode(node);
  }

  if (input.RecordDelimiter !== undefined) {
    var node = new __XmlNode("RecordDelimiter").addChildNode(new __XmlText(input.RecordDelimiter)).withName("RecordDelimiter");
    bodyNode.addChildNode(node);
  }

  if (input.Comments !== undefined) {
    var node = new __XmlNode("Comments").addChildNode(new __XmlText(input.Comments)).withName("Comments");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlCSVOutput = function serializeAws_restXmlCSVOutput(input, context) {
  var bodyNode = new __XmlNode("CSVOutput");

  if (input.FieldDelimiter !== undefined) {
    var node = new __XmlNode("FieldDelimiter").addChildNode(new __XmlText(input.FieldDelimiter)).withName("FieldDelimiter");
    bodyNode.addChildNode(node);
  }

  if (input.QuoteFields !== undefined) {
    var node = new __XmlNode("QuoteFields").addChildNode(new __XmlText(input.QuoteFields)).withName("QuoteFields");
    bodyNode.addChildNode(node);
  }

  if (input.QuoteCharacter !== undefined) {
    var node = new __XmlNode("QuoteCharacter").addChildNode(new __XmlText(input.QuoteCharacter)).withName("QuoteCharacter");
    bodyNode.addChildNode(node);
  }

  if (input.RecordDelimiter !== undefined) {
    var node = new __XmlNode("RecordDelimiter").addChildNode(new __XmlText(input.RecordDelimiter)).withName("RecordDelimiter");
    bodyNode.addChildNode(node);
  }

  if (input.QuoteEscapeCharacter !== undefined) {
    var node = new __XmlNode("QuoteEscapeCharacter").addChildNode(new __XmlText(input.QuoteEscapeCharacter)).withName("QuoteEscapeCharacter");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlDefaultRetention = function serializeAws_restXmlDefaultRetention(input, context) {
  var bodyNode = new __XmlNode("DefaultRetention");

  if (input.Days !== undefined) {
    var node = new __XmlNode("Days").addChildNode(new __XmlText(String(input.Days))).withName("Days");
    bodyNode.addChildNode(node);
  }

  if (input.Mode !== undefined) {
    var node = new __XmlNode("ObjectLockRetentionMode").addChildNode(new __XmlText(input.Mode)).withName("Mode");
    bodyNode.addChildNode(node);
  }

  if (input.Years !== undefined) {
    var node = new __XmlNode("Years").addChildNode(new __XmlText(String(input.Years))).withName("Years");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlDelete = function serializeAws_restXmlDelete(input, context) {
  var bodyNode = new __XmlNode("Delete");

  if (input.Objects !== undefined) {
    var nodes = serializeAws_restXmlObjectIdentifierList(input.Objects, context);
    nodes.map(function (node) {
      node = node.withName("Object");
      bodyNode.addChildNode(node);
    });
  }

  if (input.Quiet !== undefined) {
    var node = new __XmlNode("Quiet").addChildNode(new __XmlText(String(input.Quiet))).withName("Quiet");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlDeleteMarkerReplication = function serializeAws_restXmlDeleteMarkerReplication(input, context) {
  var bodyNode = new __XmlNode("DeleteMarkerReplication");

  if (input.Status !== undefined) {
    var node = new __XmlNode("DeleteMarkerReplicationStatus").addChildNode(new __XmlText(input.Status)).withName("Status");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlDestination = function serializeAws_restXmlDestination(input, context) {
  var bodyNode = new __XmlNode("Destination");

  if (input.EncryptionConfiguration !== undefined) {
    var node = serializeAws_restXmlEncryptionConfiguration(input.EncryptionConfiguration, context).withName("EncryptionConfiguration");
    bodyNode.addChildNode(node);
  }

  if (input.Bucket !== undefined) {
    var node = new __XmlNode("BucketName").addChildNode(new __XmlText(input.Bucket)).withName("Bucket");
    bodyNode.addChildNode(node);
  }

  if (input.Account !== undefined) {
    var node = new __XmlNode("AccountId").addChildNode(new __XmlText(input.Account)).withName("Account");
    bodyNode.addChildNode(node);
  }

  if (input.StorageClass !== undefined) {
    var node = new __XmlNode("StorageClass").addChildNode(new __XmlText(input.StorageClass)).withName("StorageClass");
    bodyNode.addChildNode(node);
  }

  if (input.Metrics !== undefined) {
    var node = serializeAws_restXmlMetrics(input.Metrics, context).withName("Metrics");
    bodyNode.addChildNode(node);
  }

  if (input.AccessControlTranslation !== undefined) {
    var node = serializeAws_restXmlAccessControlTranslation(input.AccessControlTranslation, context).withName("AccessControlTranslation");
    bodyNode.addChildNode(node);
  }

  if (input.ReplicationTime !== undefined) {
    var node = serializeAws_restXmlReplicationTime(input.ReplicationTime, context).withName("ReplicationTime");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlEncryption = function serializeAws_restXmlEncryption(input, context) {
  var bodyNode = new __XmlNode("Encryption");

  if (input.KMSKeyId !== undefined) {
    var node = new __XmlNode("SSEKMSKeyId").addChildNode(new __XmlText(input.KMSKeyId)).withName("KMSKeyId");
    bodyNode.addChildNode(node);
  }

  if (input.KMSContext !== undefined) {
    var node = new __XmlNode("KMSContext").addChildNode(new __XmlText(input.KMSContext)).withName("KMSContext");
    bodyNode.addChildNode(node);
  }

  if (input.EncryptionType !== undefined) {
    var node = new __XmlNode("ServerSideEncryption").addChildNode(new __XmlText(input.EncryptionType)).withName("EncryptionType");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlEncryptionConfiguration = function serializeAws_restXmlEncryptionConfiguration(input, context) {
  var bodyNode = new __XmlNode("EncryptionConfiguration");

  if (input.ReplicaKmsKeyID !== undefined) {
    var node = new __XmlNode("ReplicaKmsKeyID").addChildNode(new __XmlText(input.ReplicaKmsKeyID)).withName("ReplicaKmsKeyID");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlErrorDocument = function serializeAws_restXmlErrorDocument(input, context) {
  var bodyNode = new __XmlNode("ErrorDocument");

  if (input.Key !== undefined) {
    var node = new __XmlNode("ObjectKey").addChildNode(new __XmlText(input.Key)).withName("Key");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlEventList = function serializeAws_restXmlEventList(input, context) {
  return input.map(function (entry) {
    var node = new __XmlNode("Event").addChildNode(new __XmlText(entry));
    return node.withName("member");
  });
};

var serializeAws_restXmlExistingObjectReplication = function serializeAws_restXmlExistingObjectReplication(input, context) {
  var bodyNode = new __XmlNode("ExistingObjectReplication");

  if (input.Status !== undefined) {
    var node = new __XmlNode("ExistingObjectReplicationStatus").addChildNode(new __XmlText(input.Status)).withName("Status");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlExposeHeaders = function serializeAws_restXmlExposeHeaders(input, context) {
  return input.map(function (entry) {
    var node = new __XmlNode("ExposeHeader").addChildNode(new __XmlText(entry));
    return node.withName("member");
  });
};

var serializeAws_restXmlFilterRule = function serializeAws_restXmlFilterRule(input, context) {
  var bodyNode = new __XmlNode("FilterRule");

  if (input.Name !== undefined) {
    var node = new __XmlNode("FilterRuleName").addChildNode(new __XmlText(input.Name)).withName("Name");
    bodyNode.addChildNode(node);
  }

  if (input.Value !== undefined) {
    var node = new __XmlNode("FilterRuleValue").addChildNode(new __XmlText(input.Value)).withName("Value");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlFilterRuleList = function serializeAws_restXmlFilterRuleList(input, context) {
  return input.map(function (entry) {
    var node = serializeAws_restXmlFilterRule(entry, context);
    return node.withName("member");
  });
};

var serializeAws_restXmlGlacierJobParameters = function serializeAws_restXmlGlacierJobParameters(input, context) {
  var bodyNode = new __XmlNode("GlacierJobParameters");

  if (input.Tier !== undefined) {
    var node = new __XmlNode("Tier").addChildNode(new __XmlText(input.Tier)).withName("Tier");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlGrant = function serializeAws_restXmlGrant(input, context) {
  var bodyNode = new __XmlNode("Grant");

  if (input.Grantee !== undefined) {
    var node = serializeAws_restXmlGrantee(input.Grantee, context).withName("Grantee");
    bodyNode.addChildNode(node);
  }

  if (input.Permission !== undefined) {
    var node = new __XmlNode("Permission").addChildNode(new __XmlText(input.Permission)).withName("Permission");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlGrantee = function serializeAws_restXmlGrantee(input, context) {
  var bodyNode = new __XmlNode("Grantee");

  if (input.EmailAddress !== undefined) {
    var node = new __XmlNode("EmailAddress").addChildNode(new __XmlText(input.EmailAddress)).withName("EmailAddress");
    bodyNode.addChildNode(node);
  }

  if (input.DisplayName !== undefined) {
    var node = new __XmlNode("DisplayName").addChildNode(new __XmlText(input.DisplayName)).withName("DisplayName");
    bodyNode.addChildNode(node);
  }

  if (input.URI !== undefined) {
    var node = new __XmlNode("URI").addChildNode(new __XmlText(input.URI)).withName("URI");
    bodyNode.addChildNode(node);
  }

  if (input.ID !== undefined) {
    var node = new __XmlNode("ID").addChildNode(new __XmlText(input.ID)).withName("ID");
    bodyNode.addChildNode(node);
  }

  if (input.Type !== undefined) {
    bodyNode.addAttribute("xsi:type", input.Type);
  }

  return bodyNode;
};

var serializeAws_restXmlGrants = function serializeAws_restXmlGrants(input, context) {
  return input.map(function (entry) {
    var node = serializeAws_restXmlGrant(entry, context);
    return node.withName("Grant");
  });
};

var serializeAws_restXmlIndexDocument = function serializeAws_restXmlIndexDocument(input, context) {
  var bodyNode = new __XmlNode("IndexDocument");

  if (input.Suffix !== undefined) {
    var node = new __XmlNode("Suffix").addChildNode(new __XmlText(input.Suffix)).withName("Suffix");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlInputSerialization = function serializeAws_restXmlInputSerialization(input, context) {
  var bodyNode = new __XmlNode("InputSerialization");

  if (input.JSON !== undefined) {
    var node = serializeAws_restXmlJSONInput(input.JSON, context).withName("JSON");
    bodyNode.addChildNode(node);
  }

  if (input.CompressionType !== undefined) {
    var node = new __XmlNode("CompressionType").addChildNode(new __XmlText(input.CompressionType)).withName("CompressionType");
    bodyNode.addChildNode(node);
  }

  if (input.Parquet !== undefined) {
    var node = serializeAws_restXmlParquetInput(input.Parquet, context).withName("Parquet");
    bodyNode.addChildNode(node);
  }

  if (input.CSV !== undefined) {
    var node = serializeAws_restXmlCSVInput(input.CSV, context).withName("CSV");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlInventoryConfiguration = function serializeAws_restXmlInventoryConfiguration(input, context) {
  var bodyNode = new __XmlNode("InventoryConfiguration");

  if (input.IncludedObjectVersions !== undefined) {
    var node = new __XmlNode("InventoryIncludedObjectVersions").addChildNode(new __XmlText(input.IncludedObjectVersions)).withName("IncludedObjectVersions");
    bodyNode.addChildNode(node);
  }

  if (input.IsEnabled !== undefined) {
    var node = new __XmlNode("IsEnabled").addChildNode(new __XmlText(String(input.IsEnabled))).withName("IsEnabled");
    bodyNode.addChildNode(node);
  }

  if (input.Schedule !== undefined) {
    var node = serializeAws_restXmlInventorySchedule(input.Schedule, context).withName("Schedule");
    bodyNode.addChildNode(node);
  }

  if (input.Filter !== undefined) {
    var node = serializeAws_restXmlInventoryFilter(input.Filter, context).withName("Filter");
    bodyNode.addChildNode(node);
  }

  if (input.OptionalFields !== undefined) {
    var nodes = serializeAws_restXmlInventoryOptionalFields(input.OptionalFields, context);
    var containerNode_2 = new __XmlNode("OptionalFields");
    nodes.map(function (node) {
      containerNode_2.addChildNode(node);
    });
    bodyNode.addChildNode(containerNode_2);
  }

  if (input.Destination !== undefined) {
    var node = serializeAws_restXmlInventoryDestination(input.Destination, context).withName("Destination");
    bodyNode.addChildNode(node);
  }

  if (input.Id !== undefined) {
    var node = new __XmlNode("InventoryId").addChildNode(new __XmlText(input.Id)).withName("Id");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlInventoryDestination = function serializeAws_restXmlInventoryDestination(input, context) {
  var bodyNode = new __XmlNode("InventoryDestination");

  if (input.S3BucketDestination !== undefined) {
    var node = serializeAws_restXmlInventoryS3BucketDestination(input.S3BucketDestination, context).withName("S3BucketDestination");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlInventoryEncryption = function serializeAws_restXmlInventoryEncryption(input, context) {
  var bodyNode = new __XmlNode("InventoryEncryption");

  if (input.SSEKMS !== undefined) {
    var node = serializeAws_restXmlSSEKMS(input.SSEKMS, context).withName("SSE-KMS");
    bodyNode.addChildNode(node);
  }

  if (input.SSES3 !== undefined) {
    var node = serializeAws_restXmlSSES3(input.SSES3, context).withName("SSE-S3");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlInventoryFilter = function serializeAws_restXmlInventoryFilter(input, context) {
  var bodyNode = new __XmlNode("InventoryFilter");

  if (input.Prefix !== undefined) {
    var node = new __XmlNode("Prefix").addChildNode(new __XmlText(input.Prefix)).withName("Prefix");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlInventoryOptionalFields = function serializeAws_restXmlInventoryOptionalFields(input, context) {
  return input.map(function (entry) {
    var node = new __XmlNode("InventoryOptionalField").addChildNode(new __XmlText(entry));
    return node.withName("Field");
  });
};

var serializeAws_restXmlInventoryS3BucketDestination = function serializeAws_restXmlInventoryS3BucketDestination(input, context) {
  var bodyNode = new __XmlNode("InventoryS3BucketDestination");

  if (input.Format !== undefined) {
    var node = new __XmlNode("InventoryFormat").addChildNode(new __XmlText(input.Format)).withName("Format");
    bodyNode.addChildNode(node);
  }

  if (input.Encryption !== undefined) {
    var node = serializeAws_restXmlInventoryEncryption(input.Encryption, context).withName("Encryption");
    bodyNode.addChildNode(node);
  }

  if (input.Prefix !== undefined) {
    var node = new __XmlNode("Prefix").addChildNode(new __XmlText(input.Prefix)).withName("Prefix");
    bodyNode.addChildNode(node);
  }

  if (input.Bucket !== undefined) {
    var node = new __XmlNode("BucketName").addChildNode(new __XmlText(input.Bucket)).withName("Bucket");
    bodyNode.addChildNode(node);
  }

  if (input.AccountId !== undefined) {
    var node = new __XmlNode("AccountId").addChildNode(new __XmlText(input.AccountId)).withName("AccountId");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlInventorySchedule = function serializeAws_restXmlInventorySchedule(input, context) {
  var bodyNode = new __XmlNode("InventorySchedule");

  if (input.Frequency !== undefined) {
    var node = new __XmlNode("InventoryFrequency").addChildNode(new __XmlText(input.Frequency)).withName("Frequency");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlJSONInput = function serializeAws_restXmlJSONInput(input, context) {
  var bodyNode = new __XmlNode("JSONInput");

  if (input.Type !== undefined) {
    var node = new __XmlNode("JSONType").addChildNode(new __XmlText(input.Type)).withName("Type");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlJSONOutput = function serializeAws_restXmlJSONOutput(input, context) {
  var bodyNode = new __XmlNode("JSONOutput");

  if (input.RecordDelimiter !== undefined) {
    var node = new __XmlNode("RecordDelimiter").addChildNode(new __XmlText(input.RecordDelimiter)).withName("RecordDelimiter");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlLambdaFunctionConfiguration = function serializeAws_restXmlLambdaFunctionConfiguration(input, context) {
  var bodyNode = new __XmlNode("LambdaFunctionConfiguration");

  if (input.Events !== undefined) {
    var nodes = serializeAws_restXmlEventList(input.Events, context);
    nodes.map(function (node) {
      node = node.withName("Event");
      bodyNode.addChildNode(node);
    });
  }

  if (input.Filter !== undefined) {
    var node = serializeAws_restXmlNotificationConfigurationFilter(input.Filter, context).withName("Filter");
    bodyNode.addChildNode(node);
  }

  if (input.LambdaFunctionArn !== undefined) {
    var node = new __XmlNode("LambdaFunctionArn").addChildNode(new __XmlText(input.LambdaFunctionArn)).withName("CloudFunction");
    bodyNode.addChildNode(node);
  }

  if (input.Id !== undefined) {
    var node = new __XmlNode("NotificationId").addChildNode(new __XmlText(input.Id)).withName("Id");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlLambdaFunctionConfigurationList = function serializeAws_restXmlLambdaFunctionConfigurationList(input, context) {
  return input.map(function (entry) {
    var node = serializeAws_restXmlLambdaFunctionConfiguration(entry, context);
    return node.withName("member");
  });
};

var serializeAws_restXmlLifecycleExpiration = function serializeAws_restXmlLifecycleExpiration(input, context) {
  var bodyNode = new __XmlNode("LifecycleExpiration");

  if (input.Days !== undefined) {
    var node = new __XmlNode("Days").addChildNode(new __XmlText(String(input.Days))).withName("Days");
    bodyNode.addChildNode(node);
  }

  if (input.ExpiredObjectDeleteMarker !== undefined) {
    var node = new __XmlNode("ExpiredObjectDeleteMarker").addChildNode(new __XmlText(String(input.ExpiredObjectDeleteMarker))).withName("ExpiredObjectDeleteMarker");
    bodyNode.addChildNode(node);
  }

  if (input.Date !== undefined) {
    var node = new __XmlNode("Date").addChildNode(new __XmlText(input.Date.toISOString().split(".")[0] + "Z")).withName("Date");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlLifecycleRule = function serializeAws_restXmlLifecycleRule(input, context) {
  var bodyNode = new __XmlNode("LifecycleRule");

  if (input.NoncurrentVersionTransitions !== undefined) {
    var nodes = serializeAws_restXmlNoncurrentVersionTransitionList(input.NoncurrentVersionTransitions, context);
    nodes.map(function (node) {
      node = node.withName("NoncurrentVersionTransition");
      bodyNode.addChildNode(node);
    });
  }

  if (input.Expiration !== undefined) {
    var node = serializeAws_restXmlLifecycleExpiration(input.Expiration, context).withName("Expiration");
    bodyNode.addChildNode(node);
  }

  if (input.ID !== undefined) {
    var node = new __XmlNode("ID").addChildNode(new __XmlText(input.ID)).withName("ID");
    bodyNode.addChildNode(node);
  }

  if (input.Transitions !== undefined) {
    var nodes = serializeAws_restXmlTransitionList(input.Transitions, context);
    nodes.map(function (node) {
      node = node.withName("Transition");
      bodyNode.addChildNode(node);
    });
  }

  if (input.Prefix !== undefined) {
    var node = new __XmlNode("Prefix").addChildNode(new __XmlText(input.Prefix)).withName("Prefix");
    bodyNode.addChildNode(node);
  }

  if (input.NoncurrentVersionExpiration !== undefined) {
    var node = serializeAws_restXmlNoncurrentVersionExpiration(input.NoncurrentVersionExpiration, context).withName("NoncurrentVersionExpiration");
    bodyNode.addChildNode(node);
  }

  if (input.AbortIncompleteMultipartUpload !== undefined) {
    var node = serializeAws_restXmlAbortIncompleteMultipartUpload(input.AbortIncompleteMultipartUpload, context).withName("AbortIncompleteMultipartUpload");
    bodyNode.addChildNode(node);
  }

  if (input.Filter !== undefined) {
    var node = serializeAws_restXmlLifecycleRuleFilter(input.Filter, context).withName("Filter");
    bodyNode.addChildNode(node);
  }

  if (input.Status !== undefined) {
    var node = new __XmlNode("ExpirationStatus").addChildNode(new __XmlText(input.Status)).withName("Status");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlLifecycleRuleAndOperator = function serializeAws_restXmlLifecycleRuleAndOperator(input, context) {
  var bodyNode = new __XmlNode("LifecycleRuleAndOperator");

  if (input.Prefix !== undefined) {
    var node = new __XmlNode("Prefix").addChildNode(new __XmlText(input.Prefix)).withName("Prefix");
    bodyNode.addChildNode(node);
  }

  if (input.Tags !== undefined) {
    var nodes = serializeAws_restXmlTagSet(input.Tags, context);
    nodes.map(function (node) {
      node = node.withName("Tag");
      bodyNode.addChildNode(node);
    });
  }

  return bodyNode;
};

var serializeAws_restXmlLifecycleRuleFilter = function serializeAws_restXmlLifecycleRuleFilter(input, context) {
  var bodyNode = new __XmlNode("LifecycleRuleFilter");

  if (input.And !== undefined) {
    var node = serializeAws_restXmlLifecycleRuleAndOperator(input.And, context).withName("And");
    bodyNode.addChildNode(node);
  }

  if (input.Prefix !== undefined) {
    var node = new __XmlNode("Prefix").addChildNode(new __XmlText(input.Prefix)).withName("Prefix");
    bodyNode.addChildNode(node);
  }

  if (input.Tag !== undefined) {
    var node = serializeAws_restXmlTag(input.Tag, context).withName("Tag");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlLifecycleRules = function serializeAws_restXmlLifecycleRules(input, context) {
  return input.map(function (entry) {
    var node = serializeAws_restXmlLifecycleRule(entry, context);
    return node.withName("member");
  });
};

var serializeAws_restXmlLoggingEnabled = function serializeAws_restXmlLoggingEnabled(input, context) {
  var bodyNode = new __XmlNode("LoggingEnabled");

  if (input.TargetGrants !== undefined) {
    var nodes = serializeAws_restXmlTargetGrants(input.TargetGrants, context);
    var containerNode_3 = new __XmlNode("TargetGrants");
    nodes.map(function (node) {
      containerNode_3.addChildNode(node);
    });
    bodyNode.addChildNode(containerNode_3);
  }

  if (input.TargetBucket !== undefined) {
    var node = new __XmlNode("TargetBucket").addChildNode(new __XmlText(input.TargetBucket)).withName("TargetBucket");
    bodyNode.addChildNode(node);
  }

  if (input.TargetPrefix !== undefined) {
    var node = new __XmlNode("TargetPrefix").addChildNode(new __XmlText(input.TargetPrefix)).withName("TargetPrefix");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlMetadataEntry = function serializeAws_restXmlMetadataEntry(input, context) {
  var bodyNode = new __XmlNode("MetadataEntry");

  if (input.Value !== undefined) {
    var node = new __XmlNode("MetadataValue").addChildNode(new __XmlText(input.Value)).withName("Value");
    bodyNode.addChildNode(node);
  }

  if (input.Name !== undefined) {
    var node = new __XmlNode("MetadataKey").addChildNode(new __XmlText(input.Name)).withName("Name");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlMetrics = function serializeAws_restXmlMetrics(input, context) {
  var bodyNode = new __XmlNode("Metrics");

  if (input.Status !== undefined) {
    var node = new __XmlNode("MetricsStatus").addChildNode(new __XmlText(input.Status)).withName("Status");
    bodyNode.addChildNode(node);
  }

  if (input.EventThreshold !== undefined) {
    var node = serializeAws_restXmlReplicationTimeValue(input.EventThreshold, context).withName("EventThreshold");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlMetricsAndOperator = function serializeAws_restXmlMetricsAndOperator(input, context) {
  var bodyNode = new __XmlNode("MetricsAndOperator");

  if (input.Prefix !== undefined) {
    var node = new __XmlNode("Prefix").addChildNode(new __XmlText(input.Prefix)).withName("Prefix");
    bodyNode.addChildNode(node);
  }

  if (input.Tags !== undefined) {
    var nodes = serializeAws_restXmlTagSet(input.Tags, context);
    nodes.map(function (node) {
      node = node.withName("Tag");
      bodyNode.addChildNode(node);
    });
  }

  return bodyNode;
};

var serializeAws_restXmlMetricsConfiguration = function serializeAws_restXmlMetricsConfiguration(input, context) {
  var bodyNode = new __XmlNode("MetricsConfiguration");

  if (input.Id !== undefined) {
    var node = new __XmlNode("MetricsId").addChildNode(new __XmlText(input.Id)).withName("Id");
    bodyNode.addChildNode(node);
  }

  if (input.Filter !== undefined) {
    var node = serializeAws_restXmlMetricsFilter(input.Filter, context).withName("Filter");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlMetricsFilter = function serializeAws_restXmlMetricsFilter(input, context) {
  var bodyNode = new __XmlNode("MetricsFilter");

  if (input.And !== undefined) {
    var node = serializeAws_restXmlMetricsAndOperator(input.And, context).withName("And");
    bodyNode.addChildNode(node);
  }

  if (input.Prefix !== undefined) {
    var node = new __XmlNode("Prefix").addChildNode(new __XmlText(input.Prefix)).withName("Prefix");
    bodyNode.addChildNode(node);
  }

  if (input.Tag !== undefined) {
    var node = serializeAws_restXmlTag(input.Tag, context).withName("Tag");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlNoncurrentVersionExpiration = function serializeAws_restXmlNoncurrentVersionExpiration(input, context) {
  var bodyNode = new __XmlNode("NoncurrentVersionExpiration");

  if (input.NoncurrentDays !== undefined) {
    var node = new __XmlNode("Days").addChildNode(new __XmlText(String(input.NoncurrentDays))).withName("NoncurrentDays");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlNoncurrentVersionTransition = function serializeAws_restXmlNoncurrentVersionTransition(input, context) {
  var bodyNode = new __XmlNode("NoncurrentVersionTransition");

  if (input.StorageClass !== undefined) {
    var node = new __XmlNode("TransitionStorageClass").addChildNode(new __XmlText(input.StorageClass)).withName("StorageClass");
    bodyNode.addChildNode(node);
  }

  if (input.NoncurrentDays !== undefined) {
    var node = new __XmlNode("Days").addChildNode(new __XmlText(String(input.NoncurrentDays))).withName("NoncurrentDays");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlNoncurrentVersionTransitionList = function serializeAws_restXmlNoncurrentVersionTransitionList(input, context) {
  return input.map(function (entry) {
    var node = serializeAws_restXmlNoncurrentVersionTransition(entry, context);
    return node.withName("member");
  });
};

var serializeAws_restXmlNotificationConfiguration = function serializeAws_restXmlNotificationConfiguration(input, context) {
  var bodyNode = new __XmlNode("NotificationConfiguration");

  if (input.TopicConfigurations !== undefined) {
    var nodes = serializeAws_restXmlTopicConfigurationList(input.TopicConfigurations, context);
    nodes.map(function (node) {
      node = node.withName("TopicConfiguration");
      bodyNode.addChildNode(node);
    });
  }

  if (input.QueueConfigurations !== undefined) {
    var nodes = serializeAws_restXmlQueueConfigurationList(input.QueueConfigurations, context);
    nodes.map(function (node) {
      node = node.withName("QueueConfiguration");
      bodyNode.addChildNode(node);
    });
  }

  if (input.LambdaFunctionConfigurations !== undefined) {
    var nodes = serializeAws_restXmlLambdaFunctionConfigurationList(input.LambdaFunctionConfigurations, context);
    nodes.map(function (node) {
      node = node.withName("CloudFunctionConfiguration");
      bodyNode.addChildNode(node);
    });
  }

  return bodyNode;
};

var serializeAws_restXmlNotificationConfigurationFilter = function serializeAws_restXmlNotificationConfigurationFilter(input, context) {
  var bodyNode = new __XmlNode("NotificationConfigurationFilter");

  if (input.Key !== undefined) {
    var node = serializeAws_restXmlS3KeyFilter(input.Key, context).withName("S3Key");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlObjectIdentifier = function serializeAws_restXmlObjectIdentifier(input, context) {
  var bodyNode = new __XmlNode("ObjectIdentifier");

  if (input.Key !== undefined) {
    var node = new __XmlNode("ObjectKey").addChildNode(new __XmlText(input.Key)).withName("Key");
    bodyNode.addChildNode(node);
  }

  if (input.VersionId !== undefined) {
    var node = new __XmlNode("ObjectVersionId").addChildNode(new __XmlText(input.VersionId)).withName("VersionId");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlObjectIdentifierList = function serializeAws_restXmlObjectIdentifierList(input, context) {
  return input.map(function (entry) {
    var node = serializeAws_restXmlObjectIdentifier(entry, context);
    return node.withName("member");
  });
};

var serializeAws_restXmlObjectLockConfiguration = function serializeAws_restXmlObjectLockConfiguration(input, context) {
  var bodyNode = new __XmlNode("ObjectLockConfiguration");

  if (input.ObjectLockEnabled !== undefined) {
    var node = new __XmlNode("ObjectLockEnabled").addChildNode(new __XmlText(input.ObjectLockEnabled)).withName("ObjectLockEnabled");
    bodyNode.addChildNode(node);
  }

  if (input.Rule !== undefined) {
    var node = serializeAws_restXmlObjectLockRule(input.Rule, context).withName("Rule");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlObjectLockLegalHold = function serializeAws_restXmlObjectLockLegalHold(input, context) {
  var bodyNode = new __XmlNode("ObjectLockLegalHold");

  if (input.Status !== undefined) {
    var node = new __XmlNode("ObjectLockLegalHoldStatus").addChildNode(new __XmlText(input.Status)).withName("Status");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlObjectLockRetention = function serializeAws_restXmlObjectLockRetention(input, context) {
  var bodyNode = new __XmlNode("ObjectLockRetention");

  if (input.Mode !== undefined) {
    var node = new __XmlNode("ObjectLockRetentionMode").addChildNode(new __XmlText(input.Mode)).withName("Mode");
    bodyNode.addChildNode(node);
  }

  if (input.RetainUntilDate !== undefined) {
    var node = new __XmlNode("Date").addChildNode(new __XmlText(input.RetainUntilDate.toISOString().split(".")[0] + "Z")).withName("RetainUntilDate");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlObjectLockRule = function serializeAws_restXmlObjectLockRule(input, context) {
  var bodyNode = new __XmlNode("ObjectLockRule");

  if (input.DefaultRetention !== undefined) {
    var node = serializeAws_restXmlDefaultRetention(input.DefaultRetention, context).withName("DefaultRetention");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlOutputLocation = function serializeAws_restXmlOutputLocation(input, context) {
  var bodyNode = new __XmlNode("OutputLocation");

  if (input.S3 !== undefined) {
    var node = serializeAws_restXmlS3Location(input.S3, context).withName("S3");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlOutputSerialization = function serializeAws_restXmlOutputSerialization(input, context) {
  var bodyNode = new __XmlNode("OutputSerialization");

  if (input.JSON !== undefined) {
    var node = serializeAws_restXmlJSONOutput(input.JSON, context).withName("JSON");
    bodyNode.addChildNode(node);
  }

  if (input.CSV !== undefined) {
    var node = serializeAws_restXmlCSVOutput(input.CSV, context).withName("CSV");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlOwner = function serializeAws_restXmlOwner(input, context) {
  var bodyNode = new __XmlNode("Owner");

  if (input.DisplayName !== undefined) {
    var node = new __XmlNode("DisplayName").addChildNode(new __XmlText(input.DisplayName)).withName("DisplayName");
    bodyNode.addChildNode(node);
  }

  if (input.ID !== undefined) {
    var node = new __XmlNode("ID").addChildNode(new __XmlText(input.ID)).withName("ID");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlOwnershipControls = function serializeAws_restXmlOwnershipControls(input, context) {
  var bodyNode = new __XmlNode("OwnershipControls");

  if (input.Rules !== undefined) {
    var nodes = serializeAws_restXmlOwnershipControlsRules(input.Rules, context);
    nodes.map(function (node) {
      node = node.withName("Rule");
      bodyNode.addChildNode(node);
    });
  }

  return bodyNode;
};

var serializeAws_restXmlOwnershipControlsRule = function serializeAws_restXmlOwnershipControlsRule(input, context) {
  var bodyNode = new __XmlNode("OwnershipControlsRule");

  if (input.ObjectOwnership !== undefined) {
    var node = new __XmlNode("ObjectOwnership").addChildNode(new __XmlText(input.ObjectOwnership)).withName("ObjectOwnership");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlOwnershipControlsRules = function serializeAws_restXmlOwnershipControlsRules(input, context) {
  return input.map(function (entry) {
    var node = serializeAws_restXmlOwnershipControlsRule(entry, context);
    return node.withName("member");
  });
};

var serializeAws_restXmlParquetInput = function serializeAws_restXmlParquetInput(input, context) {
  var bodyNode = new __XmlNode("ParquetInput");
  return bodyNode;
};

var serializeAws_restXmlPublicAccessBlockConfiguration = function serializeAws_restXmlPublicAccessBlockConfiguration(input, context) {
  var bodyNode = new __XmlNode("PublicAccessBlockConfiguration");

  if (input.BlockPublicPolicy !== undefined) {
    var node = new __XmlNode("Setting").addChildNode(new __XmlText(String(input.BlockPublicPolicy))).withName("BlockPublicPolicy");
    bodyNode.addChildNode(node);
  }

  if (input.BlockPublicAcls !== undefined) {
    var node = new __XmlNode("Setting").addChildNode(new __XmlText(String(input.BlockPublicAcls))).withName("BlockPublicAcls");
    bodyNode.addChildNode(node);
  }

  if (input.RestrictPublicBuckets !== undefined) {
    var node = new __XmlNode("Setting").addChildNode(new __XmlText(String(input.RestrictPublicBuckets))).withName("RestrictPublicBuckets");
    bodyNode.addChildNode(node);
  }

  if (input.IgnorePublicAcls !== undefined) {
    var node = new __XmlNode("Setting").addChildNode(new __XmlText(String(input.IgnorePublicAcls))).withName("IgnorePublicAcls");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlQueueConfiguration = function serializeAws_restXmlQueueConfiguration(input, context) {
  var bodyNode = new __XmlNode("QueueConfiguration");

  if (input.Events !== undefined) {
    var nodes = serializeAws_restXmlEventList(input.Events, context);
    nodes.map(function (node) {
      node = node.withName("Event");
      bodyNode.addChildNode(node);
    });
  }

  if (input.Id !== undefined) {
    var node = new __XmlNode("NotificationId").addChildNode(new __XmlText(input.Id)).withName("Id");
    bodyNode.addChildNode(node);
  }

  if (input.Filter !== undefined) {
    var node = serializeAws_restXmlNotificationConfigurationFilter(input.Filter, context).withName("Filter");
    bodyNode.addChildNode(node);
  }

  if (input.QueueArn !== undefined) {
    var node = new __XmlNode("QueueArn").addChildNode(new __XmlText(input.QueueArn)).withName("Queue");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlQueueConfigurationList = function serializeAws_restXmlQueueConfigurationList(input, context) {
  return input.map(function (entry) {
    var node = serializeAws_restXmlQueueConfiguration(entry, context);
    return node.withName("member");
  });
};

var serializeAws_restXmlRedirect = function serializeAws_restXmlRedirect(input, context) {
  var bodyNode = new __XmlNode("Redirect");

  if (input.HttpRedirectCode !== undefined) {
    var node = new __XmlNode("HttpRedirectCode").addChildNode(new __XmlText(input.HttpRedirectCode)).withName("HttpRedirectCode");
    bodyNode.addChildNode(node);
  }

  if (input.ReplaceKeyPrefixWith !== undefined) {
    var node = new __XmlNode("ReplaceKeyPrefixWith").addChildNode(new __XmlText(input.ReplaceKeyPrefixWith)).withName("ReplaceKeyPrefixWith");
    bodyNode.addChildNode(node);
  }

  if (input.Protocol !== undefined) {
    var node = new __XmlNode("Protocol").addChildNode(new __XmlText(input.Protocol)).withName("Protocol");
    bodyNode.addChildNode(node);
  }

  if (input.HostName !== undefined) {
    var node = new __XmlNode("HostName").addChildNode(new __XmlText(input.HostName)).withName("HostName");
    bodyNode.addChildNode(node);
  }

  if (input.ReplaceKeyWith !== undefined) {
    var node = new __XmlNode("ReplaceKeyWith").addChildNode(new __XmlText(input.ReplaceKeyWith)).withName("ReplaceKeyWith");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlRedirectAllRequestsTo = function serializeAws_restXmlRedirectAllRequestsTo(input, context) {
  var bodyNode = new __XmlNode("RedirectAllRequestsTo");

  if (input.Protocol !== undefined) {
    var node = new __XmlNode("Protocol").addChildNode(new __XmlText(input.Protocol)).withName("Protocol");
    bodyNode.addChildNode(node);
  }

  if (input.HostName !== undefined) {
    var node = new __XmlNode("HostName").addChildNode(new __XmlText(input.HostName)).withName("HostName");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlReplicationConfiguration = function serializeAws_restXmlReplicationConfiguration(input, context) {
  var bodyNode = new __XmlNode("ReplicationConfiguration");

  if (input.Role !== undefined) {
    var node = new __XmlNode("Role").addChildNode(new __XmlText(input.Role)).withName("Role");
    bodyNode.addChildNode(node);
  }

  if (input.Rules !== undefined) {
    var nodes = serializeAws_restXmlReplicationRules(input.Rules, context);
    nodes.map(function (node) {
      node = node.withName("Rule");
      bodyNode.addChildNode(node);
    });
  }

  return bodyNode;
};

var serializeAws_restXmlReplicationRule = function serializeAws_restXmlReplicationRule(input, context) {
  var bodyNode = new __XmlNode("ReplicationRule");

  if (input.Prefix !== undefined) {
    var node = new __XmlNode("Prefix").addChildNode(new __XmlText(input.Prefix)).withName("Prefix");
    bodyNode.addChildNode(node);
  }

  if (input.ID !== undefined) {
    var node = new __XmlNode("ID").addChildNode(new __XmlText(input.ID)).withName("ID");
    bodyNode.addChildNode(node);
  }

  if (input.SourceSelectionCriteria !== undefined) {
    var node = serializeAws_restXmlSourceSelectionCriteria(input.SourceSelectionCriteria, context).withName("SourceSelectionCriteria");
    bodyNode.addChildNode(node);
  }

  if (input.DeleteMarkerReplication !== undefined) {
    var node = serializeAws_restXmlDeleteMarkerReplication(input.DeleteMarkerReplication, context).withName("DeleteMarkerReplication");
    bodyNode.addChildNode(node);
  }

  if (input.Filter !== undefined) {
    var node = serializeAws_restXmlReplicationRuleFilter(input.Filter, context).withName("Filter");
    bodyNode.addChildNode(node);
  }

  if (input.Priority !== undefined) {
    var node = new __XmlNode("Priority").addChildNode(new __XmlText(String(input.Priority))).withName("Priority");
    bodyNode.addChildNode(node);
  }

  if (input.Status !== undefined) {
    var node = new __XmlNode("ReplicationRuleStatus").addChildNode(new __XmlText(input.Status)).withName("Status");
    bodyNode.addChildNode(node);
  }

  if (input.ExistingObjectReplication !== undefined) {
    var node = serializeAws_restXmlExistingObjectReplication(input.ExistingObjectReplication, context).withName("ExistingObjectReplication");
    bodyNode.addChildNode(node);
  }

  if (input.Destination !== undefined) {
    var node = serializeAws_restXmlDestination(input.Destination, context).withName("Destination");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlReplicationRuleAndOperator = function serializeAws_restXmlReplicationRuleAndOperator(input, context) {
  var bodyNode = new __XmlNode("ReplicationRuleAndOperator");

  if (input.Prefix !== undefined) {
    var node = new __XmlNode("Prefix").addChildNode(new __XmlText(input.Prefix)).withName("Prefix");
    bodyNode.addChildNode(node);
  }

  if (input.Tags !== undefined) {
    var nodes = serializeAws_restXmlTagSet(input.Tags, context);
    nodes.map(function (node) {
      node = node.withName("Tag");
      bodyNode.addChildNode(node);
    });
  }

  return bodyNode;
};

var serializeAws_restXmlReplicationRuleFilter = function serializeAws_restXmlReplicationRuleFilter(input, context) {
  var bodyNode = new __XmlNode("ReplicationRuleFilter");

  if (input.Tag !== undefined) {
    var node = serializeAws_restXmlTag(input.Tag, context).withName("Tag");
    bodyNode.addChildNode(node);
  }

  if (input.Prefix !== undefined) {
    var node = new __XmlNode("Prefix").addChildNode(new __XmlText(input.Prefix)).withName("Prefix");
    bodyNode.addChildNode(node);
  }

  if (input.And !== undefined) {
    var node = serializeAws_restXmlReplicationRuleAndOperator(input.And, context).withName("And");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlReplicationRules = function serializeAws_restXmlReplicationRules(input, context) {
  return input.map(function (entry) {
    var node = serializeAws_restXmlReplicationRule(entry, context);
    return node.withName("member");
  });
};

var serializeAws_restXmlReplicationTime = function serializeAws_restXmlReplicationTime(input, context) {
  var bodyNode = new __XmlNode("ReplicationTime");

  if (input.Time !== undefined) {
    var node = serializeAws_restXmlReplicationTimeValue(input.Time, context).withName("Time");
    bodyNode.addChildNode(node);
  }

  if (input.Status !== undefined) {
    var node = new __XmlNode("ReplicationTimeStatus").addChildNode(new __XmlText(input.Status)).withName("Status");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlReplicationTimeValue = function serializeAws_restXmlReplicationTimeValue(input, context) {
  var bodyNode = new __XmlNode("ReplicationTimeValue");

  if (input.Minutes !== undefined) {
    var node = new __XmlNode("Minutes").addChildNode(new __XmlText(String(input.Minutes))).withName("Minutes");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlRequestPaymentConfiguration = function serializeAws_restXmlRequestPaymentConfiguration(input, context) {
  var bodyNode = new __XmlNode("RequestPaymentConfiguration");

  if (input.Payer !== undefined) {
    var node = new __XmlNode("Payer").addChildNode(new __XmlText(input.Payer)).withName("Payer");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlRequestProgress = function serializeAws_restXmlRequestProgress(input, context) {
  var bodyNode = new __XmlNode("RequestProgress");

  if (input.Enabled !== undefined) {
    var node = new __XmlNode("EnableRequestProgress").addChildNode(new __XmlText(String(input.Enabled))).withName("Enabled");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlRestoreRequest = function serializeAws_restXmlRestoreRequest(input, context) {
  var bodyNode = new __XmlNode("RestoreRequest");

  if (input.GlacierJobParameters !== undefined) {
    var node = serializeAws_restXmlGlacierJobParameters(input.GlacierJobParameters, context).withName("GlacierJobParameters");
    bodyNode.addChildNode(node);
  }

  if (input.Days !== undefined) {
    var node = new __XmlNode("Days").addChildNode(new __XmlText(String(input.Days))).withName("Days");
    bodyNode.addChildNode(node);
  }

  if (input.OutputLocation !== undefined) {
    var node = serializeAws_restXmlOutputLocation(input.OutputLocation, context).withName("OutputLocation");
    bodyNode.addChildNode(node);
  }

  if (input.SelectParameters !== undefined) {
    var node = serializeAws_restXmlSelectParameters(input.SelectParameters, context).withName("SelectParameters");
    bodyNode.addChildNode(node);
  }

  if (input.Tier !== undefined) {
    var node = new __XmlNode("Tier").addChildNode(new __XmlText(input.Tier)).withName("Tier");
    bodyNode.addChildNode(node);
  }

  if (input.Description !== undefined) {
    var node = new __XmlNode("Description").addChildNode(new __XmlText(input.Description)).withName("Description");
    bodyNode.addChildNode(node);
  }

  if (input.Type !== undefined) {
    var node = new __XmlNode("RestoreRequestType").addChildNode(new __XmlText(input.Type)).withName("Type");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlRoutingRule = function serializeAws_restXmlRoutingRule(input, context) {
  var bodyNode = new __XmlNode("RoutingRule");

  if (input.Redirect !== undefined) {
    var node = serializeAws_restXmlRedirect(input.Redirect, context).withName("Redirect");
    bodyNode.addChildNode(node);
  }

  if (input.Condition !== undefined) {
    var node = serializeAws_restXmlCondition(input.Condition, context).withName("Condition");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlRoutingRules = function serializeAws_restXmlRoutingRules(input, context) {
  return input.map(function (entry) {
    var node = serializeAws_restXmlRoutingRule(entry, context);
    return node.withName("RoutingRule");
  });
};

var serializeAws_restXmlS3KeyFilter = function serializeAws_restXmlS3KeyFilter(input, context) {
  var bodyNode = new __XmlNode("S3KeyFilter");

  if (input.FilterRules !== undefined) {
    var nodes = serializeAws_restXmlFilterRuleList(input.FilterRules, context);
    nodes.map(function (node) {
      node = node.withName("FilterRule");
      bodyNode.addChildNode(node);
    });
  }

  return bodyNode;
};

var serializeAws_restXmlS3Location = function serializeAws_restXmlS3Location(input, context) {
  var bodyNode = new __XmlNode("S3Location");

  if (input.BucketName !== undefined) {
    var node = new __XmlNode("BucketName").addChildNode(new __XmlText(input.BucketName)).withName("BucketName");
    bodyNode.addChildNode(node);
  }

  if (input.StorageClass !== undefined) {
    var node = new __XmlNode("StorageClass").addChildNode(new __XmlText(input.StorageClass)).withName("StorageClass");
    bodyNode.addChildNode(node);
  }

  if (input.CannedACL !== undefined) {
    var node = new __XmlNode("ObjectCannedACL").addChildNode(new __XmlText(input.CannedACL)).withName("CannedACL");
    bodyNode.addChildNode(node);
  }

  if (input.UserMetadata !== undefined) {
    var nodes = serializeAws_restXmlUserMetadata(input.UserMetadata, context);
    var containerNode_4 = new __XmlNode("UserMetadata");
    nodes.map(function (node) {
      containerNode_4.addChildNode(node);
    });
    bodyNode.addChildNode(containerNode_4);
  }

  if (input.Prefix !== undefined) {
    var node = new __XmlNode("LocationPrefix").addChildNode(new __XmlText(input.Prefix)).withName("Prefix");
    bodyNode.addChildNode(node);
  }

  if (input.Tagging !== undefined) {
    var node = serializeAws_restXmlTagging(input.Tagging, context).withName("Tagging");
    bodyNode.addChildNode(node);
  }

  if (input.Encryption !== undefined) {
    var node = serializeAws_restXmlEncryption(input.Encryption, context).withName("Encryption");
    bodyNode.addChildNode(node);
  }

  if (input.AccessControlList !== undefined) {
    var nodes = serializeAws_restXmlGrants(input.AccessControlList, context);
    var containerNode_5 = new __XmlNode("AccessControlList");
    nodes.map(function (node) {
      containerNode_5.addChildNode(node);
    });
    bodyNode.addChildNode(containerNode_5);
  }

  return bodyNode;
};

var serializeAws_restXmlScanRange = function serializeAws_restXmlScanRange(input, context) {
  var bodyNode = new __XmlNode("ScanRange");

  if (input.End !== undefined) {
    var node = new __XmlNode("End").addChildNode(new __XmlText(String(input.End))).withName("End");
    bodyNode.addChildNode(node);
  }

  if (input.Start !== undefined) {
    var node = new __XmlNode("Start").addChildNode(new __XmlText(String(input.Start))).withName("Start");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlSelectParameters = function serializeAws_restXmlSelectParameters(input, context) {
  var bodyNode = new __XmlNode("SelectParameters");

  if (input.ExpressionType !== undefined) {
    var node = new __XmlNode("ExpressionType").addChildNode(new __XmlText(input.ExpressionType)).withName("ExpressionType");
    bodyNode.addChildNode(node);
  }

  if (input.OutputSerialization !== undefined) {
    var node = serializeAws_restXmlOutputSerialization(input.OutputSerialization, context).withName("OutputSerialization");
    bodyNode.addChildNode(node);
  }

  if (input.Expression !== undefined) {
    var node = new __XmlNode("Expression").addChildNode(new __XmlText(input.Expression)).withName("Expression");
    bodyNode.addChildNode(node);
  }

  if (input.InputSerialization !== undefined) {
    var node = serializeAws_restXmlInputSerialization(input.InputSerialization, context).withName("InputSerialization");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlServerSideEncryptionByDefault = function serializeAws_restXmlServerSideEncryptionByDefault(input, context) {
  var bodyNode = new __XmlNode("ServerSideEncryptionByDefault");

  if (input.SSEAlgorithm !== undefined) {
    var node = new __XmlNode("ServerSideEncryption").addChildNode(new __XmlText(input.SSEAlgorithm)).withName("SSEAlgorithm");
    bodyNode.addChildNode(node);
  }

  if (input.KMSMasterKeyID !== undefined) {
    var node = new __XmlNode("SSEKMSKeyId").addChildNode(new __XmlText(input.KMSMasterKeyID)).withName("KMSMasterKeyID");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlServerSideEncryptionConfiguration = function serializeAws_restXmlServerSideEncryptionConfiguration(input, context) {
  var bodyNode = new __XmlNode("ServerSideEncryptionConfiguration");

  if (input.Rules !== undefined) {
    var nodes = serializeAws_restXmlServerSideEncryptionRules(input.Rules, context);
    nodes.map(function (node) {
      node = node.withName("Rule");
      bodyNode.addChildNode(node);
    });
  }

  return bodyNode;
};

var serializeAws_restXmlServerSideEncryptionRule = function serializeAws_restXmlServerSideEncryptionRule(input, context) {
  var bodyNode = new __XmlNode("ServerSideEncryptionRule");

  if (input.ApplyServerSideEncryptionByDefault !== undefined) {
    var node = serializeAws_restXmlServerSideEncryptionByDefault(input.ApplyServerSideEncryptionByDefault, context).withName("ApplyServerSideEncryptionByDefault");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlServerSideEncryptionRules = function serializeAws_restXmlServerSideEncryptionRules(input, context) {
  return input.map(function (entry) {
    var node = serializeAws_restXmlServerSideEncryptionRule(entry, context);
    return node.withName("member");
  });
};

var serializeAws_restXmlSourceSelectionCriteria = function serializeAws_restXmlSourceSelectionCriteria(input, context) {
  var bodyNode = new __XmlNode("SourceSelectionCriteria");

  if (input.SseKmsEncryptedObjects !== undefined) {
    var node = serializeAws_restXmlSseKmsEncryptedObjects(input.SseKmsEncryptedObjects, context).withName("SseKmsEncryptedObjects");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlSSEKMS = function serializeAws_restXmlSSEKMS(input, context) {
  var bodyNode = new __XmlNode("SSE-KMS");

  if (input.KeyId !== undefined) {
    var node = new __XmlNode("SSEKMSKeyId").addChildNode(new __XmlText(input.KeyId)).withName("KeyId");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlSseKmsEncryptedObjects = function serializeAws_restXmlSseKmsEncryptedObjects(input, context) {
  var bodyNode = new __XmlNode("SseKmsEncryptedObjects");

  if (input.Status !== undefined) {
    var node = new __XmlNode("SseKmsEncryptedObjectsStatus").addChildNode(new __XmlText(input.Status)).withName("Status");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlSSES3 = function serializeAws_restXmlSSES3(input, context) {
  var bodyNode = new __XmlNode("SSE-S3");
  return bodyNode;
};

var serializeAws_restXmlStorageClassAnalysis = function serializeAws_restXmlStorageClassAnalysis(input, context) {
  var bodyNode = new __XmlNode("StorageClassAnalysis");

  if (input.DataExport !== undefined) {
    var node = serializeAws_restXmlStorageClassAnalysisDataExport(input.DataExport, context).withName("DataExport");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlStorageClassAnalysisDataExport = function serializeAws_restXmlStorageClassAnalysisDataExport(input, context) {
  var bodyNode = new __XmlNode("StorageClassAnalysisDataExport");

  if (input.OutputSchemaVersion !== undefined) {
    var node = new __XmlNode("StorageClassAnalysisSchemaVersion").addChildNode(new __XmlText(input.OutputSchemaVersion)).withName("OutputSchemaVersion");
    bodyNode.addChildNode(node);
  }

  if (input.Destination !== undefined) {
    var node = serializeAws_restXmlAnalyticsExportDestination(input.Destination, context).withName("Destination");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlTag = function serializeAws_restXmlTag(input, context) {
  var bodyNode = new __XmlNode("Tag");

  if (input.Value !== undefined) {
    var node = new __XmlNode("Value").addChildNode(new __XmlText(input.Value)).withName("Value");
    bodyNode.addChildNode(node);
  }

  if (input.Key !== undefined) {
    var node = new __XmlNode("ObjectKey").addChildNode(new __XmlText(input.Key)).withName("Key");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlTagging = function serializeAws_restXmlTagging(input, context) {
  var bodyNode = new __XmlNode("Tagging");

  if (input.TagSet !== undefined) {
    var nodes = serializeAws_restXmlTagSet(input.TagSet, context);
    var containerNode_6 = new __XmlNode("TagSet");
    nodes.map(function (node) {
      containerNode_6.addChildNode(node);
    });
    bodyNode.addChildNode(containerNode_6);
  }

  return bodyNode;
};

var serializeAws_restXmlTagSet = function serializeAws_restXmlTagSet(input, context) {
  return input.map(function (entry) {
    var node = serializeAws_restXmlTag(entry, context);
    return node.withName("Tag");
  });
};

var serializeAws_restXmlTargetGrant = function serializeAws_restXmlTargetGrant(input, context) {
  var bodyNode = new __XmlNode("TargetGrant");

  if (input.Grantee !== undefined) {
    var node = serializeAws_restXmlGrantee(input.Grantee, context).withName("Grantee");
    bodyNode.addChildNode(node);
  }

  if (input.Permission !== undefined) {
    var node = new __XmlNode("BucketLogsPermission").addChildNode(new __XmlText(input.Permission)).withName("Permission");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlTargetGrants = function serializeAws_restXmlTargetGrants(input, context) {
  return input.map(function (entry) {
    var node = serializeAws_restXmlTargetGrant(entry, context);
    return node.withName("Grant");
  });
};

var serializeAws_restXmlTopicConfiguration = function serializeAws_restXmlTopicConfiguration(input, context) {
  var bodyNode = new __XmlNode("TopicConfiguration");

  if (input.Events !== undefined) {
    var nodes = serializeAws_restXmlEventList(input.Events, context);
    nodes.map(function (node) {
      node = node.withName("Event");
      bodyNode.addChildNode(node);
    });
  }

  if (input.Filter !== undefined) {
    var node = serializeAws_restXmlNotificationConfigurationFilter(input.Filter, context).withName("Filter");
    bodyNode.addChildNode(node);
  }

  if (input.TopicArn !== undefined) {
    var node = new __XmlNode("TopicArn").addChildNode(new __XmlText(input.TopicArn)).withName("Topic");
    bodyNode.addChildNode(node);
  }

  if (input.Id !== undefined) {
    var node = new __XmlNode("NotificationId").addChildNode(new __XmlText(input.Id)).withName("Id");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlTopicConfigurationList = function serializeAws_restXmlTopicConfigurationList(input, context) {
  return input.map(function (entry) {
    var node = serializeAws_restXmlTopicConfiguration(entry, context);
    return node.withName("member");
  });
};

var serializeAws_restXmlTransition = function serializeAws_restXmlTransition(input, context) {
  var bodyNode = new __XmlNode("Transition");

  if (input.Days !== undefined) {
    var node = new __XmlNode("Days").addChildNode(new __XmlText(String(input.Days))).withName("Days");
    bodyNode.addChildNode(node);
  }

  if (input.Date !== undefined) {
    var node = new __XmlNode("Date").addChildNode(new __XmlText(input.Date.toISOString().split(".")[0] + "Z")).withName("Date");
    bodyNode.addChildNode(node);
  }

  if (input.StorageClass !== undefined) {
    var node = new __XmlNode("TransitionStorageClass").addChildNode(new __XmlText(input.StorageClass)).withName("StorageClass");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlTransitionList = function serializeAws_restXmlTransitionList(input, context) {
  return input.map(function (entry) {
    var node = serializeAws_restXmlTransition(entry, context);
    return node.withName("member");
  });
};

var serializeAws_restXmlUserMetadata = function serializeAws_restXmlUserMetadata(input, context) {
  return input.map(function (entry) {
    var node = serializeAws_restXmlMetadataEntry(entry, context);
    return node.withName("MetadataEntry");
  });
};

var serializeAws_restXmlVersioningConfiguration = function serializeAws_restXmlVersioningConfiguration(input, context) {
  var bodyNode = new __XmlNode("VersioningConfiguration");

  if (input.Status !== undefined) {
    var node = new __XmlNode("BucketVersioningStatus").addChildNode(new __XmlText(input.Status)).withName("Status");
    bodyNode.addChildNode(node);
  }

  if (input.MFADelete !== undefined) {
    var node = new __XmlNode("MFADelete").addChildNode(new __XmlText(input.MFADelete)).withName("MfaDelete");
    bodyNode.addChildNode(node);
  }

  return bodyNode;
};

var serializeAws_restXmlWebsiteConfiguration = function serializeAws_restXmlWebsiteConfiguration(input, context) {
  var bodyNode = new __XmlNode("WebsiteConfiguration");

  if (input.ErrorDocument !== undefined) {
    var node = serializeAws_restXmlErrorDocument(input.ErrorDocument, context).withName("ErrorDocument");
    bodyNode.addChildNode(node);
  }

  if (input.RedirectAllRequestsTo !== undefined) {
    var node = serializeAws_restXmlRedirectAllRequestsTo(input.RedirectAllRequestsTo, context).withName("RedirectAllRequestsTo");
    bodyNode.addChildNode(node);
  }

  if (input.IndexDocument !== undefined) {
    var node = serializeAws_restXmlIndexDocument(input.IndexDocument, context).withName("IndexDocument");
    bodyNode.addChildNode(node);
  }

  if (input.RoutingRules !== undefined) {
    var nodes = serializeAws_restXmlRoutingRules(input.RoutingRules, context);
    var containerNode_7 = new __XmlNode("RoutingRules");
    nodes.map(function (node) {
      containerNode_7.addChildNode(node);
    });
    bodyNode.addChildNode(containerNode_7);
  }

  return bodyNode;
};

var deserializeAws_restXmlAbortIncompleteMultipartUpload = function deserializeAws_restXmlAbortIncompleteMultipartUpload(output, context) {
  var contents = {
    DaysAfterInitiation: undefined
  };

  if (output["DaysAfterInitiation"] !== undefined) {
    contents.DaysAfterInitiation = parseInt(output["DaysAfterInitiation"]);
  }

  return contents;
};

var deserializeAws_restXmlAccessControlTranslation = function deserializeAws_restXmlAccessControlTranslation(output, context) {
  var contents = {
    Owner: undefined
  };

  if (output["Owner"] !== undefined) {
    contents.Owner = output["Owner"];
  }

  return contents;
};

var deserializeAws_restXmlAllowedHeaders = function deserializeAws_restXmlAllowedHeaders(output, context) {
  return (output || []).map(function (entry) {
    return entry;
  });
};

var deserializeAws_restXmlAllowedMethods = function deserializeAws_restXmlAllowedMethods(output, context) {
  return (output || []).map(function (entry) {
    return entry;
  });
};

var deserializeAws_restXmlAllowedOrigins = function deserializeAws_restXmlAllowedOrigins(output, context) {
  return (output || []).map(function (entry) {
    return entry;
  });
};

var deserializeAws_restXmlAnalyticsAndOperator = function deserializeAws_restXmlAnalyticsAndOperator(output, context) {
  var contents = {
    Prefix: undefined,
    Tags: undefined
  };

  if (output["Prefix"] !== undefined) {
    contents.Prefix = output["Prefix"];
  }

  if (output.Tag === "") {
    contents.Tags = [];
  }

  if (output["Tag"] !== undefined) {
    contents.Tags = deserializeAws_restXmlTagSet(__getArrayIfSingleItem(output["Tag"]), context);
  }

  return contents;
};

var deserializeAws_restXmlAnalyticsConfiguration = function deserializeAws_restXmlAnalyticsConfiguration(output, context) {
  var contents = {
    StorageClassAnalysis: undefined,
    Filter: undefined,
    Id: undefined
  };

  if (output["StorageClassAnalysis"] !== undefined) {
    contents.StorageClassAnalysis = deserializeAws_restXmlStorageClassAnalysis(output["StorageClassAnalysis"], context);
  }

  if (output["Filter"] !== undefined) {
    contents.Filter = deserializeAws_restXmlAnalyticsFilter(output["Filter"], context);
  }

  if (output["Id"] !== undefined) {
    contents.Id = output["Id"];
  }

  return contents;
};

var deserializeAws_restXmlAnalyticsConfigurationList = function deserializeAws_restXmlAnalyticsConfigurationList(output, context) {
  return (output || []).map(function (entry) {
    return deserializeAws_restXmlAnalyticsConfiguration(entry, context);
  });
};

var deserializeAws_restXmlAnalyticsExportDestination = function deserializeAws_restXmlAnalyticsExportDestination(output, context) {
  var contents = {
    S3BucketDestination: undefined
  };

  if (output["S3BucketDestination"] !== undefined) {
    contents.S3BucketDestination = deserializeAws_restXmlAnalyticsS3BucketDestination(output["S3BucketDestination"], context);
  }

  return contents;
};

var deserializeAws_restXmlAnalyticsFilter = function deserializeAws_restXmlAnalyticsFilter(output, context) {
  var contents = {
    Prefix: undefined,
    Tag: undefined,
    And: undefined
  };

  if (output["Prefix"] !== undefined) {
    contents.Prefix = output["Prefix"];
  }

  if (output["Tag"] !== undefined) {
    contents.Tag = deserializeAws_restXmlTag(output["Tag"], context);
  }

  if (output["And"] !== undefined) {
    contents.And = deserializeAws_restXmlAnalyticsAndOperator(output["And"], context);
  }

  return contents;
};

var deserializeAws_restXmlAnalyticsS3BucketDestination = function deserializeAws_restXmlAnalyticsS3BucketDestination(output, context) {
  var contents = {
    Prefix: undefined,
    BucketAccountId: undefined,
    Bucket: undefined,
    Format: undefined
  };

  if (output["Prefix"] !== undefined) {
    contents.Prefix = output["Prefix"];
  }

  if (output["BucketAccountId"] !== undefined) {
    contents.BucketAccountId = output["BucketAccountId"];
  }

  if (output["Bucket"] !== undefined) {
    contents.Bucket = output["Bucket"];
  }

  if (output["Format"] !== undefined) {
    contents.Format = output["Format"];
  }

  return contents;
};

var deserializeAws_restXmlBucket = function deserializeAws_restXmlBucket(output, context) {
  var contents = {
    CreationDate: undefined,
    Name: undefined
  };

  if (output["CreationDate"] !== undefined) {
    contents.CreationDate = new Date(output["CreationDate"]);
  }

  if (output["Name"] !== undefined) {
    contents.Name = output["Name"];
  }

  return contents;
};

var deserializeAws_restXmlBuckets = function deserializeAws_restXmlBuckets(output, context) {
  return (output || []).map(function (entry) {
    return deserializeAws_restXmlBucket(entry, context);
  });
};

var deserializeAws_restXmlCommonPrefix = function deserializeAws_restXmlCommonPrefix(output, context) {
  var contents = {
    Prefix: undefined
  };

  if (output["Prefix"] !== undefined) {
    contents.Prefix = output["Prefix"];
  }

  return contents;
};

var deserializeAws_restXmlCommonPrefixList = function deserializeAws_restXmlCommonPrefixList(output, context) {
  return (output || []).map(function (entry) {
    return deserializeAws_restXmlCommonPrefix(entry, context);
  });
};

var deserializeAws_restXmlCondition = function deserializeAws_restXmlCondition(output, context) {
  var contents = {
    KeyPrefixEquals: undefined,
    HttpErrorCodeReturnedEquals: undefined
  };

  if (output["KeyPrefixEquals"] !== undefined) {
    contents.KeyPrefixEquals = output["KeyPrefixEquals"];
  }

  if (output["HttpErrorCodeReturnedEquals"] !== undefined) {
    contents.HttpErrorCodeReturnedEquals = output["HttpErrorCodeReturnedEquals"];
  }

  return contents;
};

var deserializeAws_restXmlCopyObjectResult = function deserializeAws_restXmlCopyObjectResult(output, context) {
  var contents = {
    ETag: undefined,
    LastModified: undefined
  };

  if (output["ETag"] !== undefined) {
    contents.ETag = output["ETag"];
  }

  if (output["LastModified"] !== undefined) {
    contents.LastModified = new Date(output["LastModified"]);
  }

  return contents;
};

var deserializeAws_restXmlCopyPartResult = function deserializeAws_restXmlCopyPartResult(output, context) {
  var contents = {
    ETag: undefined,
    LastModified: undefined
  };

  if (output["ETag"] !== undefined) {
    contents.ETag = output["ETag"];
  }

  if (output["LastModified"] !== undefined) {
    contents.LastModified = new Date(output["LastModified"]);
  }

  return contents;
};

var deserializeAws_restXmlCORSRule = function deserializeAws_restXmlCORSRule(output, context) {
  var contents = {
    AllowedHeaders: undefined,
    AllowedOrigins: undefined,
    MaxAgeSeconds: undefined,
    ExposeHeaders: undefined,
    AllowedMethods: undefined
  };

  if (output.AllowedHeader === "") {
    contents.AllowedHeaders = [];
  }

  if (output["AllowedHeader"] !== undefined) {
    contents.AllowedHeaders = deserializeAws_restXmlAllowedHeaders(__getArrayIfSingleItem(output["AllowedHeader"]), context);
  }

  if (output.AllowedOrigin === "") {
    contents.AllowedOrigins = [];
  }

  if (output["AllowedOrigin"] !== undefined) {
    contents.AllowedOrigins = deserializeAws_restXmlAllowedOrigins(__getArrayIfSingleItem(output["AllowedOrigin"]), context);
  }

  if (output["MaxAgeSeconds"] !== undefined) {
    contents.MaxAgeSeconds = parseInt(output["MaxAgeSeconds"]);
  }

  if (output.ExposeHeader === "") {
    contents.ExposeHeaders = [];
  }

  if (output["ExposeHeader"] !== undefined) {
    contents.ExposeHeaders = deserializeAws_restXmlExposeHeaders(__getArrayIfSingleItem(output["ExposeHeader"]), context);
  }

  if (output.AllowedMethod === "") {
    contents.AllowedMethods = [];
  }

  if (output["AllowedMethod"] !== undefined) {
    contents.AllowedMethods = deserializeAws_restXmlAllowedMethods(__getArrayIfSingleItem(output["AllowedMethod"]), context);
  }

  return contents;
};

var deserializeAws_restXmlCORSRules = function deserializeAws_restXmlCORSRules(output, context) {
  return (output || []).map(function (entry) {
    return deserializeAws_restXmlCORSRule(entry, context);
  });
};

var deserializeAws_restXmlDefaultRetention = function deserializeAws_restXmlDefaultRetention(output, context) {
  var contents = {
    Days: undefined,
    Mode: undefined,
    Years: undefined
  };

  if (output["Days"] !== undefined) {
    contents.Days = parseInt(output["Days"]);
  }

  if (output["Mode"] !== undefined) {
    contents.Mode = output["Mode"];
  }

  if (output["Years"] !== undefined) {
    contents.Years = parseInt(output["Years"]);
  }

  return contents;
};

var deserializeAws_restXmlDeletedObject = function deserializeAws_restXmlDeletedObject(output, context) {
  var contents = {
    DeleteMarker: undefined,
    Key: undefined,
    VersionId: undefined,
    DeleteMarkerVersionId: undefined
  };

  if (output["DeleteMarker"] !== undefined) {
    contents.DeleteMarker = output["DeleteMarker"] == "true";
  }

  if (output["Key"] !== undefined) {
    contents.Key = output["Key"];
  }

  if (output["VersionId"] !== undefined) {
    contents.VersionId = output["VersionId"];
  }

  if (output["DeleteMarkerVersionId"] !== undefined) {
    contents.DeleteMarkerVersionId = output["DeleteMarkerVersionId"];
  }

  return contents;
};

var deserializeAws_restXmlDeletedObjects = function deserializeAws_restXmlDeletedObjects(output, context) {
  return (output || []).map(function (entry) {
    return deserializeAws_restXmlDeletedObject(entry, context);
  });
};

var deserializeAws_restXmlDeleteMarkerEntry = function deserializeAws_restXmlDeleteMarkerEntry(output, context) {
  var contents = {
    VersionId: undefined,
    LastModified: undefined,
    Key: undefined,
    IsLatest: undefined,
    Owner: undefined
  };

  if (output["VersionId"] !== undefined) {
    contents.VersionId = output["VersionId"];
  }

  if (output["LastModified"] !== undefined) {
    contents.LastModified = new Date(output["LastModified"]);
  }

  if (output["Key"] !== undefined) {
    contents.Key = output["Key"];
  }

  if (output["IsLatest"] !== undefined) {
    contents.IsLatest = output["IsLatest"] == "true";
  }

  if (output["Owner"] !== undefined) {
    contents.Owner = deserializeAws_restXmlOwner(output["Owner"], context);
  }

  return contents;
};

var deserializeAws_restXmlDeleteMarkerReplication = function deserializeAws_restXmlDeleteMarkerReplication(output, context) {
  var contents = {
    Status: undefined
  };

  if (output["Status"] !== undefined) {
    contents.Status = output["Status"];
  }

  return contents;
};

var deserializeAws_restXmlDeleteMarkers = function deserializeAws_restXmlDeleteMarkers(output, context) {
  return (output || []).map(function (entry) {
    return deserializeAws_restXmlDeleteMarkerEntry(entry, context);
  });
};

var deserializeAws_restXmlDestination = function deserializeAws_restXmlDestination(output, context) {
  var contents = {
    EncryptionConfiguration: undefined,
    Bucket: undefined,
    Account: undefined,
    StorageClass: undefined,
    Metrics: undefined,
    AccessControlTranslation: undefined,
    ReplicationTime: undefined
  };

  if (output["EncryptionConfiguration"] !== undefined) {
    contents.EncryptionConfiguration = deserializeAws_restXmlEncryptionConfiguration(output["EncryptionConfiguration"], context);
  }

  if (output["Bucket"] !== undefined) {
    contents.Bucket = output["Bucket"];
  }

  if (output["Account"] !== undefined) {
    contents.Account = output["Account"];
  }

  if (output["StorageClass"] !== undefined) {
    contents.StorageClass = output["StorageClass"];
  }

  if (output["Metrics"] !== undefined) {
    contents.Metrics = deserializeAws_restXmlMetrics(output["Metrics"], context);
  }

  if (output["AccessControlTranslation"] !== undefined) {
    contents.AccessControlTranslation = deserializeAws_restXmlAccessControlTranslation(output["AccessControlTranslation"], context);
  }

  if (output["ReplicationTime"] !== undefined) {
    contents.ReplicationTime = deserializeAws_restXmlReplicationTime(output["ReplicationTime"], context);
  }

  return contents;
};

var deserializeAws_restXmlEncryptionConfiguration = function deserializeAws_restXmlEncryptionConfiguration(output, context) {
  var contents = {
    ReplicaKmsKeyID: undefined
  };

  if (output["ReplicaKmsKeyID"] !== undefined) {
    contents.ReplicaKmsKeyID = output["ReplicaKmsKeyID"];
  }

  return contents;
};

var deserializeAws_restXml_Error = function deserializeAws_restXml_Error(output, context) {
  var contents = {
    Message: undefined,
    Code: undefined,
    Key: undefined,
    VersionId: undefined
  };

  if (output["Message"] !== undefined) {
    contents.Message = output["Message"];
  }

  if (output["Code"] !== undefined) {
    contents.Code = output["Code"];
  }

  if (output["Key"] !== undefined) {
    contents.Key = output["Key"];
  }

  if (output["VersionId"] !== undefined) {
    contents.VersionId = output["VersionId"];
  }

  return contents;
};

var deserializeAws_restXmlErrorDocument = function deserializeAws_restXmlErrorDocument(output, context) {
  var contents = {
    Key: undefined
  };

  if (output["Key"] !== undefined) {
    contents.Key = output["Key"];
  }

  return contents;
};

var deserializeAws_restXmlErrors = function deserializeAws_restXmlErrors(output, context) {
  return (output || []).map(function (entry) {
    return deserializeAws_restXml_Error(entry, context);
  });
};

var deserializeAws_restXmlEventList = function deserializeAws_restXmlEventList(output, context) {
  return (output || []).map(function (entry) {
    return entry;
  });
};

var deserializeAws_restXmlExistingObjectReplication = function deserializeAws_restXmlExistingObjectReplication(output, context) {
  var contents = {
    Status: undefined
  };

  if (output["Status"] !== undefined) {
    contents.Status = output["Status"];
  }

  return contents;
};

var deserializeAws_restXmlExposeHeaders = function deserializeAws_restXmlExposeHeaders(output, context) {
  return (output || []).map(function (entry) {
    return entry;
  });
};

var deserializeAws_restXmlFilterRule = function deserializeAws_restXmlFilterRule(output, context) {
  var contents = {
    Name: undefined,
    Value: undefined
  };

  if (output["Name"] !== undefined) {
    contents.Name = output["Name"];
  }

  if (output["Value"] !== undefined) {
    contents.Value = output["Value"];
  }

  return contents;
};

var deserializeAws_restXmlFilterRuleList = function deserializeAws_restXmlFilterRuleList(output, context) {
  return (output || []).map(function (entry) {
    return deserializeAws_restXmlFilterRule(entry, context);
  });
};

var deserializeAws_restXmlGrant = function deserializeAws_restXmlGrant(output, context) {
  var contents = {
    Grantee: undefined,
    Permission: undefined
  };

  if (output["Grantee"] !== undefined) {
    contents.Grantee = deserializeAws_restXmlGrantee(output["Grantee"], context);
  }

  if (output["Permission"] !== undefined) {
    contents.Permission = output["Permission"];
  }

  return contents;
};

var deserializeAws_restXmlGrantee = function deserializeAws_restXmlGrantee(output, context) {
  var contents = {
    EmailAddress: undefined,
    DisplayName: undefined,
    URI: undefined,
    ID: undefined,
    Type: undefined
  };

  if (output["EmailAddress"] !== undefined) {
    contents.EmailAddress = output["EmailAddress"];
  }

  if (output["DisplayName"] !== undefined) {
    contents.DisplayName = output["DisplayName"];
  }

  if (output["URI"] !== undefined) {
    contents.URI = output["URI"];
  }

  if (output["ID"] !== undefined) {
    contents.ID = output["ID"];
  }

  if (output["xsi:type"] !== undefined) {
    contents.Type = output["xsi:type"];
  }

  return contents;
};

var deserializeAws_restXmlGrants = function deserializeAws_restXmlGrants(output, context) {
  return (output || []).map(function (entry) {
    return deserializeAws_restXmlGrant(entry, context);
  });
};

var deserializeAws_restXmlIndexDocument = function deserializeAws_restXmlIndexDocument(output, context) {
  var contents = {
    Suffix: undefined
  };

  if (output["Suffix"] !== undefined) {
    contents.Suffix = output["Suffix"];
  }

  return contents;
};

var deserializeAws_restXmlInitiator = function deserializeAws_restXmlInitiator(output, context) {
  var contents = {
    ID: undefined,
    DisplayName: undefined
  };

  if (output["ID"] !== undefined) {
    contents.ID = output["ID"];
  }

  if (output["DisplayName"] !== undefined) {
    contents.DisplayName = output["DisplayName"];
  }

  return contents;
};

var deserializeAws_restXmlInventoryConfiguration = function deserializeAws_restXmlInventoryConfiguration(output, context) {
  var contents = {
    IncludedObjectVersions: undefined,
    IsEnabled: undefined,
    Schedule: undefined,
    Filter: undefined,
    OptionalFields: undefined,
    Destination: undefined,
    Id: undefined
  };

  if (output["IncludedObjectVersions"] !== undefined) {
    contents.IncludedObjectVersions = output["IncludedObjectVersions"];
  }

  if (output["IsEnabled"] !== undefined) {
    contents.IsEnabled = output["IsEnabled"] == "true";
  }

  if (output["Schedule"] !== undefined) {
    contents.Schedule = deserializeAws_restXmlInventorySchedule(output["Schedule"], context);
  }

  if (output["Filter"] !== undefined) {
    contents.Filter = deserializeAws_restXmlInventoryFilter(output["Filter"], context);
  }

  if (output.OptionalFields === "") {
    contents.OptionalFields = [];
  }

  if (output["OptionalFields"] !== undefined && output["OptionalFields"]["Field"] !== undefined) {
    contents.OptionalFields = deserializeAws_restXmlInventoryOptionalFields(__getArrayIfSingleItem(output["OptionalFields"]["Field"]), context);
  }

  if (output["Destination"] !== undefined) {
    contents.Destination = deserializeAws_restXmlInventoryDestination(output["Destination"], context);
  }

  if (output["Id"] !== undefined) {
    contents.Id = output["Id"];
  }

  return contents;
};

var deserializeAws_restXmlInventoryConfigurationList = function deserializeAws_restXmlInventoryConfigurationList(output, context) {
  return (output || []).map(function (entry) {
    return deserializeAws_restXmlInventoryConfiguration(entry, context);
  });
};

var deserializeAws_restXmlInventoryDestination = function deserializeAws_restXmlInventoryDestination(output, context) {
  var contents = {
    S3BucketDestination: undefined
  };

  if (output["S3BucketDestination"] !== undefined) {
    contents.S3BucketDestination = deserializeAws_restXmlInventoryS3BucketDestination(output["S3BucketDestination"], context);
  }

  return contents;
};

var deserializeAws_restXmlInventoryEncryption = function deserializeAws_restXmlInventoryEncryption(output, context) {
  var contents = {
    SSEKMS: undefined,
    SSES3: undefined
  };

  if (output["SSE-KMS"] !== undefined) {
    contents.SSEKMS = deserializeAws_restXmlSSEKMS(output["SSE-KMS"], context);
  }

  if (output["SSE-S3"] !== undefined) {
    contents.SSES3 = deserializeAws_restXmlSSES3(output["SSE-S3"], context);
  }

  return contents;
};

var deserializeAws_restXmlInventoryFilter = function deserializeAws_restXmlInventoryFilter(output, context) {
  var contents = {
    Prefix: undefined
  };

  if (output["Prefix"] !== undefined) {
    contents.Prefix = output["Prefix"];
  }

  return contents;
};

var deserializeAws_restXmlInventoryOptionalFields = function deserializeAws_restXmlInventoryOptionalFields(output, context) {
  return (output || []).map(function (entry) {
    return entry;
  });
};

var deserializeAws_restXmlInventoryS3BucketDestination = function deserializeAws_restXmlInventoryS3BucketDestination(output, context) {
  var contents = {
    Format: undefined,
    Encryption: undefined,
    Prefix: undefined,
    Bucket: undefined,
    AccountId: undefined
  };

  if (output["Format"] !== undefined) {
    contents.Format = output["Format"];
  }

  if (output["Encryption"] !== undefined) {
    contents.Encryption = deserializeAws_restXmlInventoryEncryption(output["Encryption"], context);
  }

  if (output["Prefix"] !== undefined) {
    contents.Prefix = output["Prefix"];
  }

  if (output["Bucket"] !== undefined) {
    contents.Bucket = output["Bucket"];
  }

  if (output["AccountId"] !== undefined) {
    contents.AccountId = output["AccountId"];
  }

  return contents;
};

var deserializeAws_restXmlInventorySchedule = function deserializeAws_restXmlInventorySchedule(output, context) {
  var contents = {
    Frequency: undefined
  };

  if (output["Frequency"] !== undefined) {
    contents.Frequency = output["Frequency"];
  }

  return contents;
};

var deserializeAws_restXmlLambdaFunctionConfiguration = function deserializeAws_restXmlLambdaFunctionConfiguration(output, context) {
  var contents = {
    Events: undefined,
    Filter: undefined,
    LambdaFunctionArn: undefined,
    Id: undefined
  };

  if (output.Event === "") {
    contents.Events = [];
  }

  if (output["Event"] !== undefined) {
    contents.Events = deserializeAws_restXmlEventList(__getArrayIfSingleItem(output["Event"]), context);
  }

  if (output["Filter"] !== undefined) {
    contents.Filter = deserializeAws_restXmlNotificationConfigurationFilter(output["Filter"], context);
  }

  if (output["CloudFunction"] !== undefined) {
    contents.LambdaFunctionArn = output["CloudFunction"];
  }

  if (output["Id"] !== undefined) {
    contents.Id = output["Id"];
  }

  return contents;
};

var deserializeAws_restXmlLambdaFunctionConfigurationList = function deserializeAws_restXmlLambdaFunctionConfigurationList(output, context) {
  return (output || []).map(function (entry) {
    return deserializeAws_restXmlLambdaFunctionConfiguration(entry, context);
  });
};

var deserializeAws_restXmlLifecycleExpiration = function deserializeAws_restXmlLifecycleExpiration(output, context) {
  var contents = {
    Days: undefined,
    ExpiredObjectDeleteMarker: undefined,
    Date: undefined
  };

  if (output["Days"] !== undefined) {
    contents.Days = parseInt(output["Days"]);
  }

  if (output["ExpiredObjectDeleteMarker"] !== undefined) {
    contents.ExpiredObjectDeleteMarker = output["ExpiredObjectDeleteMarker"] == "true";
  }

  if (output["Date"] !== undefined) {
    contents.Date = new Date(output["Date"]);
  }

  return contents;
};

var deserializeAws_restXmlLifecycleRule = function deserializeAws_restXmlLifecycleRule(output, context) {
  var contents = {
    NoncurrentVersionTransitions: undefined,
    Expiration: undefined,
    ID: undefined,
    Transitions: undefined,
    Prefix: undefined,
    NoncurrentVersionExpiration: undefined,
    AbortIncompleteMultipartUpload: undefined,
    Filter: undefined,
    Status: undefined
  };

  if (output.NoncurrentVersionTransition === "") {
    contents.NoncurrentVersionTransitions = [];
  }

  if (output["NoncurrentVersionTransition"] !== undefined) {
    contents.NoncurrentVersionTransitions = deserializeAws_restXmlNoncurrentVersionTransitionList(__getArrayIfSingleItem(output["NoncurrentVersionTransition"]), context);
  }

  if (output["Expiration"] !== undefined) {
    contents.Expiration = deserializeAws_restXmlLifecycleExpiration(output["Expiration"], context);
  }

  if (output["ID"] !== undefined) {
    contents.ID = output["ID"];
  }

  if (output.Transition === "") {
    contents.Transitions = [];
  }

  if (output["Transition"] !== undefined) {
    contents.Transitions = deserializeAws_restXmlTransitionList(__getArrayIfSingleItem(output["Transition"]), context);
  }

  if (output["Prefix"] !== undefined) {
    contents.Prefix = output["Prefix"];
  }

  if (output["NoncurrentVersionExpiration"] !== undefined) {
    contents.NoncurrentVersionExpiration = deserializeAws_restXmlNoncurrentVersionExpiration(output["NoncurrentVersionExpiration"], context);
  }

  if (output["AbortIncompleteMultipartUpload"] !== undefined) {
    contents.AbortIncompleteMultipartUpload = deserializeAws_restXmlAbortIncompleteMultipartUpload(output["AbortIncompleteMultipartUpload"], context);
  }

  if (output["Filter"] !== undefined) {
    contents.Filter = deserializeAws_restXmlLifecycleRuleFilter(output["Filter"], context);
  }

  if (output["Status"] !== undefined) {
    contents.Status = output["Status"];
  }

  return contents;
};

var deserializeAws_restXmlLifecycleRuleAndOperator = function deserializeAws_restXmlLifecycleRuleAndOperator(output, context) {
  var contents = {
    Prefix: undefined,
    Tags: undefined
  };

  if (output["Prefix"] !== undefined) {
    contents.Prefix = output["Prefix"];
  }

  if (output.Tag === "") {
    contents.Tags = [];
  }

  if (output["Tag"] !== undefined) {
    contents.Tags = deserializeAws_restXmlTagSet(__getArrayIfSingleItem(output["Tag"]), context);
  }

  return contents;
};

var deserializeAws_restXmlLifecycleRuleFilter = function deserializeAws_restXmlLifecycleRuleFilter(output, context) {
  var contents = {
    And: undefined,
    Prefix: undefined,
    Tag: undefined
  };

  if (output["And"] !== undefined) {
    contents.And = deserializeAws_restXmlLifecycleRuleAndOperator(output["And"], context);
  }

  if (output["Prefix"] !== undefined) {
    contents.Prefix = output["Prefix"];
  }

  if (output["Tag"] !== undefined) {
    contents.Tag = deserializeAws_restXmlTag(output["Tag"], context);
  }

  return contents;
};

var deserializeAws_restXmlLifecycleRules = function deserializeAws_restXmlLifecycleRules(output, context) {
  return (output || []).map(function (entry) {
    return deserializeAws_restXmlLifecycleRule(entry, context);
  });
};

var deserializeAws_restXmlLoggingEnabled = function deserializeAws_restXmlLoggingEnabled(output, context) {
  var contents = {
    TargetGrants: undefined,
    TargetBucket: undefined,
    TargetPrefix: undefined
  };

  if (output.TargetGrants === "") {
    contents.TargetGrants = [];
  }

  if (output["TargetGrants"] !== undefined && output["TargetGrants"]["Grant"] !== undefined) {
    contents.TargetGrants = deserializeAws_restXmlTargetGrants(__getArrayIfSingleItem(output["TargetGrants"]["Grant"]), context);
  }

  if (output["TargetBucket"] !== undefined) {
    contents.TargetBucket = output["TargetBucket"];
  }

  if (output["TargetPrefix"] !== undefined) {
    contents.TargetPrefix = output["TargetPrefix"];
  }

  return contents;
};

var deserializeAws_restXmlMetrics = function deserializeAws_restXmlMetrics(output, context) {
  var contents = {
    Status: undefined,
    EventThreshold: undefined
  };

  if (output["Status"] !== undefined) {
    contents.Status = output["Status"];
  }

  if (output["EventThreshold"] !== undefined) {
    contents.EventThreshold = deserializeAws_restXmlReplicationTimeValue(output["EventThreshold"], context);
  }

  return contents;
};

var deserializeAws_restXmlMetricsAndOperator = function deserializeAws_restXmlMetricsAndOperator(output, context) {
  var contents = {
    Prefix: undefined,
    Tags: undefined
  };

  if (output["Prefix"] !== undefined) {
    contents.Prefix = output["Prefix"];
  }

  if (output.Tag === "") {
    contents.Tags = [];
  }

  if (output["Tag"] !== undefined) {
    contents.Tags = deserializeAws_restXmlTagSet(__getArrayIfSingleItem(output["Tag"]), context);
  }

  return contents;
};

var deserializeAws_restXmlMetricsConfiguration = function deserializeAws_restXmlMetricsConfiguration(output, context) {
  var contents = {
    Id: undefined,
    Filter: undefined
  };

  if (output["Id"] !== undefined) {
    contents.Id = output["Id"];
  }

  if (output["Filter"] !== undefined) {
    contents.Filter = deserializeAws_restXmlMetricsFilter(output["Filter"], context);
  }

  return contents;
};

var deserializeAws_restXmlMetricsConfigurationList = function deserializeAws_restXmlMetricsConfigurationList(output, context) {
  return (output || []).map(function (entry) {
    return deserializeAws_restXmlMetricsConfiguration(entry, context);
  });
};

var deserializeAws_restXmlMetricsFilter = function deserializeAws_restXmlMetricsFilter(output, context) {
  var contents = {
    And: undefined,
    Prefix: undefined,
    Tag: undefined
  };

  if (output["And"] !== undefined) {
    contents.And = deserializeAws_restXmlMetricsAndOperator(output["And"], context);
  }

  if (output["Prefix"] !== undefined) {
    contents.Prefix = output["Prefix"];
  }

  if (output["Tag"] !== undefined) {
    contents.Tag = deserializeAws_restXmlTag(output["Tag"], context);
  }

  return contents;
};

var deserializeAws_restXmlMultipartUpload = function deserializeAws_restXmlMultipartUpload(output, context) {
  var contents = {
    Initiator: undefined,
    UploadId: undefined,
    Key: undefined,
    Owner: undefined,
    StorageClass: undefined,
    Initiated: undefined
  };

  if (output["Initiator"] !== undefined) {
    contents.Initiator = deserializeAws_restXmlInitiator(output["Initiator"], context);
  }

  if (output["UploadId"] !== undefined) {
    contents.UploadId = output["UploadId"];
  }

  if (output["Key"] !== undefined) {
    contents.Key = output["Key"];
  }

  if (output["Owner"] !== undefined) {
    contents.Owner = deserializeAws_restXmlOwner(output["Owner"], context);
  }

  if (output["StorageClass"] !== undefined) {
    contents.StorageClass = output["StorageClass"];
  }

  if (output["Initiated"] !== undefined) {
    contents.Initiated = new Date(output["Initiated"]);
  }

  return contents;
};

var deserializeAws_restXmlMultipartUploadList = function deserializeAws_restXmlMultipartUploadList(output, context) {
  return (output || []).map(function (entry) {
    return deserializeAws_restXmlMultipartUpload(entry, context);
  });
};

var deserializeAws_restXmlNoncurrentVersionExpiration = function deserializeAws_restXmlNoncurrentVersionExpiration(output, context) {
  var contents = {
    NoncurrentDays: undefined
  };

  if (output["NoncurrentDays"] !== undefined) {
    contents.NoncurrentDays = parseInt(output["NoncurrentDays"]);
  }

  return contents;
};

var deserializeAws_restXmlNoncurrentVersionTransition = function deserializeAws_restXmlNoncurrentVersionTransition(output, context) {
  var contents = {
    StorageClass: undefined,
    NoncurrentDays: undefined
  };

  if (output["StorageClass"] !== undefined) {
    contents.StorageClass = output["StorageClass"];
  }

  if (output["NoncurrentDays"] !== undefined) {
    contents.NoncurrentDays = parseInt(output["NoncurrentDays"]);
  }

  return contents;
};

var deserializeAws_restXmlNoncurrentVersionTransitionList = function deserializeAws_restXmlNoncurrentVersionTransitionList(output, context) {
  return (output || []).map(function (entry) {
    return deserializeAws_restXmlNoncurrentVersionTransition(entry, context);
  });
};

var deserializeAws_restXmlNotificationConfigurationFilter = function deserializeAws_restXmlNotificationConfigurationFilter(output, context) {
  var contents = {
    Key: undefined
  };

  if (output["S3Key"] !== undefined) {
    contents.Key = deserializeAws_restXmlS3KeyFilter(output["S3Key"], context);
  }

  return contents;
};

var deserializeAws_restXml_Object = function deserializeAws_restXml_Object(output, context) {
  var contents = {
    Size: undefined,
    ETag: undefined,
    Owner: undefined,
    StorageClass: undefined,
    Key: undefined,
    LastModified: undefined
  };

  if (output["Size"] !== undefined) {
    contents.Size = parseInt(output["Size"]);
  }

  if (output["ETag"] !== undefined) {
    contents.ETag = output["ETag"];
  }

  if (output["Owner"] !== undefined) {
    contents.Owner = deserializeAws_restXmlOwner(output["Owner"], context);
  }

  if (output["StorageClass"] !== undefined) {
    contents.StorageClass = output["StorageClass"];
  }

  if (output["Key"] !== undefined) {
    contents.Key = output["Key"];
  }

  if (output["LastModified"] !== undefined) {
    contents.LastModified = new Date(output["LastModified"]);
  }

  return contents;
};

var deserializeAws_restXmlObjectList = function deserializeAws_restXmlObjectList(output, context) {
  return (output || []).map(function (entry) {
    return deserializeAws_restXml_Object(entry, context);
  });
};

var deserializeAws_restXmlObjectLockConfiguration = function deserializeAws_restXmlObjectLockConfiguration(output, context) {
  var contents = {
    ObjectLockEnabled: undefined,
    Rule: undefined
  };

  if (output["ObjectLockEnabled"] !== undefined) {
    contents.ObjectLockEnabled = output["ObjectLockEnabled"];
  }

  if (output["Rule"] !== undefined) {
    contents.Rule = deserializeAws_restXmlObjectLockRule(output["Rule"], context);
  }

  return contents;
};

var deserializeAws_restXmlObjectLockLegalHold = function deserializeAws_restXmlObjectLockLegalHold(output, context) {
  var contents = {
    Status: undefined
  };

  if (output["Status"] !== undefined) {
    contents.Status = output["Status"];
  }

  return contents;
};

var deserializeAws_restXmlObjectLockRetention = function deserializeAws_restXmlObjectLockRetention(output, context) {
  var contents = {
    Mode: undefined,
    RetainUntilDate: undefined
  };

  if (output["Mode"] !== undefined) {
    contents.Mode = output["Mode"];
  }

  if (output["RetainUntilDate"] !== undefined) {
    contents.RetainUntilDate = new Date(output["RetainUntilDate"]);
  }

  return contents;
};

var deserializeAws_restXmlObjectLockRule = function deserializeAws_restXmlObjectLockRule(output, context) {
  var contents = {
    DefaultRetention: undefined
  };

  if (output["DefaultRetention"] !== undefined) {
    contents.DefaultRetention = deserializeAws_restXmlDefaultRetention(output["DefaultRetention"], context);
  }

  return contents;
};

var deserializeAws_restXmlObjectVersion = function deserializeAws_restXmlObjectVersion(output, context) {
  var contents = {
    Size: undefined,
    Key: undefined,
    StorageClass: undefined,
    Owner: undefined,
    IsLatest: undefined,
    ETag: undefined,
    LastModified: undefined,
    VersionId: undefined
  };

  if (output["Size"] !== undefined) {
    contents.Size = parseInt(output["Size"]);
  }

  if (output["Key"] !== undefined) {
    contents.Key = output["Key"];
  }

  if (output["StorageClass"] !== undefined) {
    contents.StorageClass = output["StorageClass"];
  }

  if (output["Owner"] !== undefined) {
    contents.Owner = deserializeAws_restXmlOwner(output["Owner"], context);
  }

  if (output["IsLatest"] !== undefined) {
    contents.IsLatest = output["IsLatest"] == "true";
  }

  if (output["ETag"] !== undefined) {
    contents.ETag = output["ETag"];
  }

  if (output["LastModified"] !== undefined) {
    contents.LastModified = new Date(output["LastModified"]);
  }

  if (output["VersionId"] !== undefined) {
    contents.VersionId = output["VersionId"];
  }

  return contents;
};

var deserializeAws_restXmlObjectVersionList = function deserializeAws_restXmlObjectVersionList(output, context) {
  return (output || []).map(function (entry) {
    return deserializeAws_restXmlObjectVersion(entry, context);
  });
};

var deserializeAws_restXmlOwner = function deserializeAws_restXmlOwner(output, context) {
  var contents = {
    DisplayName: undefined,
    ID: undefined
  };

  if (output["DisplayName"] !== undefined) {
    contents.DisplayName = output["DisplayName"];
  }

  if (output["ID"] !== undefined) {
    contents.ID = output["ID"];
  }

  return contents;
};

var deserializeAws_restXmlOwnershipControls = function deserializeAws_restXmlOwnershipControls(output, context) {
  var contents = {
    Rules: undefined
  };

  if (output.Rule === "") {
    contents.Rules = [];
  }

  if (output["Rule"] !== undefined) {
    contents.Rules = deserializeAws_restXmlOwnershipControlsRules(__getArrayIfSingleItem(output["Rule"]), context);
  }

  return contents;
};

var deserializeAws_restXmlOwnershipControlsRule = function deserializeAws_restXmlOwnershipControlsRule(output, context) {
  var contents = {
    ObjectOwnership: undefined
  };

  if (output["ObjectOwnership"] !== undefined) {
    contents.ObjectOwnership = output["ObjectOwnership"];
  }

  return contents;
};

var deserializeAws_restXmlOwnershipControlsRules = function deserializeAws_restXmlOwnershipControlsRules(output, context) {
  return (output || []).map(function (entry) {
    return deserializeAws_restXmlOwnershipControlsRule(entry, context);
  });
};

var deserializeAws_restXmlPart = function deserializeAws_restXmlPart(output, context) {
  var contents = {
    Size: undefined,
    LastModified: undefined,
    PartNumber: undefined,
    ETag: undefined
  };

  if (output["Size"] !== undefined) {
    contents.Size = parseInt(output["Size"]);
  }

  if (output["LastModified"] !== undefined) {
    contents.LastModified = new Date(output["LastModified"]);
  }

  if (output["PartNumber"] !== undefined) {
    contents.PartNumber = parseInt(output["PartNumber"]);
  }

  if (output["ETag"] !== undefined) {
    contents.ETag = output["ETag"];
  }

  return contents;
};

var deserializeAws_restXmlParts = function deserializeAws_restXmlParts(output, context) {
  return (output || []).map(function (entry) {
    return deserializeAws_restXmlPart(entry, context);
  });
};

var deserializeAws_restXmlPolicyStatus = function deserializeAws_restXmlPolicyStatus(output, context) {
  var contents = {
    IsPublic: undefined
  };

  if (output["IsPublic"] !== undefined) {
    contents.IsPublic = output["IsPublic"] == "true";
  }

  return contents;
};

var deserializeAws_restXmlPublicAccessBlockConfiguration = function deserializeAws_restXmlPublicAccessBlockConfiguration(output, context) {
  var contents = {
    BlockPublicPolicy: undefined,
    BlockPublicAcls: undefined,
    RestrictPublicBuckets: undefined,
    IgnorePublicAcls: undefined
  };

  if (output["BlockPublicPolicy"] !== undefined) {
    contents.BlockPublicPolicy = output["BlockPublicPolicy"] == "true";
  }

  if (output["BlockPublicAcls"] !== undefined) {
    contents.BlockPublicAcls = output["BlockPublicAcls"] == "true";
  }

  if (output["RestrictPublicBuckets"] !== undefined) {
    contents.RestrictPublicBuckets = output["RestrictPublicBuckets"] == "true";
  }

  if (output["IgnorePublicAcls"] !== undefined) {
    contents.IgnorePublicAcls = output["IgnorePublicAcls"] == "true";
  }

  return contents;
};

var deserializeAws_restXmlQueueConfiguration = function deserializeAws_restXmlQueueConfiguration(output, context) {
  var contents = {
    Events: undefined,
    Id: undefined,
    Filter: undefined,
    QueueArn: undefined
  };

  if (output.Event === "") {
    contents.Events = [];
  }

  if (output["Event"] !== undefined) {
    contents.Events = deserializeAws_restXmlEventList(__getArrayIfSingleItem(output["Event"]), context);
  }

  if (output["Id"] !== undefined) {
    contents.Id = output["Id"];
  }

  if (output["Filter"] !== undefined) {
    contents.Filter = deserializeAws_restXmlNotificationConfigurationFilter(output["Filter"], context);
  }

  if (output["Queue"] !== undefined) {
    contents.QueueArn = output["Queue"];
  }

  return contents;
};

var deserializeAws_restXmlQueueConfigurationList = function deserializeAws_restXmlQueueConfigurationList(output, context) {
  return (output || []).map(function (entry) {
    return deserializeAws_restXmlQueueConfiguration(entry, context);
  });
};

var deserializeAws_restXmlRedirect = function deserializeAws_restXmlRedirect(output, context) {
  var contents = {
    HttpRedirectCode: undefined,
    ReplaceKeyPrefixWith: undefined,
    Protocol: undefined,
    HostName: undefined,
    ReplaceKeyWith: undefined
  };

  if (output["HttpRedirectCode"] !== undefined) {
    contents.HttpRedirectCode = output["HttpRedirectCode"];
  }

  if (output["ReplaceKeyPrefixWith"] !== undefined) {
    contents.ReplaceKeyPrefixWith = output["ReplaceKeyPrefixWith"];
  }

  if (output["Protocol"] !== undefined) {
    contents.Protocol = output["Protocol"];
  }

  if (output["HostName"] !== undefined) {
    contents.HostName = output["HostName"];
  }

  if (output["ReplaceKeyWith"] !== undefined) {
    contents.ReplaceKeyWith = output["ReplaceKeyWith"];
  }

  return contents;
};

var deserializeAws_restXmlRedirectAllRequestsTo = function deserializeAws_restXmlRedirectAllRequestsTo(output, context) {
  var contents = {
    Protocol: undefined,
    HostName: undefined
  };

  if (output["Protocol"] !== undefined) {
    contents.Protocol = output["Protocol"];
  }

  if (output["HostName"] !== undefined) {
    contents.HostName = output["HostName"];
  }

  return contents;
};

var deserializeAws_restXmlReplicationConfiguration = function deserializeAws_restXmlReplicationConfiguration(output, context) {
  var contents = {
    Role: undefined,
    Rules: undefined
  };

  if (output["Role"] !== undefined) {
    contents.Role = output["Role"];
  }

  if (output.Rule === "") {
    contents.Rules = [];
  }

  if (output["Rule"] !== undefined) {
    contents.Rules = deserializeAws_restXmlReplicationRules(__getArrayIfSingleItem(output["Rule"]), context);
  }

  return contents;
};

var deserializeAws_restXmlReplicationRule = function deserializeAws_restXmlReplicationRule(output, context) {
  var contents = {
    Prefix: undefined,
    ID: undefined,
    SourceSelectionCriteria: undefined,
    DeleteMarkerReplication: undefined,
    Filter: undefined,
    Priority: undefined,
    Status: undefined,
    ExistingObjectReplication: undefined,
    Destination: undefined
  };

  if (output["Prefix"] !== undefined) {
    contents.Prefix = output["Prefix"];
  }

  if (output["ID"] !== undefined) {
    contents.ID = output["ID"];
  }

  if (output["SourceSelectionCriteria"] !== undefined) {
    contents.SourceSelectionCriteria = deserializeAws_restXmlSourceSelectionCriteria(output["SourceSelectionCriteria"], context);
  }

  if (output["DeleteMarkerReplication"] !== undefined) {
    contents.DeleteMarkerReplication = deserializeAws_restXmlDeleteMarkerReplication(output["DeleteMarkerReplication"], context);
  }

  if (output["Filter"] !== undefined) {
    contents.Filter = deserializeAws_restXmlReplicationRuleFilter(output["Filter"], context);
  }

  if (output["Priority"] !== undefined) {
    contents.Priority = parseInt(output["Priority"]);
  }

  if (output["Status"] !== undefined) {
    contents.Status = output["Status"];
  }

  if (output["ExistingObjectReplication"] !== undefined) {
    contents.ExistingObjectReplication = deserializeAws_restXmlExistingObjectReplication(output["ExistingObjectReplication"], context);
  }

  if (output["Destination"] !== undefined) {
    contents.Destination = deserializeAws_restXmlDestination(output["Destination"], context);
  }

  return contents;
};

var deserializeAws_restXmlReplicationRuleAndOperator = function deserializeAws_restXmlReplicationRuleAndOperator(output, context) {
  var contents = {
    Prefix: undefined,
    Tags: undefined
  };

  if (output["Prefix"] !== undefined) {
    contents.Prefix = output["Prefix"];
  }

  if (output.Tag === "") {
    contents.Tags = [];
  }

  if (output["Tag"] !== undefined) {
    contents.Tags = deserializeAws_restXmlTagSet(__getArrayIfSingleItem(output["Tag"]), context);
  }

  return contents;
};

var deserializeAws_restXmlReplicationRuleFilter = function deserializeAws_restXmlReplicationRuleFilter(output, context) {
  var contents = {
    Tag: undefined,
    Prefix: undefined,
    And: undefined
  };

  if (output["Tag"] !== undefined) {
    contents.Tag = deserializeAws_restXmlTag(output["Tag"], context);
  }

  if (output["Prefix"] !== undefined) {
    contents.Prefix = output["Prefix"];
  }

  if (output["And"] !== undefined) {
    contents.And = deserializeAws_restXmlReplicationRuleAndOperator(output["And"], context);
  }

  return contents;
};

var deserializeAws_restXmlReplicationRules = function deserializeAws_restXmlReplicationRules(output, context) {
  return (output || []).map(function (entry) {
    return deserializeAws_restXmlReplicationRule(entry, context);
  });
};

var deserializeAws_restXmlReplicationTime = function deserializeAws_restXmlReplicationTime(output, context) {
  var contents = {
    Time: undefined,
    Status: undefined
  };

  if (output["Time"] !== undefined) {
    contents.Time = deserializeAws_restXmlReplicationTimeValue(output["Time"], context);
  }

  if (output["Status"] !== undefined) {
    contents.Status = output["Status"];
  }

  return contents;
};

var deserializeAws_restXmlReplicationTimeValue = function deserializeAws_restXmlReplicationTimeValue(output, context) {
  var contents = {
    Minutes: undefined
  };

  if (output["Minutes"] !== undefined) {
    contents.Minutes = parseInt(output["Minutes"]);
  }

  return contents;
};

var deserializeAws_restXmlRoutingRule = function deserializeAws_restXmlRoutingRule(output, context) {
  var contents = {
    Redirect: undefined,
    Condition: undefined
  };

  if (output["Redirect"] !== undefined) {
    contents.Redirect = deserializeAws_restXmlRedirect(output["Redirect"], context);
  }

  if (output["Condition"] !== undefined) {
    contents.Condition = deserializeAws_restXmlCondition(output["Condition"], context);
  }

  return contents;
};

var deserializeAws_restXmlRoutingRules = function deserializeAws_restXmlRoutingRules(output, context) {
  return (output || []).map(function (entry) {
    return deserializeAws_restXmlRoutingRule(entry, context);
  });
};

var deserializeAws_restXmlS3KeyFilter = function deserializeAws_restXmlS3KeyFilter(output, context) {
  var contents = {
    FilterRules: undefined
  };

  if (output.FilterRule === "") {
    contents.FilterRules = [];
  }

  if (output["FilterRule"] !== undefined) {
    contents.FilterRules = deserializeAws_restXmlFilterRuleList(__getArrayIfSingleItem(output["FilterRule"]), context);
  }

  return contents;
};

var deserializeAws_restXmlServerSideEncryptionByDefault = function deserializeAws_restXmlServerSideEncryptionByDefault(output, context) {
  var contents = {
    SSEAlgorithm: undefined,
    KMSMasterKeyID: undefined
  };

  if (output["SSEAlgorithm"] !== undefined) {
    contents.SSEAlgorithm = output["SSEAlgorithm"];
  }

  if (output["KMSMasterKeyID"] !== undefined) {
    contents.KMSMasterKeyID = output["KMSMasterKeyID"];
  }

  return contents;
};

var deserializeAws_restXmlServerSideEncryptionConfiguration = function deserializeAws_restXmlServerSideEncryptionConfiguration(output, context) {
  var contents = {
    Rules: undefined
  };

  if (output.Rule === "") {
    contents.Rules = [];
  }

  if (output["Rule"] !== undefined) {
    contents.Rules = deserializeAws_restXmlServerSideEncryptionRules(__getArrayIfSingleItem(output["Rule"]), context);
  }

  return contents;
};

var deserializeAws_restXmlServerSideEncryptionRule = function deserializeAws_restXmlServerSideEncryptionRule(output, context) {
  var contents = {
    ApplyServerSideEncryptionByDefault: undefined
  };

  if (output["ApplyServerSideEncryptionByDefault"] !== undefined) {
    contents.ApplyServerSideEncryptionByDefault = deserializeAws_restXmlServerSideEncryptionByDefault(output["ApplyServerSideEncryptionByDefault"], context);
  }

  return contents;
};

var deserializeAws_restXmlServerSideEncryptionRules = function deserializeAws_restXmlServerSideEncryptionRules(output, context) {
  return (output || []).map(function (entry) {
    return deserializeAws_restXmlServerSideEncryptionRule(entry, context);
  });
};

var deserializeAws_restXmlSourceSelectionCriteria = function deserializeAws_restXmlSourceSelectionCriteria(output, context) {
  var contents = {
    SseKmsEncryptedObjects: undefined
  };

  if (output["SseKmsEncryptedObjects"] !== undefined) {
    contents.SseKmsEncryptedObjects = deserializeAws_restXmlSseKmsEncryptedObjects(output["SseKmsEncryptedObjects"], context);
  }

  return contents;
};

var deserializeAws_restXmlSSEKMS = function deserializeAws_restXmlSSEKMS(output, context) {
  var contents = {
    KeyId: undefined
  };

  if (output["KeyId"] !== undefined) {
    contents.KeyId = output["KeyId"];
  }

  return contents;
};

var deserializeAws_restXmlSseKmsEncryptedObjects = function deserializeAws_restXmlSseKmsEncryptedObjects(output, context) {
  var contents = {
    Status: undefined
  };

  if (output["Status"] !== undefined) {
    contents.Status = output["Status"];
  }

  return contents;
};

var deserializeAws_restXmlSSES3 = function deserializeAws_restXmlSSES3(output, context) {
  var contents = {};
  return contents;
};

var deserializeAws_restXmlStorageClassAnalysis = function deserializeAws_restXmlStorageClassAnalysis(output, context) {
  var contents = {
    DataExport: undefined
  };

  if (output["DataExport"] !== undefined) {
    contents.DataExport = deserializeAws_restXmlStorageClassAnalysisDataExport(output["DataExport"], context);
  }

  return contents;
};

var deserializeAws_restXmlStorageClassAnalysisDataExport = function deserializeAws_restXmlStorageClassAnalysisDataExport(output, context) {
  var contents = {
    OutputSchemaVersion: undefined,
    Destination: undefined
  };

  if (output["OutputSchemaVersion"] !== undefined) {
    contents.OutputSchemaVersion = output["OutputSchemaVersion"];
  }

  if (output["Destination"] !== undefined) {
    contents.Destination = deserializeAws_restXmlAnalyticsExportDestination(output["Destination"], context);
  }

  return contents;
};

var deserializeAws_restXmlTag = function deserializeAws_restXmlTag(output, context) {
  var contents = {
    Value: undefined,
    Key: undefined
  };

  if (output["Value"] !== undefined) {
    contents.Value = output["Value"];
  }

  if (output["Key"] !== undefined) {
    contents.Key = output["Key"];
  }

  return contents;
};

var deserializeAws_restXmlTagSet = function deserializeAws_restXmlTagSet(output, context) {
  return (output || []).map(function (entry) {
    return deserializeAws_restXmlTag(entry, context);
  });
};

var deserializeAws_restXmlTargetGrant = function deserializeAws_restXmlTargetGrant(output, context) {
  var contents = {
    Grantee: undefined,
    Permission: undefined
  };

  if (output["Grantee"] !== undefined) {
    contents.Grantee = deserializeAws_restXmlGrantee(output["Grantee"], context);
  }

  if (output["Permission"] !== undefined) {
    contents.Permission = output["Permission"];
  }

  return contents;
};

var deserializeAws_restXmlTargetGrants = function deserializeAws_restXmlTargetGrants(output, context) {
  return (output || []).map(function (entry) {
    return deserializeAws_restXmlTargetGrant(entry, context);
  });
};

var deserializeAws_restXmlTopicConfiguration = function deserializeAws_restXmlTopicConfiguration(output, context) {
  var contents = {
    Events: undefined,
    Filter: undefined,
    TopicArn: undefined,
    Id: undefined
  };

  if (output.Event === "") {
    contents.Events = [];
  }

  if (output["Event"] !== undefined) {
    contents.Events = deserializeAws_restXmlEventList(__getArrayIfSingleItem(output["Event"]), context);
  }

  if (output["Filter"] !== undefined) {
    contents.Filter = deserializeAws_restXmlNotificationConfigurationFilter(output["Filter"], context);
  }

  if (output["Topic"] !== undefined) {
    contents.TopicArn = output["Topic"];
  }

  if (output["Id"] !== undefined) {
    contents.Id = output["Id"];
  }

  return contents;
};

var deserializeAws_restXmlTopicConfigurationList = function deserializeAws_restXmlTopicConfigurationList(output, context) {
  return (output || []).map(function (entry) {
    return deserializeAws_restXmlTopicConfiguration(entry, context);
  });
};

var deserializeAws_restXmlTransition = function deserializeAws_restXmlTransition(output, context) {
  var contents = {
    Days: undefined,
    Date: undefined,
    StorageClass: undefined
  };

  if (output["Days"] !== undefined) {
    contents.Days = parseInt(output["Days"]);
  }

  if (output["Date"] !== undefined) {
    contents.Date = new Date(output["Date"]);
  }

  if (output["StorageClass"] !== undefined) {
    contents.StorageClass = output["StorageClass"];
  }

  return contents;
};

var deserializeAws_restXmlTransitionList = function deserializeAws_restXmlTransitionList(output, context) {
  return (output || []).map(function (entry) {
    return deserializeAws_restXmlTransition(entry, context);
  });
};

var deserializeMetadata = function deserializeMetadata(output) {
  return {
    httpStatusCode: output.statusCode,
    httpHeaders: output.headers,
    requestId: output.headers["x-amzn-requestid"]
  };
}; // Collect low-level response body stream to Uint8Array.


var collectBody = function collectBody(streamBody, context) {
  if (streamBody === void 0) {
    streamBody = new Uint8Array();
  }

  if (streamBody instanceof Uint8Array) {
    return Promise.resolve(streamBody);
  }

  return context.streamCollector(streamBody) || Promise.resolve(new Uint8Array());
}; // Encode Uint8Array data into string with utf-8.


var collectBodyString = function collectBodyString(streamBody, context) {
  return collectBody(streamBody, context).then(function (body) {
    return context.utf8Encoder(body);
  });
};

var isSerializableHeaderValue = function isSerializableHeaderValue(value) {
  return value !== undefined && value !== "" && (!Object.getOwnPropertyNames(value).includes("length") || value.length != 0) && (!Object.getOwnPropertyNames(value).includes("size") || value.size != 0);
};

var decodeEscapedXML = function decodeEscapedXML(str) {
  return str.replace(/&amp;/g, "&").replace(/&apos;/g, "'").replace(/&quot;/g, '"').replace(/&gt;/g, ">").replace(/&lt;/g, "<");
};

var parseBody = function parseBody(streamBody, context) {
  return collectBodyString(streamBody, context).then(function (encoded) {
    if (encoded.length) {
      var parsedObj = xmlParse(encoded, {
        attributeNamePrefix: "",
        ignoreAttributes: false,
        parseNodeValue: false,
        tagValueProcessor: function tagValueProcessor(val, tagName) {
          return decodeEscapedXML(val);
        }
      });
      var textNodeName = "#text";
      var key = Object.keys(parsedObj)[0];
      var parsedObjToReturn = parsedObj[key];

      if (parsedObjToReturn[textNodeName]) {
        parsedObjToReturn[key] = parsedObjToReturn[textNodeName];
        delete parsedObjToReturn[textNodeName];
      }

      return __getValueFromTextNode(parsedObjToReturn);
    }

    return {};
  });
};

var loadRestXmlErrorCode = function loadRestXmlErrorCode(output, data) {
  if (data.Code !== undefined) {
    return data.Code;
  }

  if (output.statusCode == 404) {
    return "NotFound";
  }

  return "";
};